var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBkgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: "297mm",
    height: "210mm",
    viewBox: "0 0 297 210",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 3559.8,
    x2: 1126.7,
    y1: 4036,
    y2: 1014.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "#B37CFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop3",
    stopColor: "#F895E7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082341467367301374580000012278336009540478380_",
    x1: 6416.6,
    x2: 7462.3,
    y1: 542.02,
    y2: 542.02,
    gradientTransform: "matrix(.9241 .3823 -.3823 .9241 -5471.5 -1929.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop4",
    stopColor: "#A737D5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop5",
    stopColor: "#EF497A",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123417293118030957290000008448576168209327256_",
    x1: -835.22,
    x2: 167.59,
    y1: 3829.3,
    y2: 3829.3,
    gradientTransform: "matrix(.6312 -.7758 .7758 .6312 -1946.3 -1491.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop6",
    stopColor: "#CE1567",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop7",
    stopColor: "#7A1DBC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098909845763051153590000014870951605869837757_",
    x1: 1951.7,
    x2: 1915.6,
    y1: 3319.1,
    y2: 2604.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop9",
    stopColor: "#2B3582",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop10",
    stopColor: "#150E42",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119828917555509783370000015597325786279213757_",
    x1: 482.63,
    x2: 3257.2,
    y1: 1841.6,
    y2: 1841.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop11",
    stopColor: "#2B3582",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop12",
    stopColor: "#150E42",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093173410323720510400000007903223900152542382_",
    x1: 2332.8,
    x2: -8.5249,
    y1: 1241.1,
    y2: 3923.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop13",
    stopColor: "#FDF53F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop14",
    stopColor: "#D93C65",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150797358783885708480000012842919997571784586_",
    x1: 1954,
    x2: 1622.1,
    y1: 3049.6,
    y2: 3778.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop15",
    stopColor: "#2B3582",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop16",
    stopColor: "#150E42",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012433440356731570030000006688954660694553016_",
    x1: 2475.4,
    x2: 1381,
    y1: 1507.5,
    y2: 3202.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop26",
    stopColor: "#CB236D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop27",
    stopColor: "#4C246D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121255058289730104800000012049694533815015326_",
    x1: 2865,
    x2: 3110.4,
    y1: 2554.3,
    y2: 1957.9,
    gradientTransform: "matrix(.9998 -.0189 .0189 .9998 -59.548 19.477)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop29",
    stopColor: "#2B3582",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop30",
    stopColor: "#150E42",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145767868375547687400000015347788309441258117_",
    x1: 2633.8,
    x2: 2845.1,
    y1: 1920.8,
    y2: 2397.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop32",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop33",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126294802325949112060000010710211191002116028_",
    x1: 2637.6,
    x2: 2848.8,
    y1: 1919.1,
    y2: 2396.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop34",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop35",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155861672047287428150000014717788061683036842_",
    x1: 3164.5,
    x2: 3179,
    y1: 2883.9,
    y2: 3242.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop36",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop37",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127006289731129278320000012267005091792574389_",
    x1: 2873,
    x2: 2965.5,
    y1: 3445.9,
    y2: 2364.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop38",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop39",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057148531611838001090000012512168209830623914_",
    x1: 2916.5,
    x2: 2894.7,
    y1: 2855.4,
    y2: 3250.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop40",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop41",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056387823534247972520000008672781865422673299_",
    x1: 3059.2,
    x2: 3151.8,
    y1: 3462,
    y2: 2379.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop42",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop43",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160167077789473137970000017271167619637359282_",
    x1: 3024.6,
    x2: 2745.1,
    y1: 2165.2,
    y2: 2555.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop44",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop45",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036248008372141159810000014012371011415691174_",
    x1: 3179.1,
    x2: 2681.2,
    y1: 2357.1,
    y2: 3028.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop46",
    stopColor: "#CB236D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop47",
    stopColor: "#4C246D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183208277611434962600000001046633294711992992_",
    x1: 2862.8,
    x2: 2880.2,
    y1: 2379.6,
    y2: 2252.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop48",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop49",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180338681985789405450000012380444343976624570_",
    x1: 2770.9,
    x2: 2754.6,
    y1: 2082.2,
    y2: 2484.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop50",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop51",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073694119909794220420000006590638614203047602_",
    x1: 2588.2,
    x2: 2573,
    y1: 2078.7,
    y2: 2453.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop52",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop53",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003824175442088235630000016428937389097010607_",
    x1: -5429.1,
    x2: -5312.7,
    y1: 2967.7,
    y2: 3101.5,
    gradientTransform: "matrix(.9653 .2612 -.2612 .9653 8857 649.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop54",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop55",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142874473602750082140000010672921293727273881_",
    x1: 2742.2,
    x2: 2989.8,
    y1: 2510.7,
    y2: 1909,
    gradientTransform: "matrix(.9998 -.0189 .0189 .9998 -59.548 19.477)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop56",
    stopColor: "#2B3582",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop57",
    stopColor: "#150E42",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096054419447218278060000010041112042875498137_",
    x1: -5400,
    x2: -5283.6,
    y1: 2942.3,
    y2: 3076.2,
    gradientTransform: "matrix(.9653 .2612 -.2612 .9653 8857 649.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop58",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop59",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059267434382287216220000004489918044642373018_",
    x1: 10824,
    x2: 9979.9,
    y1: 2804.4,
    y2: 3351.4,
    gradientTransform: "matrix(-1 0 0 1 11862 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop61",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop62",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070812078389389961600000016134425165338174892_",
    x1: 1305.3,
    x2: 1196.4,
    y1: 2349.2,
    y2: 2836.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop63",
    stopColor: "#A737D5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop64",
    stopColor: "#EF497A",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136402634363684585320000006862258134375914666_",
    x1: 1137.3,
    x2: 1110,
    y1: 2871.9,
    y2: 3325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop69",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop70",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180349596226331042480000010840716938464896388_",
    x1: 558.74,
    x2: 1047.6,
    y1: 2936.5,
    y2: 3535.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop71",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop72",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032623186513359405750000012785328301312811672_",
    x1: 642.24,
    x2: 1115.8,
    y1: 2889.2,
    y2: 3469.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop73",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop74",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024715384995037754330000010483725735170682250_",
    x1: 1460.2,
    x2: 1341.9,
    y1: 1315.9,
    y2: 1559.8,
    gradientTransform: "matrix(.987 .1608 -.1608 .987 126.98 357.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop75",
    stopColor: "#2B3582",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop76",
    stopColor: "#150E42",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103244378409925569540000016965414628150126739_",
    x1: 1187.1,
    x2: 1187.1,
    y1: 2303.9,
    y2: 2829.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop77",
    stopColor: "#CB236D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop78",
    stopColor: "#4C246D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049910347570220484680000000597896893701108899_",
    x1: 964.1,
    x2: 1213.6,
    y1: 2370.4,
    y2: 2973.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop79",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop80",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027592542826384946180000009731866730917058228_",
    x1: -5573.6,
    x2: -5324,
    y1: 2369.1,
    y2: 2971.9,
    gradientTransform: "matrix(-1 0 0 1 -4167.1 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop81",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop82",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119829255027656507080000006627442016540507068_",
    x1: 1185.8,
    x2: 1172.8,
    y1: 2448.3,
    y2: 2973.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop83",
    stopColor: "#2B3582",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop84",
    stopColor: "#150E42",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065057624785415088930000005202497983871013025_",
    x1: 1347.1,
    x2: 1483.4,
    y1: 2737.3,
    y2: 2737.3,
    gradientTransform: "matrix(1 .0077 -.0077 1 9.5247 16.814)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop85",
    stopColor: "#2B3582",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop86",
    stopColor: "#150E42",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008119365616928549590000003286971871700152708_",
    x1: 1425.5,
    x2: 1281.6,
    y1: 2518.6,
    y2: 2908.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop87",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop88",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134942934122744615380000000543446911036119436_",
    x1: -5873.7,
    x2: -5737.3,
    y1: 2697.7,
    y2: 2697.7,
    gradientTransform: "matrix(-.9998 -.02 -.02 .9998 -4814 -50.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop89",
    stopColor: "#2B3582",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop90",
    stopColor: "#150E42",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075156606444083772850000003998114166742077119_",
    x1: 1137.1,
    x2: 993.13,
    y1: 2401.1,
    y2: 2791.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop91",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop92",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032647687386308890090000004867695665167111095_",
    x1: 1486.5,
    x2: 1112.4,
    y1: 2511,
    y2: 2792.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop93",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop94",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149347290681369176030000011862234838761214634_",
    x1: 1148.2,
    x2: 1050.1,
    y1: 2763.2,
    y2: 2513.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop95",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop96",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016764513929429233440000008101920196457355399_",
    x1: 1183.2,
    x2: 1179.8,
    y1: 2420.2,
    y2: 2131.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop97",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop98",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013896166155030400350000003548011044717471888_",
    x1: 1338.9,
    x2: 1349.2,
    y1: 1709.5,
    y2: 1458.2,
    gradientTransform: "matrix(.987 .1608 -.1608 .987 126.98 357.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop99",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop100",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163045720834340893020000011436860482050806174_",
    x1: 1461,
    x2: 1327.9,
    y1: 1281.6,
    y2: 1556,
    gradientTransform: "matrix(.987 .1608 -.1608 .987 126.98 357.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop101",
    stopColor: "#2B3582",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop102",
    stopColor: "#150E42",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155851387241616723420000003624910578456651924_",
    x1: 822.25,
    x2: 838.46,
    y1: 2641.6,
    y2: 2247.7,
    gradientTransform: "matrix(.9911 -.1329 .1329 .9911 -26.025 -216.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop103",
    stopColor: "#F9B776",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop104",
    stopColor: "#F47960",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130617072708312783100000018275990001070300548_",
    x1: 1184.3,
    x2: 1175.9,
    y1: 2437.4,
    y2: 2838.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop105",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop106",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126309739124055247540000008039247533513984927_",
    x1: 1135.8,
    x2: 624.27,
    y1: 835.24,
    y2: 1999.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop107",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop108",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146491883155936271640000008500859777069182394_",
    x1: 1216.8,
    x2: 705.32,
    y1: 870.83,
    y2: 2035.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop109",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop110",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018946021706565558580000001575258451275350459_",
    x1: 1294.6,
    x2: 783.07,
    y1: 904.98,
    y2: 2069.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop111",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop112",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120545269160990797450000017593968488008271807_",
    x1: 1387.9,
    x2: 876.4,
    y1: 945.97,
    y2: 2110.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop113",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop114",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070082901237665985070000009831773738052753799_",
    x1: 1462.9,
    x2: 951.4,
    y1: 978.91,
    y2: 2143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop115",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop116",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006680315642275126000000013376675634451725246_",
    x1: 1525.4,
    x2: 1013.9,
    y1: 1006.4,
    y2: 2171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop117",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop118",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155147862518604541580000016873595598943496870_",
    x1: 1865.8,
    x2: 1528.6,
    y1: 845.92,
    y2: 1915.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop119",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop120",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003820701522329797970000012454256313383754401_",
    x1: 1958.7,
    x2: 1621.4,
    y1: 875.21,
    y2: 1944.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop121",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop122",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041975470230838145490000010677777126521910158_",
    x1: 2052.4,
    x2: 1715.2,
    y1: 904.76,
    y2: 1974.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop123",
    stopColor: "#53D8FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop124",
    stopColor: "#3840F7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042738986960506732860000006370903724307866797_",
    x1: 2383.8,
    x2: 2217.3,
    y1: 1357.2,
    y2: 2169.8,
    gradientTransform: "matrix(.9855 -.1695 .1695 .9855 325.72 -30.968)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop130",
    stopColor: "#A737D5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop131",
    stopColor: "#EF497A",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114788984611675698270000002127776657650069909_",
    x1: 2022,
    x2: 1890.8,
    y1: 1052.6,
    y2: 1688.5,
    gradientTransform: "matrix(.9855 -.1695 .1695 .9855 325.72 -30.968)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop139",
    stopColor: "#A737D5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop140",
    stopColor: "#EF497A",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m90.474 43.721 0.25272 113.22 116.76 0.25272 0.25272-114.48z",
    fill: "#0055d4",
    stroke: "#003380",
    strokeWidth: 0.968
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m90.474 43.721-23.283-12.269 0.3574 141.89 23.178-16.4z",
    fill: "#b3ff80",
    stroke: "#214478",
    strokeWidth: 0.968
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "m67.191 31.451-28.235-13.224 0.7148 170.84 27.877-15.726z",
    fill: "#80ffe6",
    stroke: "#214478",
    strokeWidth: 0.968
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "m38.957 18.227-39.088-18.593 0.13107 210.37 39.671-20.935z",
    fill: "#e9afc6",
    stroke: "#214478",
    strokeWidth: 0.968
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "m207.74 42.71 38.155-18.495 0.50968 159.49-38.918-26.512z",
    fill: "#fea",
    stroke: "#214478",
    strokeWidth: 0.968
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "m245.89 24.215 51.108-24.215v210l-50.599-26.296z",
    fill: "#eaf",
    stroke: "#214478",
    strokeWidth: 0.968
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "m-0.13107-0.3651 297.13 0.3651-89.264 42.71-117.26 1.0109z",
    fill: "#d5e5ff",
    stroke: "#003380",
    strokeWidth: 0.968
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "m0 210h297l-89.516-52.808-116.76-0.25272z",
    fill: "#0055d4",
    stroke: "#003380",
    strokeWidth: 0.968
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8",
    x: 96.91,
    y: 57.886,
    width: 104.23,
    height: 73.321,
    ry: 5.361,
    fill: "#025",
    stroke: "#0fc",
    strokeWidth: 0.91382
  }), /*#__PURE__*/React.createElement("g", {
    id: "link-mix"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1",
    d: "m9.2031 21.176 24.214 10.275c2.0049 0.85081 2.8436 3.7192 2.8592 5.8971l0.7148 100.07c0.01556 2.1779-0.53858 3.358-2.6805 3.7527l-26.18 4.8249c-2.1419 0.39476-3.1289-2.6469-3.1273-4.8249l0.08935-116.78c0.00167-2.178 2.1052-4.0674 4.1101-3.2166z",
    fill: "#c6afe9",
    stroke: "#06f",
    strokeWidth: 0.968
  }), /*#__PURE__*/React.createElement("text", {
    id: "text48",
    transform: "scale(.76582 1.3058)",
    x: 28.851326,
    y: 90.219513,
    fill: "#0088aa",
    fontFamily: "'Ink Free'",
    fontSize: "63.303px",
    stroke: "#55ffdd",
    strokeWidth: 2.7205,
    "text-align": "center",
    textAnchor: "middle",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan48",
    x: 28.851326,
    y: 90.219513,
    strokeWidth: 2.7205
  }, "?")), /*#__PURE__*/React.createElement("path", {
    id: "text49",
    transform: "matrix(.51838 .12004 -.2638 1.868 1.9912 -1.9294)",
    d: "m35.212 23.693c0.0224 0.0583-0.02698 0.1081-0.14819 0.14946-0.095 0.03024-0.17728 0.04477-0.24682 0.0436-0.22192-0.0066-0.55892-0.02682-1.0119-0.06069-0.45348-0.03103-0.79308-0.04997-1.0179-0.05674-0.02149-3.69e-4 -0.15613 0.0032-0.40424 0.0106-0.27219 0.01-0.4697 0.01539-0.59225 0.01623-0.20001-5.01e-4 -0.38959-0.1431-0.5689-0.42837-0.17252-0.30066-0.34499-0.60064-0.5174-0.89995-0.27099-0.43886-0.55246-0.79488-0.84433-1.0674-0.39843-0.36899-0.84378-0.61783-1.3362-0.74562 0.23792 0.58297 0.38536 0.96392 0.44304 1.1446 0.05654 0.17748 0.10361 0.38135 0.14124 0.61153 0.02047 0.14624 0.04092 0.29235 0.06134 0.43834 0.02675 0.15489 0.13833 0.23566 0.33456 0.24242 0.19181 0.03036 0.41262 0.06419 0.66228 0.10148 0.22001 0.03371 0.37514 0.06909 0.46562 0.10618 0.14544 0.06164 0.24344 0.16061 0.29409 0.29686 0.02891 0.08283 0.0071 0.14858-0.06558 0.1973-0.06123 0.03717-0.13076 0.05511-0.20861 0.0538-0.24836-0.02771-1.4245-0.08594-3.5521-0.17569-0.34758-0.01195-0.66282-0.02036-0.9455-0.02522-0.67681-0.01164-1.1739-0.0037-1.4892 0.02393l-0.47256 0.04609c-0.08148-0.0014-0.1694-0.02843-0.26378-0.08121-0.09446-0.05283-0.1554-0.11566-0.18276-0.18851-0.05722-0.16094 0.042-0.26024 0.29742-0.29771 0.33849-0.04789 0.62098-0.09674 0.84778-0.14658 0.18769-0.0415 0.30644-0.09484 0.35638-0.16006 0.06704-0.07992 0.06694-0.21541-3.4e-4 -0.40668-0.10564-0.30413-0.24575-0.65362-0.42056-1.0489l-0.37513-0.85901c-0.06007-0.14518-0.11748-0.29197-0.17224-0.44038-0.14059-0.38103-0.27642-0.81983-0.40752-1.3168-0.13138-0.48936-0.21053-0.77074-0.23714-0.84296-0.09595-0.25164-0.18461-0.42112-0.26591-0.50814-0.11646-0.12892-0.28978-0.19794-0.52009-0.20694-0.02005-7.83e-4 -0.14697-0.0011-0.38105-8.49e-4 -0.22103 7.41e-4 -0.34677 5.23e-4 -0.37699-6.54e-4 -0.24434-0.01579-0.38418-0.03064-0.41924-0.04451-0.10286-0.03533-0.18126-0.12925-0.23517-0.28188-0.06476-0.18148 0.12404-0.26326 0.56547-0.24519 0.11098 0.0045 0.24499 0.01786 0.40195 0.03993 0.33077 0.01977 0.82132 0.03356 1.4701 0.04136 0.64596 0.0078 1.1273 0.02129 1.4456 0.04054 1.226 0.07183 1.9217 0.11721 2.0947 0.13658 0.88449 0.1066 1.595 0.30503 2.1336 0.59472 0.69145 0.37604 1.1516 0.91958 1.383 1.6297 0.08037 0.24304 0.03394 0.47863-0.13919 0.7071-0.06085 0.08506-0.19617 0.21581-0.40604 0.39233 1.3233 0.78027 2.46 1.6539 3.4144 2.6202 0.10998 0.11033 0.45901 0.26168 1.045 0.45342 0.16185 0.05243 0.28425 0.18528 0.36725 0.39834zm-5.5401-4.4187c-0.20988-0.63898-0.77016-1.1706-1.6858-1.5954-0.20151-0.0934-0.37832-0.14309-0.53028-0.14896-0.15211-0.0059-0.19895 0.07821-0.14046 0.25208 0.22534 0.48242 0.51273 1.1629 0.86108 2.0385 0.24016 0.07082 0.62636 0.11879 1.1574 0.14393 0.3825 0.01762 0.49504-0.21202 0.33799-0.69011zm15.009 1.5821c0.36355 1.2327 0.12073 2.1168-0.72812 2.6619-0.66862 0.43202-1.6735 0.63751-3.0234 0.61544-1.1677-0.01909-2.2309-0.3336-3.1893-0.94801-1.051-0.67457-1.7697-1.5904-2.1496-2.7492-0.38911-1.1868-0.18756-2.0655 0.60558-2.6272 0.65708-0.46455 1.6234-0.66997 2.8914-0.61741 1.3007 0.05392 2.4274 0.3566 3.3824 0.90445 1.125 0.6473 1.8596 1.5681 2.2111 2.76zm-5.2331-2.9738c-0.28848-0.01125-0.39597 0.34629-0.32225 1.0704 0.05057 0.49859 0.14872 0.97978 0.2942 1.4435 0.19443 0.61968 0.42754 1.2188 0.69899 1.7974 0.41758 0.88993 0.77014 1.3351 1.0596 1.3404 0.55408 0.01028 0.55828-0.86823 0.0089-2.653-0.60652-1.9704-1.188-2.9771-1.7395-2.9986zm-1.0393-3.1721c0.11762 0.0059 0.35212 0.112 0.70268 0.31772 0.24074 0.14904 0.48044 0.29621 0.71909 0.44152 0.13538 0.07775 0.32983 0.22937 0.58293 0.45444 0.2824 0.24645 0.4387 0.4202 0.46958 0.52178 0.01543 0.05076-0.07549 0.12039-0.27288 0.20894-0.23148 0.10191-0.3529 0.15856-0.36404 0.16987-0.24313-0.13438-0.542-0.35282-0.89725-0.65601-0.23209-0.1976-0.48606-0.38332-0.76204-0.55713-0.10497 0.08155-0.2552 0.24153-0.45067 0.47995l-0.19737 0.39317c-0.07307 0.14556-0.14427 0.21684-0.21363 0.21385-0.07242-0.0031-0.18399-0.04513-0.33485-0.12612-0.16209-0.08756-0.2538-0.16468-0.27494-0.2313-0.03174-0.09998 0.01573-0.24729 0.14243-0.44188 0.09325-0.13033 0.18802-0.26059 0.2843-0.39078 0.20389-0.32874 0.31358-0.50176 0.32904-0.51899 0.16211-0.19592 0.34138-0.28892 0.53763-0.27904zm17.38 7.3783c0.05235 0.17475 0.07437 0.83222 0.06616 1.9673-0.0015 0.10454-0.09442 0.15388-0.27902 0.14806-0.01815-3.09e-4 -0.16869-0.0082-0.45211-0.02381-0.28075-0.01286-0.4344-0.01952-0.4605-0.01997-0.61232-0.01048-1.7006-0.02097-3.2766-0.03152-1.4271-0.0078-2.5505-0.02138-3.3623-0.04064-0.22532-0.0038-0.35927-0.07936-0.40161-0.22674-0.02399-0.08349 0.14357-0.45033 0.5029-1.1009 0.34487-0.7517 0.67518-1.4462 0.99081-2.0833 0.2763-0.5548 0.55186-1.1087 0.8267-1.6618 0.11096-0.22978 0.15343-0.38751 0.12736-0.47314-0.02918-0.0971-0.2163-0.15516-0.56203-0.17418-0.31622-0.0179-0.64662 0.01472-0.99114 0.09802-0.37425 0.08805-0.6701 0.21764-0.88703 0.38871-0.21789 0.16831-0.31146 0.34113-0.28063 0.51821 0.03496 0.21102 0.04477 0.34308 0.02949 0.39637-0.02112 0.08139-0.10127 0.11556-0.24057 0.10252-0.21664-0.02125-0.5155-0.69763-0.89911-2.0389-0.02992-0.10462 0.01296-0.17471 0.1286-0.21021 0.09545-0.02768 0.28548-0.04141 0.56967-0.04118 0.1973-4.64e-4 0.41378 0.0042 0.64936 0.01389 0.39729 0.01639 0.94673 0.05474 1.6464 0.11484 0.79214 0.06372 1.316 0.10356 1.5748 0.1198 0.40903 0.02518 0.97408 0.02574 1.6933 0.0018 0.77919-0.02395 1.333-0.02901 1.6639-0.01528 0.15187 0.0063 0.25794 0.03998 0.3183 0.10101 0.02438 0.02329 0.05244 0.08155 0.08417 0.17472 0.05621 0.15805-0.08002 0.56944-0.40836 1.2338l-1.8381 3.7232c-0.04491 0.08921-0.05738 0.17089-0.03741 0.245 0.02586 0.09601 0.24875 0.15222 0.66766 0.16863 0.22048 7e-3 0.51286-0.05511 0.87686-0.18619 0.32359-0.11269 0.51467-0.20087 0.57367-0.26469 0.22328-0.2338 0.34288-0.35999 0.35888-0.37862 0.14466-0.16492 0.23929-0.31201 0.28391-0.44133 0.03458-0.10787 0.06953-0.2144 0.10484-0.3196 0.0475-0.11852 0.11216-0.17534 0.19394-0.17044 0.22274 0.0086 0.37094 0.13756 0.44481 0.38644zm8.1583-3.6248c0.03665 0.16505-0.04196 0.26779-0.23599 0.30841-0.18367 0.0223-0.36789 0.04328-0.55265 0.06294-0.19624 0.03537-0.27788 0.12625-0.24478 0.27251 0.02266 0.10012 0.06285 0.24504 0.1205 0.4346 0.05695 0.18657 0.09666 0.32956 0.11918 0.42911 0.13476 0.59576 0.40982 1.9788 0.82087 4.1261 0.01878 0.10427 0.0076 0.20405-0.03365 0.29939-0.0437 0.10565-0.11167 0.15772-0.20397 0.15623-0.17993-0.0029-0.92757-0.48312-2.2584-1.452-1.3503-0.98709-2.0514-1.4871-2.0868-1.488-0.06339-0.0017-0.08007 0.05951-0.05006 0.18364 0.08143 0.33676 0.23085 0.67433 0.44785 1.0124 0.24407 0.37994 0.50451 0.64365 0.78143 0.79193 0.0056 0.0027 0.19486 0.06186 0.56668 0.1771 0.26142 0.08123 0.40462 0.17585 0.43008 0.28394 0.01427 0.0606-0.0036 0.11536-0.0537 0.16431-0.04822 0.04637-0.10082 0.06907-0.15779 0.0681-0.16611-0.0028-0.41539-0.01102-0.74833-0.02458-0.33383-0.0136-0.58494-0.02185-0.75282-0.02473-0.15806-0.0027-0.39483 0.0012-0.71074 0.01164-0.31348 0.0132-0.55023 0.01847-0.70983 0.01577-0.20296-0.0034-0.31948-0.06518-0.34934-0.1853-0.03786-0.15231 0.07204-0.25543 0.32939-0.30915 0.35366-0.07039 0.53552-0.1094 0.5462-0.11716 0.08171-0.05685 0.11158-0.19709 0.08961-0.42097-0.05345-0.51833-0.17117-1.1512-0.35379-1.9004-0.20426-0.83791-0.44228-1.5896-0.71428-2.254-0.03112-0.075-0.10432-0.15985-0.21972-0.2546-0.11364-0.09756-0.20619-0.15051-0.27755-0.15876 0.04216 0.0043-0.17155-0.0026-0.64241-0.02075-0.0756-0.0029-0.15966-0.02407-0.2522-0.06348-0.11562-0.04861-0.18182-0.10636-0.19852-0.17325-0.06476-0.2595 0.08881-0.38181 0.46-0.36659 0.27639 0.01133 0.68824 0.02685 1.2342 0.04651 0.54559 0.01687 0.9536 0.03087 1.2253 0.04202 0.05888 0.0024 0.11394 0.01014 0.16517 0.02317 0.17273 0.04531 0.70912 0.41426 1.6022 1.1014 0.8693 0.67136 1.3118 1.0048 1.3341 1.0055 0.06459 0.0021 0.08271-0.0587 0.05436-0.1826-0.04628-0.20225-0.17136-0.42503-0.37566-0.66863-0.18488-0.22203-0.37964-0.39915-0.58426-0.53113-0.09053-0.05753-0.20978-0.10407-0.3578-0.13959-0.17157-0.03919-0.2897-0.07363-0.35422-0.10328-0.10953-0.05044-0.17718-0.1305-0.20287-0.2402-0.03086-0.13176 0.04781-0.19248 0.23583-0.18206 0.57937 0.02916 0.90575 0.04524 0.98109 0.04832 0.24831 0.01016 0.5671 0.0056 0.95588-0.01349 0.31682-0.01661 0.63165-0.03324 0.9445-0.04988 0.04887-6.35e-4 0.09724 0.0296 0.1451 0.09067 0.0497 0.05845 0.08055 0.11474 0.09257 0.16889zm9.0419 3.9936c0.05803 0.30248 0.0921 0.61508 0.10229 0.93784l0.0014 0.91889c0.0018 0.13768-0.17309 0.20351-0.52557 0.19754-0.19249-0.0033-0.56624-0.01712-1.123-0.04167-0.55704-0.02463-0.93433-0.03865-1.1301-0.042-1.1768-0.02014-2.1344-0.01738-2.8673 0.0085l-0.78698 0.02522c-0.05462-9.14e-4 -0.11186-0.03012-0.17174-0.08765-0.05348-0.04975-0.08411-0.09786-0.09185-0.1443-0.0207-0.10589 0.01532-0.17475 0.10805-0.20652 0.04367-0.01721 0.13392-0.02712 0.27065-0.02972 0.09498 0.0018 0.25425 8.8e-4 0.47759-0.0027 0.34225-0.0064 0.46886-0.18998 0.38032-0.55139-0.03-0.11899-0.11935-0.4508-0.26852-0.99711-0.12115-0.43619-0.22256-0.84597-0.30409-1.229-0.0011-0.0053-0.05096-0.27854-0.14981-0.82138-0.09683-0.54487-0.1533-0.85532-0.16914-0.9298-0.04246-0.19971-0.17266-0.36205-0.39094-0.48703-0.07387-0.04265-0.32582-0.09762-0.75701-0.16506-0.35108-0.05913-0.53994-0.14798-0.56579-0.2665-0.03353-0.15368 0.01701-0.22781 0.15154-0.22226-0.05624-0.0023 0.23982 0.02324 0.88562 0.07648 0.65201 0.05335 1.3349 0.09458 2.0483 0.12379 0.9937 0.04068 1.7323 0.05781 2.2203 0.05165 0.48795-0.0087 0.92567-5e-3 1.3136 0.01104 0.16457 0.0068 0.29087 0.13158 0.37894 0.37399 0.02516 0.07102 0.06718 0.25922 0.12599 0.56413 0.04464 0.23148 0.06529 0.53386 0.062 0.90682-0.0017 0.15666-0.05402 0.23966-0.15717 0.24912-0.04726 0.0036-0.09676-0.016-0.14851-0.05883-0.04999-0.04536-0.08346-0.10563-0.10039-0.18083-0.02147-0.09858-0.05122-0.18076-0.08926-0.24652-0.19817-0.34529-0.5017-0.60885-0.91139-0.79035-0.32051-0.14492-0.658-0.22439-1.0124-0.23807-0.04232-0.0016-0.0757 0.01799-0.10013 0.05888-0.02496 0.03825-0.03346 0.07712-0.02549 0.11661 0.03132 0.15522 0.06958 0.32745 0.11474 0.51664 0.09014 0.37756 0.15406 0.6599 0.19193 0.84764 0.03362 0.16666 0.13091 0.25244 0.29176 0.25747 0.01864 5.83e-4 0.10154-0.0071 0.24859-0.02317 0.14922-0.01594 0.23305-0.0236 0.25162-0.02302 0.22488 0.0071 0.43401 0.04714 0.62744 0.12004 0.14341 0.05325 0.24591 0.2257 0.30756 0.51694 0.04089 0.18528 0.05648 0.50357 0.04684 0.9542-0.0031 0.19316-0.04925 0.2886-0.13861 0.28646-0.09401-0.0023-0.15218-0.04815-0.17446-0.13774-0.0073-0.02563-0.01429-0.06654-0.02087-0.12272-0.01089-0.06651-0.01887-0.11259-0.02393-0.13821-0.03701-0.18718-0.16044-0.38846-0.37071-0.60412-0.23971-0.24538-0.48517-0.37207-0.73614-0.37947-0.0349-1e-3 -0.07324 0.03261-0.11501 0.10092 0.05767 0.29745 0.13065 0.75104 0.21874 1.3593 0.08954 0.60321 0.13185 0.89239 0.12722 0.86946 0.0247 0.12228 0.08657 0.18432 0.18558 0.18622 0.35622 0.0068 0.76286-0.18627 1.2202-0.57889 0.30888-0.2664 0.52138-0.50826 0.63776-0.72581 0.03319-0.06254 0.05097-0.15209 0.05335-0.26872 0.0047-0.11665 0.05024-0.17385 0.13672-0.17155 0.0614 0.0016 0.11763 0.04118 0.16866 0.11861 0.038 0.05675 0.06163 0.1093 0.07091 0.15765z",
    fill: "#08a",
    stroke: "#5fd",
    strokeWidth: 0.37329,
    "aria-label": "r\\xF4zne"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "link-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "m51.902 39.637 11.056 4.5137c1.6001 0.65325 2.5916 2.496 2.6019 4.3239l0.47178 83.095c0.01038 1.8279-0.24284 3.5395-1.9256 3.8644l-19.122 3.692c-1.6827 0.32489-2.3669-1.2386-2.3656-3.0666l0.07015-96.582c0.0013-1.8279 0.68902-3.5441 2.2437-2.789z",
    fill: "#ffe680",
    stroke: "#37c871",
    strokeWidth: 0.78572
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect11",
    d: "m49.042 84.156 12.039 1.769c2.1549 0.31664 2.2255 0.36344 2.2255 2.5414v12.418c0 2.178-0.30029 2.1089-2.4783 2.0992l-14.124-0.0632c-2.178-0.01-1.6569-0.93207-1.6569-3.1101v-14.629c0-2.178 1.8397-1.3418 3.9946-1.0251z",
    fill: "#999",
    stroke: "#4d4d4d",
    strokeWidth: 0.968
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "m54.84 84.725c-0.18659-1.0575-0.26382-2.268 0.39409-3.1857 0.5093-0.55153 1.3922-0.39344 1.9403 0.01338 0.69451 0.41868 1.6847 0.31192 2.1886-0.35466 0.54329-0.66406 0.43811-1.7994-0.33508-2.2446-1.4666-0.89838-6.0238-0.17838-7.1482-2.7567-0.29774-0.75874-0.14923-1.5891-0.21424-2.3814 2e-3 -0.15432 7e-3 -0.3086 0.01545-0.4627",
    fill: "none",
    stroke: "#4d4d4d",
    strokeWidth: 0.968
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect12",
    d: "m46.248 85.799 1.0741 0.12636v1.8954l-1.0741-0.06318z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "m48.017 85.988 1.0741 0.12636v1.8954l-1.0741-0.06318z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-2",
    d: "m49.737 86.215 1.0741 0.12636v1.8954l-1.0741-0.06318z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-4",
    d: "m51.46 86.563 1.0173 0.1268v1.902l-1.0173-0.0634z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.26127
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-7",
    d: "m58.064 87.449 0.84819 0.12819v1.9228l-0.84819-0.06409z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.23987
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-8",
    d: "m59.607 87.582 0.96069 0.12725v1.9087l-0.96069-0.06362z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.25435
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-42",
    d: "m53.227 86.742 0.84819 0.12819v1.9228l-0.84819-0.06409z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.23987
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-3",
    d: "m54.925 86.955 0.84819 0.12819v1.9228l-0.84819-0.06409z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.23987
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-0",
    d: "m56.603 87.259 0.84819 0.12819v1.9228l-0.84819-0.06409z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.23987
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-06",
    d: "m61.191 87.885 1.4183 0.12396v1.8593l-1.4183-0.06198z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.30503
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-82",
    d: "m46.118 89.092 1.8845 0.12119v1.8178l-1.8845-0.06059z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.34765
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-1",
    d: "m48.576 89.252 1.0741 0.12636v1.8954l-1.0741-0.06318z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-71",
    d: "m50.342 89.442 1.0741 0.12636v1.8954l-1.0741-0.06318z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-9",
    d: "m52.037 89.786 0.96069 0.12725v1.9087l-0.96069-0.06362z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.25435
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-47",
    d: "m53.703 89.979 1.0173 0.1268v1.902l-1.0173-0.0634z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.26127
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-04",
    d: "m55.317 90.109 1.0741 0.12636v1.8954l-1.0741-0.06318z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-38",
    d: "m56.905 90.397 1.0741 0.12636v1.8954l-1.0741-0.06318z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-046",
    d: "m58.534 90.501 0.90432 0.12771v1.9156l-0.90432-0.06385z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.24722
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-01",
    d: "m60.058 90.576 0.90432 0.12771v1.9156l-0.90432-0.06385z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.24722
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-75",
    d: "m61.582 90.714 0.90432 0.12771v1.9156l-0.90432-0.06385z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.24722
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-82-1",
    d: "m46.298 92.146 1.8845 0.12119v1.8178l-1.8845-0.06059z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.34765
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-1-8",
    d: "m48.757 92.306 1.0741 0.12636v1.8954l-1.0741-0.06318z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-71-9",
    d: "m50.522 92.496 1.0741 0.12636v1.8954l-1.0741-0.06318z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-9-5",
    d: "m52.218 92.84 0.96069 0.12725v1.9087l-0.96069-0.06362z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.25435
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-47-0",
    d: "m53.883 93.033 1.0173 0.1268v1.902l-1.0173-0.0634z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.26127
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-04-2",
    d: "m55.498 93.163 1.0741 0.12636v1.8954l-1.0741-0.06318z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-38-7",
    d: "m57.085 93.451 1.0741 0.12636v1.8954l-1.0741-0.06318z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-046-6",
    d: "m58.714 93.555 0.90432 0.12771v1.9156l-0.90432-0.06385z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.24722
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-01-6",
    d: "m60.239 93.63 0.90432 0.12771v1.9156l-0.90432-0.06385z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.24722
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-75-0",
    d: "m61.763 93.768 0.90432 0.12771v1.9156l-0.90432-0.06385z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.24722
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-82-0",
    d: "m46.259 95.143 1.8845 0.12119v1.8178l-1.8845-0.06059z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.34765
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-1-4",
    d: "m48.717 95.303 1.0741 0.12636v1.8954l-1.0741-0.06318z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-1-4-1",
    d: "m46.258 98.686 1.0741 0.12636v1.8954l-1.0741-0.0632z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-1-4-13",
    d: "m48.15 98.714 1.0741 0.12636v1.8954l-1.0741-0.0632z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-1-4-0",
    d: "m58.607 99.456 1.0741 0.12636v1.8954l-1.0741-0.0632z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-1-4-07",
    d: "m60.183 99.52 1.0741 0.12636v1.8954l-1.0741-0.0632z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-1-4-06",
    d: "m61.746 99.595 1.0741 0.12636v1.8954l-1.0741-0.0632z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-1-4-11",
    d: "m50.201 99.037 7.2437 0.38102-0.05928 1.5456-7.2456-0.32945z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.62912
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-71-5",
    d: "m50.483 95.493 1.0741 0.12636v1.8954l-1.0741-0.06318z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-9-0",
    d: "m52.178 95.837 0.96069 0.12725v1.9087l-0.96069-0.06362z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.25435
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-47-1",
    d: "m53.844 96.03 1.0173 0.1268v1.902l-1.0173-0.0634z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.26127
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-04-3",
    d: "m55.458 96.16 1.0741 0.12636v1.8954l-1.0741-0.06318z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-38-8",
    d: "m57.046 96.449 1.0741 0.12636v1.8954l-1.0741-0.06318z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-046-8",
    d: "m58.675 96.552 0.90432 0.12771v1.9156l-0.90432-0.06385z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.24722
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-01-9",
    d: "m60.199 96.627 0.90432 0.12771v1.9156l-0.90432-0.06385z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.24722
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-75-2",
    d: "m61.723 96.766 0.90432 0.12771v1.9156l-0.90432-0.06385z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.24722
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "m60.147 119.76c0 6.2634-2.2185 11.025-5.8126 11.025-3.594 0-5.8126-4.572-5.8126-10.835s2.5976-11.72 6.1917-11.72c3.594 0 5.4335 5.267 5.4335 11.53z",
    fill: "#80b3ff",
    stroke: "#003380",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "m50.205 112.04c2.3981 2.0236 5.531 3.7411 8.7572 0.13402",
    fill: "none",
    stroke: "#003380",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "m48.444 120.04 11.782-0.82134",
    fill: "none",
    stroke: "#003380",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "m50.321 127.68c3.6562-4.8866 6.4213-2.9505 8.9576-2.2375",
    fill: "none",
    stroke: "#003380",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "m54.569 108.37c-4.7393 4.6433-2.2417 20.591 0.43909 22.349",
    fill: "none",
    stroke: "#003380",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "m54.844 108.34c2.8294 4.3369 3.9351 17.488 0.37273 22.23",
    fill: "none",
    stroke: "#003380",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "m54.714 108.25 0.27889 22.501",
    fill: "none",
    stroke: "#003380",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "m56.293 121.94 0.6318 8.5293 0.88452-2.1481 0.69498 3.4117 1.0109-1.39-1.0741-2.7799 1.5795-0.75816z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.268
  })), /*#__PURE__*/React.createElement("path", {
    id: "text50",
    transform: "matrix(.65073 .043205 -.083228 1.5312 -.62096 .55406)",
    d: "m74.667 34.556-0.21435-3.3903c0.36453 1.3194 0.71168 2.2726 1.0413 2.8602 0.32855 0.5821 0.68505 0.88807 1.069 0.91892 0.33632 0.02702 0.61137-0.20239 0.82553-0.68713 0.21747-0.48701 0.30218-1.0996 0.25463-1.8386-0.04213-0.65474-0.17603-1.1617-0.40201-1.5216-0.22221-0.3601-0.53027-0.56075-0.92505-0.6016l-0.54432-0.05632-0.36147 0.77361-0.11568-1.8196 0.46216 0.81068 0.44327 0.04638c0.35741 0.0374 0.61426-0.11253 0.77128-0.44916 0.16086-0.33548 0.21887-0.84987 0.17429-1.5434-0.03713-0.57771-0.15359-1.0383-0.34961-1.3823-0.19632-0.34453-0.45388-0.53678-0.77321-0.57646-0.33724-0.0419-0.6093 0.09943-0.81574 0.42472-0.20696 0.32611-0.42556 1.0117-0.65604 2.0592l-0.18743-2.9601 0.48389 1.0189c0.12055-0.29678 0.28211-0.50825 0.4845-0.63456 0.20617-0.1255 0.45891-0.16936 0.7579-0.13186 0.45729 0.05735 0.84753 0.29386 1.1716 0.70889 0.32735 0.4144 0.50938 0.91094 0.54679 1.4907 0.02947 0.45681-0.03885 0.86346-0.20526 1.2204-0.16702 0.35375-0.43065 0.66046-0.7917 0.92033 0.47079 0.22349 0.83098 0.522 1.0817 0.89569 0.25026 0.37293 0.3919 0.81766 0.42531 1.3349 0.05092 0.78819-0.10548 1.454-0.47042 1.9988-0.36266 0.54359-0.80204 0.79594-1.3189 0.75508-0.26579-0.02101-0.52665-0.15212-0.78248-0.39368-0.25216-0.24176-0.48357-0.58299-0.69407-1.0238zm5.0591 0.06377c0.20365 0.01696 0.3752 0.0745 0.51482 0.17253 0.14323 0.09429 0.21877 0.20256 0.22676 0.32492 0.0075 0.11447-0.05492 0.20765-0.18732 0.27962-0.1326 0.07207-0.29862 0.10028-0.4982 0.08453-0.19999-0.01579-0.37036-0.07071-0.51092-0.16482-0.14075-0.09424-0.21492-0.19906-0.2224-0.31435-8e-3 -0.12324 0.051-0.22118 0.17683-0.29378 0.12949-0.07612 0.29636-0.10563 0.50043-0.08864zm3.3977 1.0208 0.69319-0.40805-0.36007-5.4128-0.77663-0.5184 1.058 0.1185 0.19488 1.6183c0.04601-0.58511 0.13579-1.004 0.26921-1.257 0.1368-0.25591 0.3308-0.36955 0.5817-0.34132 0.18486 0.0208 0.34339 0.10894 0.47574 0.26431 0.13194 0.15136 0.24795 0.37861 0.3481 0.68174l0.20455-0.76219 0.20346 3.0195c-0.19995-0.88583-0.40631-1.5547-0.61921-2.0065-0.20966-0.45598-0.42809-0.69672-0.65544-0.72172-0.24723-0.0272-0.43379 0.20055-0.55941 0.68402-0.12224 0.48099-0.15565 1.1387-0.10003 1.9729 0.03607 0.54092 0.09122 1.078 0.16545 1.6111 0.07397 0.52921 0.1688 1.0524 0.28444 1.5695zm4.6284-5.5912c-0.26197-0.02909-0.44498 0.18175-0.54863 0.63319-0.10033 0.44883-0.11979 1.1274-0.05822 2.0356 0.06857 1.0115 0.18635 1.7821 0.35317 2.3108 0.17041 0.52846 0.3868 0.80304 0.64877 0.82412 0.26497 0.02132 0.44818-0.2236 0.55005-0.73403 0.10168-0.50949 0.11866-1.2581 0.05112-2.246-0.06157-0.90056-0.17661-1.5875-0.3453-2.0617-0.16542-0.47805-0.38226-0.73216-0.65096-0.762zm-0.0077-0.27638c0.39155 0.04405 0.73666 0.37414 1.036 0.98933 0.30235 0.61414 0.48481 1.3807 0.54793 2.3011 0.06548 0.95493-0.0088 1.7151-0.22331 2.2813-0.21547 0.56425-0.52417 0.8312-0.92688 0.79941-0.40069-0.03163-0.75354-0.35497-1.0578-0.971-0.30146-0.62098-0.48494-1.4129-0.54991-2.3742-0.06286-0.93012 0.02017-1.678 0.2485-2.2426 0.22733-0.5666 0.53603-0.82724 0.92546-0.78343zm4.3281 4.2548 0.61505 0.05663c-0.01846 0.799-0.1203 1.3934-0.30589 1.7831-0.18607 0.39074-0.45322 0.57276-0.80205 0.54522-0.43338-0.03421-0.80248-0.33871-1.1063-0.91444-0.3046-0.57715-0.48968-1.3388-0.55464-2.2833-0.06595-0.95887 0.02142-1.7209 0.26146-2.285 0.23922-0.56222 0.57408-0.81835 1.0037-0.77002 0.17273 0.01943 0.33797 0.11516 0.4958 0.28702 0.15759 0.17161 0.30224 0.4149 0.43401 0.72986l0.13909-0.97344 0.18715 2.685c-0.16598-0.75772-0.3594-1.3483-0.58045-1.7719-0.22145-0.42437-0.45264-0.65019-0.69375-0.67695-0.25619-0.02843-0.43532 0.21005-0.537 0.71622-0.10187 0.50711-0.11902 1.2516-0.05126 2.2334 0.06368 0.92266 0.17564 1.6029 0.3357 2.04 0.15989 0.4366 0.3808 0.66607 0.66222 0.68874 0.24105 0.01941 0.39894-0.09723 0.47408-0.34967 0.07837-0.25554 0.09107-0.76342 0.03821-1.5236zm-0.09352-5.6224-0.61443 1.042-0.54051-0.06295-0.73646-1.2107 0.96974 0.62573zm1.1 8.0265 0.64181-0.38833-0.36002-5.1366-0.70177-0.48788 0.98902 0.11077 0.15082 1.5534c0.07182-0.5122 0.19209-0.90039 0.3606-1.1647 0.16813-0.26374 0.37021-0.3821 0.60607-0.35556 0.36299 0.04084 0.68618 0.33429 0.97015 0.87951 0.28304 0.54032 0.45271 1.2096 0.50954 2.0092 0.04013 0.5647 0.0048 1.0706-0.10614 1.518-0.11116 0.44834-0.30718 0.85971-0.58867 1.2345l0.91556 0.49684-1.4354-0.11408c0.28155-0.40226 0.47424-0.85749 0.5787-1.3661 0.104-0.51124 0.12889-1.1479 0.07485-1.9104-0.05787-0.81651-0.16438-1.4289-0.31971-1.838-0.15205-0.40915-0.35763-0.62828-0.61716-0.65712-0.25332-0.02815-0.46602 0.23604-0.63792 0.79378-0.16913 0.55597-0.2253 1.2413-0.16814 2.0551 0.0322 0.45844 0.08256 0.92778 0.15109 1.4079 0.07203 0.48039 0.16368 0.96783 0.27492 1.4622zm4.0352 0.32071 0.73878-0.37069-0.54466-5.0203-0.87327-0.51964 2.2418 0.25108-0.81942 0.32877 0.21205 4.9778 0.75727 0.48908zm1.4646-7.3644-1.2666 0.90639 0.38683-1.0133zm0.57668 7.5266 0.63762-0.37407-0.5242-7.2529-0.69944-0.50838 1.2639 0.15789 0.13429 4.6077 1.0241-1.7691-0.65876-0.4974 1.496 0.16755-0.56135 0.36009-0.95826 1.62 1.571 3.296 0.68277 0.46351-1.5144-0.12036 0.62426-0.36012-1.6859-2.757 0.09309 3.0402z",
    fill: "#1c1c24",
    stroke: "#1c1c24",
    strokeWidth: 0.50056,
    "aria-label": "3. ro\\u010Dn\\xEDk"
  })), /*#__PURE__*/React.createElement("g", {
    id: "link-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "m71.824 48.646 14.795 5.9465c1.264 0.50805 1.6599 2.2477 1.6577 3.7733l-0.09935 68.757c-0.0022 1.5256 0.03236 3.891-1.2804 4.1476l-15.46 3.0223c-1.3128 0.25663-1.8157-1.2286-1.8214-2.7542l-0.3028-80.639c-0.0057-1.5256 1.2863-2.8491 2.5113-2.2531z",
    fill: "#f95",
    stroke: "#fd5",
    strokeWidth: 0.63327
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "m71.773 86.178c3.2409-4.8231 7.2902-2.3187 8.0871 0.88452l2.6536 0.37908-0.12636 7.3289 4.1699 0.50544v7.3289l-2.6536-0.12636 0.25272 6.9498 1.8954-0.25272 0.25272 5.8126h-3.6644l0.25272 5.0544-6.9498 0.50545c-0.78034 1.2923-1.5458 2.7626-2.6536 0.12636h-1.769z",
    fill: "#ffe680",
    stroke: "#ff7f2a",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "m83.007 94.904-5.706-0.41834c-0.06599 0.7728-1.3456 2.3545-2.464-0.25272l-1.1372 0.06318-0.44226 21.039 1.5479 0.0316 3.0958-0.0632 8.4661-0.15795-0.25272-5.9705-1.8453 0.10243-0.17646-6.7679 2.622 0.25272 0.03159-7.6448z",
    fill: "#ffe680",
    stroke: "#ff7f2a",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "m73.803 94.532 0.98285-0.08935c1.1013 3.0634 3.1653 0.23093 2.5912 0.26805l9.2031 0.7148-0.08935 7.148-7.9738-0.47834c-0.299 1.2213-2.1419 1.1486-2.5695-0.23651l-2.3231 0.0893z",
    fill: "#59f",
    stroke: "#3771c8",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "m75.974 101.91c0.02932 1.6882 2.6065 1.7246 2.4956 0.3159l5.4335 0.3159 0.12636 6.8866-5.4967 0.2843c0.756 2.186-3.6055 1.8686-2.6536 0.12636l-0.88452 0.0948 0.06318-7.9923z",
    fill: "#ff7f2a",
    stroke: "#a40",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "m73.605 101.97h1.2952l0.03159 8.0239 0.75816-0.18954c-0.58423 2.2802 4.2067 1.9589 2.9063-2e-5l7.4237-0.37906 0.25272 5.5282-8.6241 0.22113c0.53977 1.0735-2.8247 1.8901-2.7799 0.0632l-1.4216 0.0316z",
    fill: "#ffb380",
    stroke: "#ff7f2a",
    strokeWidth: 0.268
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path27",
    cx: 83.398,
    cy: 99.066,
    rx: 1.508,
    ry: 2.3293,
    fill: "#d5e5ff",
    stroke: "#06f",
    strokeWidth: 0.28466
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path27-1",
    cx: 82.013,
    cy: 106.03,
    rx: 1.508,
    ry: 2.3293,
    fill: "#ffe6d5",
    stroke: "#f60",
    strokeWidth: 0.28466
  }), /*#__PURE__*/React.createElement("text", {
    id: "text27",
    transform: "matrix(.65249 .065059 -.091255 1.5235 0 0)",
    x: 125.85848,
    y: 55.145325,
    fill: "#ff9955",
    fontFamily: "'Ink Free'",
    fontSize: "3.2113px",
    stroke: "#ff9955",
    strokeWidth: 0.3957,
    "text-align": "center",
    textAnchor: "middle",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan27",
    x: 125.85848,
    y: 55.145325,
    fill: "#ff9955",
    stroke: "#ff9955",
    strokeWidth: 0.3957
  }, "SCRATCH")))), /*#__PURE__*/React.createElement("path", {
    id: "text50-0",
    transform: "matrix(.65073 .043205 -.083228 1.5312 0 2.1444)",
    d: "m117.94 36.048-0.36675-0.79244-0.42652 0.0355 0.12548 3.5972 0.59773 0.47939-1.3441-0.09674 0.13834-3.9437-1.975 0.16287 0.53393-4.4211-0.61486-0.4746 1.2888 0.16222-0.8806 4.0294 1.6728 0.16673 0.15287-4.0772 0.74277 0.09349-0.57781 0.31999 0.12936 3.7083 0.42881 0.04274 0.31027-0.66391zm1.1774 2.6899c0.1754 0.01344 0.32255 0.06604 0.44168 0.15777 0.12237 0.08815 0.18623 0.19066 0.19167 0.30767 5e-3 0.10958-0.0499 0.19982-0.16526 0.27076-0.11561 0.07111-0.25962 0.10058-0.43214 0.08828-0.17291-0.01233-0.31958-0.0627-0.43978-0.15113-0.12028-0.0885-0.18271-0.18802-0.18721-0.29843-5e-3 -0.1179 0.0478-0.21241 0.15774-0.28351 0.11303-0.07446 0.2575-0.10488 0.4333-0.09141zm2.9199 0.92967 0.59655-0.40054-0.30337-5.0551-0.65103-0.46595 0.88747 0.09844 0.16429 1.482c0.0384-0.53917 0.11351-0.92412 0.2252-1.1566 0.11427-0.23471 0.27652-0.33996 0.48664-0.31653 0.1548 0.01726 0.28785 0.09607 0.39941 0.23645 0.1113 0.13687 0.20981 0.3434 0.29566 0.61996l0.16627-0.69836 0.19358 2.782c-0.17558-0.8217-0.35396-1.4378-0.5357-1.8514-0.17843-0.41611-0.36271-0.63422-0.55346-0.65493-0.20747-0.02253-0.3636 0.18757-0.46844 0.6324-0.10244 0.44437-0.13004 1.0536-0.0821 1.8298 0.0313 0.50621 0.079 1.0108 0.14318 1.5136 0.0643 0.50126 0.14664 0.99867 0.24724 1.492zm3.8923-5.2863c-0.21916-0.02407-0.36948 0.17023-0.45084 0.58468-0.0789 0.41363-0.0875 1.0406-0.0249 1.8842 0.0702 0.94692 0.17979 1.6727 0.32874 2.1721 0.15261 0.50118 0.34147 0.76057 0.5657 0.77698 0.22672 0.01659 0.37897-0.2201 0.45689-0.70773 0.0774-0.48459 0.0785-1.1911 4e-3 -2.1157-0.0673-0.83638-0.1754-1.4696-0.32435-1.9037-0.14574-0.43618-0.33057-0.66617-0.55529-0.69084zm-0.0102-0.25181c0.32711 0.03648 0.62002 0.33409 0.88025 0.89388 0.2639 0.56133 0.43126 1.2677 0.50209 2.1234 0.074 0.89451 0.0261 1.6133-0.14534 2.1539-0.17315 0.5415-0.43213 0.80166-0.77709 0.77706-0.34337-0.02448-0.64975-0.32917-0.91746-0.91298-0.26415-0.58584-0.42852-1.3315-0.49318-2.2323-0.0621-0.86491 6e-4 -1.557 0.18648-2.0783 0.18409-0.52048 0.43883-0.7609 0.76425-0.72461zm3.7183 3.8865 0.51963 0.04537c9e-3 0.75296-0.0581 1.3176-0.20332 1.691-0.14614 0.37578-0.36797 0.55396-0.66571 0.53273-0.37005-0.02639-0.69225-0.3125-0.96479-0.85748-0.27205-0.54399-0.4458-1.2611-0.52114-2.1465-0.0759-0.89187-0.0188-1.5972 0.16959-2.1182 0.18681-0.51668 0.45934-0.75336 0.81741-0.71342 0.14393 0.01605 0.28365 0.10166 0.41932 0.2568 0.13563 0.15509 0.26265 0.37607 0.38122 0.66327l0.0876-0.8907 0.23507 2.4678c-0.16143-0.70062-0.33998-1.2431-0.5361-1.6299-0.19587-0.38629-0.39407-0.59026-0.5952-0.61233-0.21374-0.02346-0.35709 0.19615-0.42988 0.66102-0.0733 0.46775-0.0703 1.1567 0.01 2.0705 0.0759 0.86549 0.18731 1.5069 0.33405 1.9197 0.14708 0.41368 0.34104 0.62969 0.58104 0.64727 0.20551 0.01506 0.33631-0.09866 0.39269-0.34049 0.0589-0.24429 0.0546-0.72625-0.0124-1.4429zm-0.23695-5.1591-0.47963 0.94403-0.44918-0.05216-0.63624-1.0845 0.81508 0.55438zm1.1632 7.4244 0.53106-0.3803-0.47661-4.7913-0.59757-0.43837 0.82325 0.09132 0.17816 1.4228c0.0421-0.47238 0.12852-0.82972 0.25901-1.0732 0.12988-0.24237 0.29281-0.35218 0.48883-0.33032 0.30164 0.03364 0.58031 0.29792 0.83731 0.79356 0.25704 0.49311 0.42636 1.1087 0.50807 1.8501 0.058 0.5265 0.0505 1.0011-0.0231 1.4237-0.074 0.42505-0.22152 0.81784-0.4433 1.1785l0.79539 0.46087-1.2195-0.08777c0.22192-0.38823 0.36584-0.82402 0.43269-1.3073 0.0661-0.48362 0.0603-1.0816-0.0165-1.7926-0.0817-0.75654-0.19508-1.32-0.34027-1.694-0.14203-0.37296-0.32064-0.57099-0.53652-0.59471-0.21075-0.02316-0.37744 0.22032-0.50029 0.73339-0.1212 0.51391-0.14409 1.149-0.0676 1.9064 0.0433 0.42888 0.1025 0.86938 0.17761 1.3215 0.0784 0.45409 0.1739 0.91636 0.28664 1.3868zm3.4306 0.24691 0.60506-0.36464-0.6948-4.6785-0.74422-0.46548 1.8598 0.2063-0.65931 0.30853 0.42178 4.6429 0.66327 0.45539zm0.8602-6.8444-0.99566 0.8298 0.27071-0.9182zm0.86965 6.9689 0.5155-0.36625-0.82633-6.6989-0.59647-0.44962 1.0384 0.1307 0.36172 4.1986 0.74486-1.642-0.56989-0.44723 1.2377 0.13729-0.43922 0.33465-0.69677 1.5028 1.5077 3.0756 0.6023 0.43158-1.2784-0.09202 0.50133-0.35265-1.5709-2.5733 0.25085 2.867z",
    fill: "#1c1c24",
    stroke: "#1c1c24",
    strokeWidth: 0.50056,
    "aria-label": "4. ro\\u010Dn\\xEDk"
  })), /*#__PURE__*/React.createElement("g", {
    id: "link-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "m253.14 36.437 33.71-13.955c2.7224-1.127 4.4768 0.14733 4.4768 3.0454v117.35c0 2.8981-2.258 4.4194-5.1626 3.8861l-33.881-6.221c-2.9046-0.53332-2.9553-1.6606-2.9338-4.5586l0.68578-92.801c0.0214-2.898 0.38285-5.6173 3.1053-6.7444z",
    fill: "#08a",
    stroke: "#acf",
    strokeWidth: 1.3006
  }), /*#__PURE__*/React.createElement("g", {
    id: "g47",
    transform: "translate(8.5776 -3.2166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "m252.86 74.161c2.077-1.261 4.6584-3.3365 7.6841-6.9693 1.3566 1.8813 1.8858 2.2176 8.2202 3.9314-2.0517 8.1606 1.9598 16.321-8.5776 24.482-8.3301-5.7626-6.5929-13.894-7.3267-21.444z",
    fill: "#5f5fd3",
    stroke: "#afafe9",
    strokeWidth: 0.449
  }), /*#__PURE__*/React.createElement("g", {
    id: "g29",
    stroke: "#87aade",
    strokeWidth: 0.849
  }, /*#__PURE__*/React.createElement("path", {
    id: "path29",
    d: "m257.86 79.254c-0.12487-7.6322 5.2894-7.4056 5.1823-0.08935",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect29",
    d: "m257.62 79.7 6.0216-0.62545c0.26111-0.02712 0.65255 0.92614 0.65255 1.1887v8.0767c0 0.26251-0.21225 0.45186-0.47385 0.47385l-6.379 0.5361c-0.26159 0.02198-0.37338-0.30092-0.3845-0.5632l-0.3574-8.4341c-0.0111-0.26228 0.6595-0.62543 0.9206-0.65255z",
    fill: "#87aade"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    fill: "#2c5aa0",
    stroke: "#2c5aa0",
    strokeWidth: 0.849
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "path30",
    cx: 260.28,
    cy: 83.408,
    rx: 0.7148,
    ry: 1.0275
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect30",
    x: 260.37,
    y: 84.525,
    width: 0.1787,
    height: 1.9657,
    ry: 0.08935
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    strokeWidth: 0.849
  }, /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "m263.76 102.04c1.8301-10.285 7.8185-4.106 7.9522-2.7699 3.1265-1.2881 5.1764 2.3268 3.7527 3.9314 3.9749 1.0093 2.8453 6.9371 0.62545 7.3267h-12.598c-3.8333-1.0561-3.8611-6.9591 0.26805-8.4883z",
    fill: "#d5f6ff",
    stroke: "#025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "m265.55 110.7v7.9522l-2.4125-0.0893",
    fill: "none",
    stroke: "#cd87de"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    fill: "none",
    stroke: "#cd87de"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect33",
    d: "m258.76 115.53 4.1101 0.1787 0.0893 4.9143-4.1995-0.26805z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect34",
    x: 260.63,
    y: 120.53,
    width: 0.44675,
    height: 1.519
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "m259.2 122.05 3.0379 0.26805"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34-2",
    transform: "translate(17.346 1.3586)",
    fill: "none",
    stroke: "#cd87de"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect33-5",
    d: "m258.76 115.53 4.1101 0.1787 0.0893 4.9143-4.1995-0.26805z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect34-1",
    x: 260.63,
    y: 120.53,
    width: 0.44675,
    height: 1.519
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34-6",
    d: "m259.2 122.05 3.0379 0.26805"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34-4",
    transform: "translate(-.75057 10.733)",
    fill: "none",
    stroke: "#cd87de"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect33-9",
    d: "m259.14 115.47 4.2997 0.55778-0.0371 4.7879-4.3258-0.45759z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect34-7",
    x: 260.89,
    y: 120.72,
    width: 0.44675,
    height: 1.519
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34-4",
    d: "m259.2 122.05 3.6065 0.58395"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34-5",
    transform: "translate(7.8017 12.127)",
    fill: "none",
    stroke: "#cd87de"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect33-95",
    d: "m258.95 115.28 4.6787 0.62096-0.10024 5.167-4.7681-0.71031z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect34-6",
    d: "m260.82 120.72 0.63629 0.25272-0.37908 1.0767h-0.44675z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34-5",
    d: "m259.2 122.05 3.6697 0.58395"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34-6",
    transform: "translate(17.366 13.379)",
    fill: "none",
    stroke: "#cd87de"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect33-4",
    d: "m258.32 115.34 4.8683 0.36824 0.0893 5.4829-5.084-0.58395z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect34-3",
    d: "m260.57 121.04 0.50993-0.0632v1.0767h-0.44675z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34-59",
    d: "m258.83 122.31 3.7329 0.52077"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "m267.19 110.94 0.18955 14.152-6.7603-0.69498v1.769",
    fill: "none",
    stroke: "#cd87de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "m269.02 110.94 0.0632 16.3",
    fill: "none",
    stroke: "#cd87de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    d: "m270.92 110.94 0.12637 14.784 7.0762 0.63181 0.0632 2.0218",
    fill: "none",
    stroke: "#cd87de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "m272.75 110.88-0.0632 8.2134 3.3486 0.25272",
    fill: "none",
    stroke: "#cd87de"
  })), /*#__PURE__*/React.createElement("path", {
    id: "text50-0-8",
    transform: "matrix(.65073 .043205 -.083228 1.5312 0 0)",
    d: "m396.92 14.974c-0.34603 0.06252-0.59362 0.35092-0.7433 0.86322-0.14539 0.50485-0.14655 1.1016-5e-3 1.7906 0.13612 0.66025 0.36974 1.1739 0.70149 1.5429 0.33558 0.36505 0.70249 0.51813 1.102 0.45868 0.41448-0.06168 0.7115-0.27866 0.89002-0.65211 0.17865-0.37912 0.20967-0.86457 0.0921-1.4563-0.15683-0.78933-0.43707-1.4294-0.83992-1.9174-0.40323-0.49132-0.80295-0.70098-1.1979-0.62963zm-0.012 8.3933-0.63945-3.0835c0.50308 1.0634 0.94517 1.8233 1.3274 2.2819 0.38266 0.45904 0.7449 0.66743 1.0876 0.62466 0.42091-0.05254 0.69539-0.46424 0.82243-1.2393 0.12725-0.78469 0.0687-1.7969-0.17764-3.0383-0.0106-0.05317-0.0291-0.1345-0.0555-0.24404-0.0265-0.10959-0.0458-0.19485-0.0578-0.25576-0.058 0.4516-0.18848 0.79342-0.39103 1.0261-0.19739 0.23109-0.4821 0.37372-0.85339 0.42839-0.60212 0.08866-1.1281-0.0541-1.5807-0.42703-0.45219-0.37571-0.7518-0.91851-0.90009-1.6311-0.0927-0.44537-0.098-0.88526-0.0154-1.3203 0.0829-0.43697 0.24943-0.83164 0.50035-1.1841 0.10373-0.15711 0.23133-0.28518 0.38291-0.38412 0.15544-0.1038 0.32086-0.17178 0.49624-0.20378 0.62785-0.11455 1.233 0.19454 1.8119 0.92865 0.57965 0.73499 0.9962 1.7457 1.2478 3.0248 0.26708 1.3576 0.28237 2.4825 0.049 3.3755-0.22753 0.88018-0.63574 1.3534-1.2229 1.4256-0.23697 0.02913-0.48208-0.03832-0.73554-0.20206-0.24956-0.16764-0.51594-0.4398-0.79936-0.81656zm5.2997-1.1618c0.22267-0.02857 0.41594-0.01065 0.57952 0.05389 0.16758 0.06027 0.26265 0.14926 0.28502 0.26684 0.0209 0.10993-0.0373 0.21412-0.17445 0.31244-0.13681 0.09809-0.31429 0.16047-0.53223 0.18726-0.21734 0.02672-0.40637 0.0096-0.56735-0.05123-0.16075-0.06075-0.25161-0.14546-0.27277-0.25425-0.0226-0.11637 0.0288-0.22297 0.15464-0.31991 0.12978-0.1015 0.30558-0.16655 0.52762-0.19504zm3.9401 0.24889 0.78079-0.57354-0.99174-5.5249-0.98256-0.30325 1.2807-0.21101 0.406 1.6568c-5e-3 -0.63331 0.0615-1.1069 0.19889-1.4195 0.142-0.31866 0.37041-0.50447 0.68573-0.55663 0.23365-0.03865 0.44199 0.0045 0.62466 0.12969 0.18216 0.12124 0.35196 0.33062 0.50918 0.62796l0.18712-0.90022 0.55078 3.2149c-0.33976-0.89424-0.66719-1.5533-0.98148-1.9752-0.30997-0.42653-0.60865-0.61643-0.89537-0.56994-0.30988 0.05025-0.51683 0.35372-0.62133 0.90836-0.0999 0.54701-0.0729 1.2502 0.0799 2.1088 0.0987 0.55439 0.21984 1.098 0.36343 1.631 0.14256 0.52791 0.30955 1.0435 0.50099 1.547zm5.2953-7.2653c-0.35577 0.05818-0.58179 0.35705-0.67884 0.89483-0.0922 0.53026-0.0563 1.2842 0.10695 2.2599 0.18064 1.08 0.40378 1.8803 0.67002 2.4053 0.27103 0.52392 0.58193 0.76382 0.93397 0.71988 0.3586-0.04476 0.58696-0.35821 0.6843-0.9425 0.0979-0.58738 0.0604-1.4193-0.11365-2.4979-0.15961-0.98944-0.37596-1.7253-0.64849-2.2039-0.2682-0.4838-0.58673-0.69565-0.95426-0.63555zm-0.035-0.30897c0.53692-0.08882 1.0399 0.16402 1.5067 0.75934 0.47236 0.59503 0.79009 1.4042 0.9522 2.4229 0.16714 1.0503 0.12329 1.9173-0.12939 2.6015-0.25141 0.67491-0.65069 1.0442-1.1966 1.1113-0.53733 0.06605-1.0313-0.19166-1.4841-0.77248-0.44819-0.58499-0.75797-1.384-0.9303-2.4014-0.16776-0.99046-0.1293-1.8337 0.11747-2.5297 0.24799-0.70558 0.63565-1.1039 1.164-1.1913zm6.5179 3.4227 0.94035-0.13096c0.0202 0.94102-0.0993 1.6625-0.35718 2.1665-0.25624 0.50089-0.64435 0.7822-1.1632 0.84598-0.63755 0.07837-1.1938-0.1638-1.672-0.72557-0.47753-0.56108-0.79786-1.3626-0.96209-2.4095-0.16778-1.0696-0.10206-1.9724 0.19979-2.7085 0.3044-0.74235 0.77611-1.1686 1.4168-1.2746 0.2598-0.04298 0.51494 0.0078 0.76513 0.15248 0.2506 0.14497 0.48703 0.38103 0.70899 0.70804l0.14938-1.2227 0.46013 3.1405c-0.30241-0.84001-0.63621-1.4724-1.0006-1.8953-0.36402-0.42247-0.72768-0.60384-1.0901-0.54461-0.38238 0.0625-0.62897 0.40958-0.74057 1.0388-0.11099 0.62576-0.0807 1.4921 0.0898 2.5968 0.15918 1.0316 0.36994 1.7693 0.63289 2.2173 0.26287 0.44788 0.60117 0.64593 1.0165 0.59406 0.35835-0.04475 0.58614-0.22187 0.68248-0.53194 0.10141-0.31595 0.0883-0.90503-0.0399-1.7694zm-0.51567-6.6716-0.86193 1.5142-0.81135 0.13842-1.1743-1.1441 1.4781 0.35226zm2.1968 9.1597 0.97738-0.63828-0.856-6.0289-1.1333-0.31849 1.5701-0.25868 0.32845 1.8449c0.0872-0.653 0.26-1.1768 0.51912-1.5705 0.26051-0.39574 0.58636-0.62667 0.9778-0.69142 0.60788-0.10056 1.1661 0.13499 1.6719 0.70773 0.50593 0.56905 0.82323 1.3476 0.95088 2.3313 0.0897 0.69126 0.0478 1.3331-0.12467 1.9249-0.17151 0.58842-0.48568 1.1545-0.94035 1.6972l1.5589 0.32041-2.3981 0.29639c0.44416-0.56684 0.74378-1.1766 0.89669-1.8286 0.15327-0.6603 0.16925-1.4528 0.0468-2.3781-0.13186-0.99639-0.33803-1.7225-0.61801-2.1743-0.27421-0.45285-0.62875-0.64374-1.062-0.57286-0.41963 0.06865-0.75447 0.48319-1.0046 1.2395-0.24315 0.7453-0.29627 1.599-0.16124 2.5614 0.0757 0.53978 0.18079 1.0849 0.31512 1.6356 0.13963 0.54868 0.3106 1.0986 0.51292 1.65zm6.6174-0.81788 1.2905-0.6975-1.1067-6.205-1.5625-0.29511 4.0657-0.66987-1.5088 0.80417 0.49986 6.3168 1.3828 0.36825zm2.4713-10.119-2.3122 1.8182 0.67425-1.5278zm1.1959 9.666 1.1913-0.69582-1.0722-9.4573-1.3442-0.33777 2.4417-0.44394 0.29054 6.2334 2.0241-2.8676-1.3171-0.37152 3.0377-0.50049-1.1608 0.78153-1.9192 2.6542 3.1121 3.8056 1.3917 0.37464-3.0578 0.37793 1.2469-0.69955-3.3179-3.0249 0.19284 3.9566z",
    fill: "#1c1c24",
    stroke: "#1c1c24",
    strokeWidth: 0.50056,
    "aria-label": "9. ro\\u010Dn\\xEDk"
  })), /*#__PURE__*/React.createElement("g", {
    id: "link-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect10",
    d: "m214.57 53.173 24.845-10.488c2.0066-0.84702 3.2996 0.11072 3.2996 2.2887v88.192c0 2.178-1.6642 3.3213-3.805 2.9205l-24.972-4.6753c-2.1408-0.40081-2.1782-1.248-2.1624-3.426l0.50544-69.743c0.0158-2.1779 0.28218-4.2216 2.2887-5.0686z",
    fill: "#de87aa",
    stroke: "#ff2a7f",
    strokeWidth: 0.968
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "m223.55 83.81c-0.42396-5.7695 1.9082-5.4755 3.7527-6.2545 3.4176-0.32014 4.4439 1.7511 3.574 5.7184 0.70618 7.186-1.9193 6.0429-3.9314 6.4332-1.7889-0.18242-3.6394-0.48821-3.574 3.0379v3.574c-4.5534-0.13225-4.4515-10.396-1.6083-11.973l5.361-0.7148z",
    fill: "#003380",
    stroke: "#de87aa",
    strokeWidth: 0.849
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39-5",
    d: "m231.22 95.141c0.45197 5.7674-1.8816 5.4848-3.7223 6.2727-3.416 0.33673-4.4523-1.7295-3.6017-5.701-0.74107-7.1825 1.8899-6.0522 3.9001-6.4522 1.7897 0.17374 3.6417 0.47054 3.5592-3.0552l-0.0173-3.574c4.554 0.11014 4.502 10.374 1.6664 11.965l-5.3575 0.74083z",
    fill: "#d4aa00",
    stroke: "#de87aa",
    strokeWidth: 0.849
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "m216.4 106.64 3.9344-0.0927",
    fill: "none",
    stroke: "#de87aa",
    strokeWidth: 0.849
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    d: "m218.28 109.14h3.842",
    fill: "none",
    stroke: "#55f",
    strokeWidth: 0.90313
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41-4",
    d: "m219.87 111.57h3.2166",
    fill: "none",
    stroke: "#55f",
    strokeWidth: 0.82636
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41-9",
    d: "m219.85 114.16 4.871 0.2245",
    fill: "none",
    stroke: "#55f",
    strokeWidth: 1.0138
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41-3",
    d: "m219.69 118.84 3.8212 0.40004",
    fill: "none",
    stroke: "#55f",
    strokeWidth: 0.90313
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41-2",
    d: "m233.28 112.03 5.9849 0.1354",
    fill: "none",
    stroke: "#55f",
    strokeWidth: 1.1273
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41-6",
    d: "m226.56 122.18 4.7327 0.39488",
    fill: "none",
    stroke: "#55f",
    strokeWidth: 0.99093
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41-0",
    d: "m218.48 123.61 3.8162 0.4452",
    fill: "none",
    stroke: "#55f",
    strokeWidth: 0.90313
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41-96",
    d: "m227.11 124.97 3.3888 0.36907",
    fill: "none",
    stroke: "#55f",
    strokeWidth: 0.77903
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41-99",
    d: "m226.59 111.93h5.8078",
    fill: "none",
    stroke: "#ffe680",
    strokeWidth: 1.1104
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "m222.66 109.14h2.3231",
    fill: "none",
    stroke: "#fc0",
    strokeWidth: 0.849
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "m223.82 111.71 1.8736 0.0514",
    fill: "none",
    stroke: "#c83771",
    strokeWidth: 0.98214
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43-6",
    d: "m229.81 114.65 3.4088 0.0484",
    fill: "none",
    stroke: "#87de87",
    strokeWidth: 1.2859
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43-6-8",
    d: "m234.43 122.89 3.3885 0.37404",
    fill: "none",
    stroke: "#87de87",
    strokeWidth: 1.2859
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43-6-9",
    d: "m219.35 121.38 3.3954 0.30498",
    fill: "none",
    stroke: "#87de87",
    strokeWidth: 1.2859
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43-6-5",
    d: "m223.01 121.77 3.3928 0.3331",
    fill: "none",
    stroke: "#87de87",
    strokeWidth: 1.2859
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43-1",
    d: "m218.28 116.19 3.5869 0.25884",
    fill: "none",
    stroke: "#c83771",
    strokeWidth: 1.3166
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43-2",
    d: "m225.53 114.42 3.644 0.0902",
    fill: "none",
    stroke: "#c83771",
    strokeWidth: 1.1862
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43-19",
    d: "m231.84 122.78 1.8628 0.2071",
    fill: "none",
    stroke: "#c83771",
    strokeWidth: 0.98214
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43-3",
    d: "m223.05 124.29 2.4633 0.2963",
    fill: "none",
    stroke: "#c83771",
    strokeWidth: 1.1038
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43-8",
    d: "m216.85 125.89 3.0222 0.48982",
    fill: "none",
    stroke: "#c83771",
    strokeWidth: 1.3093
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path44",
    cx: 226.15,
    cy: 80.571,
    rx: 0.40208,
    ry: 0.84883,
    fill: "none",
    stroke: "#de87aa",
    strokeWidth: 0.849
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path45",
    cx: 228.25,
    cy: 98.352,
    rx: 0.40208,
    ry: 0.82649,
    fill: "none",
    stroke: "#de87aa",
    strokeWidth: 0.849
  }))), /*#__PURE__*/React.createElement("path", {
    id: "text50-0-0",
    transform: "matrix(.58001 .034194 -.074183 1.2119 23.538 10.329)",
    d: "m338.84 31.85c-0.32809 0.04685-0.56208 0.27033-0.7029 0.66972-0.13747 0.39338-0.16385 0.91606-0.0794 1.5688 0.10843 0.83856 0.29679 1.5276 0.56567 2.0683 0.2732 0.54199 0.54962 0.79926 0.82954 0.7705 0.29185-0.02999 0.51361-0.33196 0.66468-0.90735 0.15464-0.58222 0.18139-1.2674 0.0798-2.054-0.0948-0.73395-0.25884-1.282-0.49173-1.6432-0.2328-0.36466-0.52165-0.52195-0.86565-0.47283zm-0.55504-4.5464c-0.2848 0.05098-0.48149 0.26188-0.59081 0.63218-0.10614 0.36445-0.11765 0.86703-0.0347 1.5084 0.0947 0.73223 0.24331 1.2905 0.4463 1.6755 0.20289 0.38152 0.43818 0.5533 0.70636 0.51454 0.27287-0.03943 0.46236-0.26968 0.56779-0.69142 0.10871-0.42773 0.11751-0.99553 0.0262-1.7026-0.0856-0.66326-0.22703-1.1643-0.4238-1.5026-0.19633-0.33751-0.42893-0.48189-0.69731-0.43385zm0.97797 4.379c0.40177 0.12554 0.73063 0.37882 0.98538 0.76017 0.25915 0.38203 0.42692 0.86702 0.50268 1.454 0.0638 0.49428 0.052 0.975-0.0351 1.4414-0.0833 0.4649-0.23785 0.90077-0.46295 1.3071-0.0976 0.17438-0.21422 0.31272-0.34967 0.41508-0.13514 0.10212-0.27917 0.16078-0.43204 0.17612-0.12416 0.01246-0.25667-0.01386-0.3975-0.07885-0.13647-0.06087-0.26049-0.15141-0.37214-0.27158-0.30855-0.32711-0.56394-0.71547-0.76676-1.1653-0.19948-0.4536-0.33163-0.93184-0.39677-1.4354-0.0769-0.59405-0.0427-1.1045 0.1029-1.5322 0.14602-0.42913 0.39865-0.7535 0.75916-0.97306-0.36008-0.21755-0.64501-0.51101-0.85575-0.88053-0.20732-0.37346-0.34567-0.82951-0.41543-1.3688-0.0843-0.65158-0.0237-1.2069 0.18226-1.6673 0.2063-0.4667 0.51242-0.73747 0.91966-0.8112 0.42048-0.07612 0.78807 0.06624 1.1016 0.42855 0.31842 0.36313 0.52139 0.88054 0.60795 1.5511 0.0735 0.569 0.0487 1.0902-0.074 1.5625-0.11875 0.4705-0.32019 0.83327-0.60352 1.0884zm2.925 4.3008c0.18556-0.02 0.34629 0.01244 0.482 0.09749 0.13913 0.08033 0.21773 0.18988 0.23561 0.32853 0.0167 0.1297-0.0325 0.24801-0.14751 0.35477-0.11477 0.10655-0.26326 0.1689-0.44526 0.18716-0.18149 0.01821-0.33898-0.0132-0.47266-0.09407-0.13343-0.08073-0.20834-0.18526-0.22492-0.31369-0.0177-0.1373 0.0262-0.25867 0.13185-0.36427 0.10897-0.11063 0.25586-0.17597 0.44089-0.19591zm3.2825 0.52649 0.65071-0.62288-0.82445-6.4094-0.80634-0.39957 1.0512-0.16552 0.33503 1.9045c-5e-3 -0.72124 0.0494-1.2551 0.1618-1.6015 0.11608-0.3524 0.30315-0.54934 0.56175-0.59028 0.1916-0.03034 0.36273 0.03028 0.51318 0.18214 0.15013 0.14748 0.29064 0.39415 0.42143 0.74012l0.14885-1.008 0.47407 3.6916c-0.28671-1.0438-0.56063-1.8143-0.82166-2.3122-0.2569-0.50176-0.50311-0.73397-0.73854-0.69772-0.25447 0.03918-0.42393 0.37125-0.50894 0.99515-0.0815 0.61718-0.0582 1.4221 0.0696 2.4158 0.0828 0.64395 0.18447 1.2786 0.30505 1.9041 0.12004 0.62125 0.26074 1.2313 0.42219 1.8304zm4.3436-8.0379c-0.29164 0.04544-0.47437 0.37031-0.54897 0.97376-0.0709 0.59677-0.0341 1.4577 0.1104 2.5835 0.16073 1.2528 0.35469 2.1909 0.58224 2.8155 0.23217 0.62545 0.49467 0.92359 0.78808 0.89338 0.29886-0.03077 0.48496-0.38234 0.55747-1.0558 0.0727-0.67504 0.029-1.638-0.13116-2.8879-0.14615-1.1404-0.33485-1.9905-0.56571-2.5491-0.22677-0.56286-0.4911-0.8203-0.79235-0.77337zm-0.0322-0.35059c0.43972-0.06963 0.85596 0.24415 1.2479 0.9438 0.39777 0.70191 0.67251 1.6413 0.82296 2.8158 0.15594 1.2174 0.13391 2.2165-0.0654 2.9951-0.19909 0.77049-0.52708 1.1775-0.98241 1.2231-0.44821 0.04497-0.86391-0.28539-1.248-0.98874-0.37909-0.70568-0.64388-1.6481-0.79552-2.8294-0.14686-1.1441-0.12191-2.1031 0.0755-2.8793 0.19768-0.78433 0.51224-1.2119 0.94505-1.2804zm5.4432 4.2727 0.77786-0.09558c0.042 1.0855-0.0382 1.9133-0.24008 2.483-0.20109 0.56755-0.51859 0.87231-0.95113 0.91571-0.53153 0.05333-1.002-0.26225-1.4129-0.94421-0.40917-0.67902-0.69077-1.6241-0.84615-2.8378-0.15789-1.2332-0.1195-2.2569 0.11605-3.0741 0.23668-0.82112 0.61601-1.2744 1.14-1.3574 0.21245-0.03364 0.42311 0.03788 0.6319 0.21495 0.20932 0.17752 0.40931 0.45717 0.59985 0.83913l0.0932-1.3694 0.45777 3.583c-0.27129-0.97434-0.56227-1.7111-0.87253-2.2105-0.30926-0.49771-0.61227-0.7228-0.90888-0.67662-0.31299 0.04873-0.5088 0.42619-0.58829 1.1313-0.0793 0.70334-0.0374 1.6914 0.12562 2.9651 0.15306 1.196 0.34376 2.061 0.57251 2.5959 0.22922 0.53607 0.51636 0.78676 0.86229 0.75112 0.29847-0.03076 0.48447-0.22335 0.55715-0.57813 0.0767-0.36076 0.0508-1.0438-0.0776-2.0488zm-0.58393-7.5726-0.67157 1.6413-0.66196 0.10941-0.98157-1.3435 1.2145 0.47515zm2.0521 10.552 0.79839-0.68453-0.8868-6.9478-0.94033-0.42264 1.2831-0.20203 0.32463 2.1013c0.0525-0.73444 0.17911-1.3161 0.38042-1.7448 0.20199-0.43025 0.46251-0.67116 0.78206-0.72176 0.49613-0.07856 0.96308 0.21731 1.3998 0.89028 0.43804 0.6709 0.72951 1.5708 0.87291 2.6971 0.10121 0.79494 0.0914 1.5283-0.0293 2.1987-0.1203 0.66852-0.36098 1.3047-0.72071 1.9071l1.3172 0.46509-1.9971 0.20222c0.35141-0.63273 0.57958-1.322 0.6832-2.0667 0.10326-0.75176 0.0872-1.6606-0.0484-2.7252-0.14532-1.1408-0.34157-1.9747-0.58831-2.5007-0.24144-0.52553-0.53954-0.76018-0.89344-0.70501-0.34286 0.05345-0.6053 0.50092-0.78796 1.3401-0.17794 0.83016-0.196 1.7977-0.0547 2.9049 0.0795 0.62334 0.18387 1.2563 0.31306 1.8992 0.13392 0.64272 0.29447 1.2906 0.48176 1.944zm5.5116-0.55809 1.0499-0.73367-1.1887-7.1476-1.2973-0.41932 3.3146-0.52192-1.2053 0.81672 0.6989 7.2381 1.1759 0.50961zm1.5975-11.34-1.8147 1.892 0.48826-1.6609zm1.455 11.031 0.96231-0.73698-1.3652-10.761-1.1136-0.44647 1.9713-0.35522 0.55949 6.9854 1.5174-3.1196-1.1046-0.48958 2.4712-0.38912-0.91039 0.80879-1.4387 2.8827 2.8133 4.5417 1.1912 0.51653-2.5433 0.25753 1.004-0.73742-2.9393-3.6667 0.37257 4.5624z",
    fill: "#1c1c24",
    stroke: "#1c1c24",
    strokeWidth: 0.50056,
    "aria-label": "8. ro\\u010Dn\\xEDk"
  })), /*#__PURE__*/React.createElement("path", {
    id: "text50-0-5",
    transform: "matrix(.65215 -.0029716 .025384 1.5333 0 0)",
    d: "m163.86 48.257-0.64835 1.7119v-1.4901h-1.3308l-0.73366 3.6114q0.23318-0.14218 0.46636-0.21612 0.23886-0.07393 0.44361-0.07393 0.77347 0 1.2796 0.64835 0.51186 0.64267 0.51186 1.6436 0 1.2057-0.5403 2.0531-0.5346 0.84741-1.2512 0.84741-0.38674 0-0.72229-0.33555t-0.53461-0.93272l-0.40948 0.83035v-3.2304q0.42654 1.9621 0.79622 2.6901 0.36967 0.72229 0.88153 0.72229 0.46636 0 0.79622-0.72798 0.33556-0.72798 0.33556-1.8199 0-0.93272-0.34124-1.5356-0.34124-0.60854-0.84741-0.60854-0.28437 0-0.58579 0.14787-0.29574 0.14218-0.60286 0.43224l0.23318-3.9242-0.66541-0.44361zm1.1318 7.9338q0.28436 0 0.47204 0.12512 0.19337 0.11943 0.19337 0.29574 0 0.16493-0.19337 0.28436-0.19337 0.11943-0.47204 0.11943-0.27868 0-0.46636-0.11943-0.18768-0.11943-0.18768-0.28436 0-0.17631 0.18199-0.29574 0.18768-0.12512 0.47205-0.12512zm3.1678 0.72229 0.69953-0.45498v-5.3006l-0.72228-0.42655h1.0237l0.0853 1.5811q0.12512-0.87584 0.34693-1.274 0.22749-0.4038 0.59716-0.4038 0.27299 0 0.45499 0.21043 0.18199 0.20474 0.30142 0.64267l0.25593-0.78485v2.9972q-0.21043-1.2967-0.48342-1.9394-0.2673-0.64835-0.60285-0.64835-0.36399 0-0.59717 0.73935-0.22749 0.73366-0.22749 1.9621 0 0.79622 0.0569 1.5754 0.0569 0.77347 0.17631 1.5242zm4.9764-6.0001q-0.39811 0-0.60286 0.69954-0.19905 0.69385-0.19905 2.0531 0 1.5128 0.19905 2.2863 0.20475 0.77347 0.60286 0.77347 0.4038 0 0.61423-0.78485t0.21043-2.2749q0-1.3593-0.21043-2.0531-0.20475-0.69954-0.61423-0.69954zm0.0114-0.27868q0.59717 0 0.99528 0.88722 0.4038 0.88722 0.4038 2.2806 0 1.4446-0.39243 2.3318-0.39242 0.88153-1.0066 0.88153-0.60854 0-1.0066-0.88722-0.39243-0.89291-0.39243-2.3261 0-1.3877 0.4038-2.2749 0.4038-0.89291 0.99528-0.89291zm4.2143 3.8901h0.65404q-0.11943 1.2398-0.46067 1.8654-0.34124 0.6256-0.8929 0.6256-0.68248 0-1.0976-0.84172-0.41518-0.84172-0.41518-2.2749 0-1.456 0.43793-2.3602 0.43792-0.90428 1.1147-0.90428 0.27299 0 0.50617 0.23887 0.23318 0.23887 0.40948 0.70522l0.22181-1.0237v2.7583q-0.182-1.1488-0.48911-1.7688-0.30711-0.61992-0.68816-0.61992-0.4038 0-0.61992 0.79622t-0.21612 2.292q0 1.4048 0.20474 2.0531 0.20475 0.64835 0.64836 0.64835 0.38105 0 0.52892-0.39811 0.15355-0.4038 0.15355-1.5697zm0.31849-5.8011-0.73366 1.1545h-0.56873l-0.68816-1.1545 0.97821 0.52323zm0.58011 8.1897 0.72229-0.45498v-5.3006l-0.72229-0.42655h1.0635l0.0455 1.6038q0.17631-0.81328 0.48342-1.2569 0.30712-0.44361 0.69385-0.44361 0.59717 0 1.0067 0.81328 0.40948 0.8076 0.40948 2.0645 0 0.88722-0.23886 1.6095-0.23887 0.72229-0.75073 1.3479l0.97822 0.44361h-1.5811q0.51186-0.66541 0.74503-1.4787 0.23318-0.81897 0.23318-2.0133 0-1.2796-0.21043-1.8996-0.20474-0.61992-0.63129-0.61992-0.41517 0-0.7621 0.90428-0.34123 0.89859-0.34123 2.1612 0 0.71091 0.0569 1.4503 0.0626 0.73935 0.18768 1.4958zm4.4134 0 0.86447-0.45498-0.21043-5.2778-0.9441-0.4493h2.5309l-0.96685 0.4493-0.16493 5.2778 0.82466 0.45498zm2.2692-8.002-1.5242 1.1318 0.52324-1.1318zm0.0398 8.002 0.76779-0.45498v-7.7461l-0.76779-0.45498h1.456l-0.23318 4.965 1.3536-2.0304-0.73366-0.46067h1.7574l-0.69954 0.46067-1.2683 1.8654 1.5697 3.4124 0.77347 0.44361h-1.7858l0.76778-0.44361-1.746-2.8152-0.14787 3.2588z",
    fill: "#d5e5ff",
    stroke: "#d5e5ff",
    strokeWidth: 0.50056,
    "aria-label": "5. ro\\u010Dn\\xEDk"
  }), /*#__PURE__*/React.createElement("path", {
    id: "text50-0-5-6",
    transform: "matrix(.65213 .0060177 .0042472 1.5335 0 0)",
    d: "m214.17 50.744q-0.53461 0-0.87016 0.50048-0.32986 0.4948-0.32986 1.3195 0 1.2398 0.36967 2.0474 0.37536 0.80191 0.91566 0.80191 0.45498 0 0.79053-0.69385 0.33555-0.69954 0.33555-1.7403 0-0.99528-0.34124-1.6152-0.33555-0.61992-0.87015-0.61992zm1.6095-3.5887v3.1906q-0.36967-1.6778-0.75641-2.4569-0.38673-0.77916-0.84172-0.77916-0.55735 0-0.93272 1.1431-0.36967 1.1431-0.36967 3.0029 0 0.07393 6e-3 0.24455 6e-3 0.16493 6e-3 0.24456 0.17062-0.6256 0.4948-0.92703 0.32986-0.30712 0.83034-0.30712 0.80191 0 1.2967 0.65973 0.50048 0.65973 0.50048 1.7403 0 0.6711-0.22749 1.2853t-0.64835 1.0692q-0.17062 0.18768-0.40949 0.29574-0.23318 0.10806-0.46067 0.10806-0.83035 0-1.3706-1.183-0.54029-1.183-0.54029-3.0768 0-2.0474 0.51185-3.3157 0.51755-1.274 1.3138-1.274 0.3128 0 0.60286 0.30143 0.29005 0.30143 0.56304 0.90997zm1.4446 7.6892q0.28436 0 0.47205 0.12512 0.19336 0.11943 0.19336 0.29574 0 0.16493-0.19336 0.28436-0.19337 0.11943-0.47205 0.11943t-0.46636-0.11943q-0.18768-0.11943-0.18768-0.28436 0-0.17631 0.18199-0.29574 0.18768-0.12512 0.47205-0.12512zm3.1678 0.72229 0.69954-0.45498v-5.3006l-0.72229-0.42655h1.0237l0.0853 1.5811q0.12512-0.87584 0.34693-1.274 0.22749-0.4038 0.59717-0.4038 0.27299 0 0.45498 0.21043 0.18199 0.20474 0.30143 0.64267l0.25593-0.78485v2.9972q-0.21043-1.2967-0.48342-1.9394-0.26731-0.64835-0.60286-0.64835-0.36399 0-0.59717 0.73935-0.22749 0.73366-0.22749 1.9621 0 0.79622 0.0569 1.5754 0.0569 0.77347 0.17631 1.5242zm4.9764-6.0001q-0.39811 0-0.60285 0.69954-0.19906 0.69385-0.19906 2.0531 0 1.5128 0.19906 2.2863 0.20474 0.77347 0.60285 0.77347 0.4038 0 0.61423-0.78485t0.21043-2.2749q0-1.3593-0.21043-2.0531-0.20474-0.69954-0.61423-0.69954zm0.0114-0.27868q0.59717 0 0.99528 0.88722 0.4038 0.88722 0.4038 2.2806 0 1.4446-0.39242 2.3318-0.39243 0.88153-1.0067 0.88153-0.60854 0-1.0066-0.88722-0.39242-0.89291-0.39242-2.3261 0-1.3877 0.4038-2.2749 0.40379-0.89291 0.99527-0.89291zm4.2143 3.8901h0.65404q-0.11944 1.2398-0.46067 1.8654-0.34124 0.6256-0.89291 0.6256-0.68248 0-1.0976-0.84172t-0.41517-2.2749q0-1.456 0.43792-2.3602 0.43792-0.90428 1.1147-0.90428 0.27299 0 0.50617 0.23887 0.23318 0.23887 0.40949 0.70522l0.2218-1.0237v2.7583q-0.18199-1.1488-0.48911-1.7688-0.30711-0.61992-0.68816-0.61992-0.4038 0-0.61992 0.79622t-0.21612 2.292q0 1.4048 0.20475 2.0531 0.20474 0.64835 0.64835 0.64835 0.38105 0 0.52892-0.39811 0.15356-0.4038 0.15356-1.5697zm0.31849-5.8011-0.73367 1.1545h-0.56873l-0.68816-1.1545 0.97822 0.52323zm0.5801 8.1897 0.72229-0.45498v-5.3006l-0.72229-0.42655h1.0635l0.0455 1.6038q0.17631-0.81328 0.48343-1.2569 0.30711-0.44361 0.69385-0.44361 0.59716 0 1.0066 0.81328 0.40949 0.8076 0.40949 2.0645 0 0.88722-0.23887 1.6095-0.23887 0.72229-0.75073 1.3479l0.97822 0.44361h-1.5811q0.51186-0.66541 0.74504-1.4787 0.23318-0.81897 0.23318-2.0133 0-1.2796-0.21043-1.8996-0.20475-0.61992-0.63129-0.61992-0.41518 0-0.7621 0.90428-0.34124 0.89859-0.34124 2.1612 0 0.71091 0.0569 1.4503 0.0626 0.73935 0.18768 1.4958zm4.4134 0 0.86447-0.45498-0.21043-5.2778-0.94409-0.4493h2.5308l-0.96684 0.4493-0.16494 5.2778 0.82466 0.45498zm2.2692-8.002-1.5242 1.1318 0.52323-1.1318zm0.0398 8.002 0.76778-0.45498v-7.7461l-0.76778-0.45498h1.456l-0.23318 4.965 1.3536-2.0304-0.73366-0.46067h1.7574l-0.69954 0.46067-1.2683 1.8654 1.5697 3.4124 0.77347 0.44361h-1.7858l0.76778-0.44361-1.746-2.8152-0.14787 3.2588z",
    fill: "#d5e5ff",
    stroke: "#d5e5ff",
    strokeWidth: 0.50056,
    "aria-label": "6. ro\\u010Dn\\xEDk"
  }), /*#__PURE__*/React.createElement("path", {
    id: "text50-0-5-4",
    transform: "matrix(.65214 -.0049355 .030001 1.5332 0 0)",
    d: "m265.61 48.88-1.6095 8.2125 0.61992 0.44361h-1.5071l2.2408-8.4343h-2.1896l-0.71092 3.0655v-3.2873zm0.72228 7.9338q0.28437 0 0.47205 0.12512 0.19337 0.11943 0.19337 0.29574 0 0.16493-0.19337 0.28436-0.19337 0.11943-0.47205 0.11943-0.27867 0-0.46635-0.11943-0.18769-0.11943-0.18769-0.28436 0-0.17631 0.182-0.29574 0.18768-0.12512 0.47204-0.12512zm3.1678 0.72229 0.69954-0.45498v-5.3006l-0.72229-0.42655h1.0237l0.0853 1.5811q0.12512-0.87584 0.34692-1.274 0.2275-0.4038 0.59717-0.4038 0.27299 0 0.45499 0.21043 0.18199 0.20474 0.30142 0.64266l0.25593-0.78485v2.9972q-0.21043-1.2967-0.48342-1.9394-0.2673-0.64835-0.60285-0.64835-0.36399 0-0.59717 0.73935-0.22749 0.73366-0.22749 1.9621 0 0.79622 0.0569 1.5754 0.0569 0.77347 0.17631 1.5242zm4.9764-6.0001q-0.39811 0-0.60285 0.69954-0.19906 0.69385-0.19906 2.0531 0 1.5128 0.19906 2.2863 0.20474 0.77347 0.60285 0.77347 0.4038 0 0.61423-0.78485t0.21043-2.2749q0-1.3593-0.21043-2.0531-0.20474-0.69954-0.61423-0.69954zm0.0114-0.27868q0.59717 0 0.99528 0.88722 0.4038 0.88722 0.4038 2.2806 0 1.4446-0.39243 2.3318-0.39242 0.88153-1.0066 0.88153-0.60854 0-1.0066-0.88722-0.39243-0.89291-0.39243-2.3261 0-1.3877 0.4038-2.2749 0.4038-0.89291 0.99528-0.89291zm4.2143 3.8901h0.65404q-0.11943 1.2398-0.46067 1.8654t-0.89291 0.6256q-0.68247 0-1.0976-0.84172-0.41517-0.84172-0.41517-2.2749 0-1.456 0.43792-2.3602 0.43793-0.90428 1.1147-0.90428 0.27299 0 0.50617 0.23887 0.23317 0.23887 0.40948 0.70523l0.22181-1.0237v2.7583q-0.182-1.1488-0.48911-1.7688-0.30712-0.61992-0.68817-0.61992-0.40379 0-0.61991 0.79622-0.21612 0.79622-0.21612 2.292 0 1.4048 0.20474 2.0531 0.20475 0.64835 0.64836 0.64835 0.38105 0 0.52892-0.39811 0.15355-0.4038 0.15355-1.5697zm0.31849-5.8011-0.73366 1.1545h-0.56873l-0.68816-1.1545 0.97821 0.52323zm0.58011 8.1897 0.72229-0.45498v-5.3006l-0.72229-0.42655h1.0635l0.0455 1.6038q0.17631-0.81328 0.48342-1.2569 0.30712-0.44361 0.69385-0.44361 0.59717 0 1.0067 0.81328 0.40948 0.8076 0.40948 2.0645 0 0.88722-0.23886 1.6095-0.23887 0.72229-0.75073 1.3479l0.97822 0.44361h-1.5811q0.51185-0.66542 0.74503-1.4787 0.23318-0.81897 0.23318-2.0133 0-1.2796-0.21043-1.8996-0.20474-0.61992-0.63129-0.61992-0.41517 0-0.7621 0.90428-0.34123 0.89859-0.34123 2.1612 0 0.71091 0.0569 1.4503 0.0626 0.73935 0.18768 1.4958zm4.4133 0 0.86448-0.45498-0.21044-5.2778-0.94409-0.4493h2.5308l-0.96684 0.4493-0.16493 5.2778 0.82466 0.45498zm2.2692-8.002-1.5242 1.1318 0.52323-1.1318zm0.0398 8.002 0.76779-0.45498v-7.7461l-0.76779-0.45498h1.456l-0.23318 4.965 1.3536-2.0304-0.73366-0.46067h1.7574l-0.69953 0.46067-1.2683 1.8654 1.5697 3.4124 0.77348 0.44361h-1.7858l0.76779-0.44361-1.746-2.8152-0.14787 3.2588z",
    fill: "#d5e5ff",
    stroke: "#d5e5ff",
    strokeWidth: 0.50056,
    "aria-label": "7. ro\\u010Dn\\xEDk"
  }), /*#__PURE__*/React.createElement("g", {
    id: "link-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect46",
    x: 101.86,
    y: 88.797,
    width: 28.235,
    height: 36.097,
    ry: 3.2166,
    fill: "#08a",
    stroke: "#5fd",
    strokeWidth: 0.849
  }), /*#__PURE__*/React.createElement("g", {
    id: "g70",
    transform: "matrix(.02234 0 0 .02234 101.61 91.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "object"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1-8",
    d: "m248.08 542.88-15.103 17.012-5.999-5.326c-2.919-2.591-3.185-7.059-0.593-9.978l5.718-6.441c2.592-2.919 7.059-3.185 9.978-0.593z",
    fill: "#bbbdc4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2-2",
    d: "m288.37 496.11-37.414 42.143-7.992-7.095c-3.017-2.678-3.291-7.294-0.613-10.311l27.716-31.219c2.678-3.017 7.294-3.291 10.311-0.613z",
    fill: "#dedee0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3-1",
    d: "m466.32 298.42-37.414 42.143-7.992-7.095c-3.017-2.678-3.291-7.295-0.613-10.311l27.716-31.219c2.678-3.017 7.294-3.291 10.311-0.613z",
    fill: "#dedee0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4-9",
    d: "m712.3 490.3-253.38 285.41c-9.905 11.157-26.979 12.172-38.136 2.267l-194.54-172.71c-11.157-9.905-12.172-26.979-2.267-38.136l253.38-285.41c9.905-11.157 26.979-12.172 38.136-2.267l194.54 172.71c11.157 9.905 12.172 26.979 2.267 38.136z",
    fill: "#cecfd4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect5",
    transform: "matrix(.6639 -.7478 .7478 .6639 -243.06 544.11)",
    x: 266.07,
    y: 431.15,
    width: 435.44,
    height: 222.62,
    fill: "#876d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon7",
    points: "297.35 423.9 345.54 369.62 395.73 376.79 454.01 409.08 347.66 528.87 308.21 475.38",
    fill: "#dedee0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8-0",
    d: "m299.58 558.34-35.037 39.466c-3.039 3.423-8.276 3.734-11.699 0.695l-7.741-6.872c-3.423-3.039-3.734-8.276-0.695-11.699l35.037-39.466c3.039-3.423 8.276-3.734 11.699-0.695l7.741 6.872c3.422 3.039 3.734 8.277 0.695 11.699z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9-7",
    d: "m320.54 512.86c5.124 4.549 5.59 12.39 1.041 17.513-4.549 5.124-12.39 5.59-17.513 1.041-5.124-4.549-5.59-12.39-1.041-17.514s12.389-5.589 17.513-1.04z",
    fill: "#a6caa2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10-6",
    d: "m577.4 429.09c-1.184 0.07-2.314 0.314-3.38 0.689l-16.125-14.315c-2.484-2.205-6.284-1.979-8.489 0.505s-1.979 6.284 0.505 8.489l16.125 14.315c-0.246 1.103-0.354 2.254-0.284 3.438 0.407 6.839 6.281 12.054 13.12 11.648 6.84-0.407 12.054-6.281 11.648-13.12-0.406-6.84-6.28-12.055-13.12-11.649z",
    fill: "#cecfd4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13",
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon11",
    points: "347.66 528.87 378.93 552.83 485.12 436.7 454.01 409.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12-0",
    d: "m531.75 437.45c-9.699-2.915-19.74-4.453-29.798-4.616 2.025 0.484 4.039 1.026 6.038 1.626 21.455 6.447 40.441 19.669 54.218 37.296 3.426 4.442 6.507 9.124 9.242 14.022 10.786 19.32 15.276 41.904 12.973 63.892-2.285 21.805-11.28 42.817-25.622 59.415-14.864 17.202-34.908 29.457-57.002 34.799-8.813 2.131-17.883 3.103-26.934 2.957 16.589 3.963 34.096 4.046 50.695 0.033 22.094-5.342 42.138-17.597 57.002-34.799 14.342-16.597 23.337-37.61 25.622-59.415 2.304-21.988-2.187-44.573-12.973-63.892-2.735-4.898-5.815-9.58-9.242-14.022-13.778-17.626-32.764-30.849-54.219-37.296z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g15"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle13",
    cx: 481.73,
    cy: 537.79,
    r: 107.18,
    fill: "#6d6e72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g16"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse14",
    transform: "matrix(.7071 -.7071 .7071 .7071 -239.18 498.15)",
    cx: 481.73,
    cy: 537.79,
    r: 92.374,
    fill: "#333"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16-5",
    d: "m494.09 426.06c-22.605-2.437-45.618 1.997-65.662 12.742-20.709 11.101-37.712 28.938-47.936 50.084-9.895 20.464-13.36 43.904-9.796 66.354 3.609 22.739 14.117 43.946 30.083 60.545 16.163 16.804 37.531 28.34 60.465 32.563 22.249 4.097 45.69 1.378 66.343-7.889 21.479-9.638 39.558-25.925 51.422-46.263 11.448-19.624 16.613-42.728 14.794-65.362-1.833-22.825-10.698-44.966-25.351-62.586-3.715-4.467-7.741-8.648-12.074-12.52-17.375-15.328-39.219-25.182-62.288-27.668zm92.305 87.477c4.894 21.002 3.272 43.514-4.655 63.573-8.287 20.968-23.165 39.075-42.161 51.228-18.289 11.699-39.954 17.523-61.637 16.813-45.074-1.475-85.426-32.432-98.775-75.458-6.402-20.635-6.391-42.984-0.072-63.637 6.568-21.464 20.186-40.697 38.129-54.159 35.524-26.654 85.099-28.457 122.51-4.548 4.707 3.009 9.137 6.433 13.325 10.127 16.584 14.819 28.288 34.384 33.34 56.061z",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g20",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse18",
    transform: "matrix(.999 -.0451 .0451 .999 -23.748 22.258)",
    cx: 481.73,
    cy: 537.79,
    r: 59.604
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g23-0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path21-4",
    d: "m445.1 834.04c6.921-10.514 63.267-62.909 67.629-66.244l3.727-58.405-54.975 63.268-38.386 6.769-37.079-39.356 42.319-42.827-17.079-23.772-72.419 40.714s5.893 46.896 5.894 46.896c4.902 9.588 26.048 62.702 26.048 62.702l-86.282 241.74-23.497 77.307 163.87 51.338 10.969-82.192c0.426-21.878 4.214-270.27 9.261-277.94z",
    fill: "#ebceb1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon22",
    points: "227 1269.8 253.14 1130 447.48 1187.4 445 1269.8",
    fill: "#ad6f5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path23-9",
    d: "m395.07 1244.6c7.393-4.005 13.697-9.713 19.923-15.364 4.852-4.405 10.165-10.786 7.391-16.724-0.712-1.525-1.898-2.773-2.789-4.201-1.705-2.731-2.269-6-3.406-9.012-5.001-13.244-22.454-19.768-35.227-13.663-2.429 1.161-4.834 2.729-7.526 2.689-1.918-0.028-4.238-0.746-5.476 0.719-0.526 0.622-0.661 1.474-0.776 2.28-2.935 20.588-6.668 71.993 27.886 53.276z",
    fill: "#d18f00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24-0",
    d: "m356.42 1256.7c2.367-2.59 9.096-8.144 9.494-11.757 0.486-4.414-2.693-5.055-4.468-9.102-3.482-7.939-5.075-17.787-10.628-24.619-5.227-6.429-14.492-8.986-22.491-6.83-8 2.156-14.528 8.625-17.474 16.369-0.187 0.492-0.364 1.022-0.247 1.535 0.497 2.194 5.412 2.259 4.347 4.241-5.185 2.115-10.757 4.563-13.466 9.464-4.023 7.279 0.553 16.974 7.76 21.125 1.833 1.056 3.854 1.889 5.312 3.422 1.004 1.057 1.688 2.398 2.763 3.382 4.026 3.686 10.395 0.562 14.834-2.614 1.919 4.554 8.042 6.018 12.717 4.418 1.086-0.372 2.106-0.871 3.081-1.45 0.47-0.314 0.942-0.622 1.414-0.924 2.608-1.852 4.877-4.279 7.052-6.66z",
    fill: "#d18f00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g27-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path25-1",
    d: "m347.95 1264.2c0.484-0.287 0.953-0.598 1.414-0.924-0.473 0.302-0.945 0.61-1.414 0.924z",
    fill: "#d18f00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26-7",
    d: "m259.81 1168.8c3.471 1.831 7.321 2.797 11.128 3.748 2.967 0.741 6.821 1.148 8.407-1.468 0.407-0.672 0.584-1.455 0.907-2.172 0.618-1.37 1.74-2.436 2.614-3.658 3.843-5.375 1.85-13.84-3.831-17.214-1.08-0.641-2.312-1.168-2.995-2.223-0.487-0.752-0.809-1.838-1.699-1.939-0.378-0.043-0.743 0.126-1.086 0.29-8.75 4.2-29.668 16.079-13.445 24.636z",
    fill: "#f9d189"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g29-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path27-7",
    d: "m252.14 1157.5c1.839-0.956 1.263-2.356 2.374-4.094 2.178-3.41 5.588-6.581 6.799-10.508 1.14-3.695-0.27-7.954-3.181-10.499-0.84-0.735-1.796-1.312-2.811-1.765l-2.184-0.645-5.231 27.438c1.603 0.31 3.34 0.537 4.234 0.073z",
    fill: "#f9d189"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28-2",
    d: "m250.99 1188.7c1.085-3.417-0.309-7.095-0.245-10.679 0.033-1.906 0.483-3.784 0.545-5.691 0.148-4.555-2.165-5.626-5.234-5.218l-5.538 29.045c1.685-0.373 3.344-0.84 4.895-1.588 2.498-1.207 4.737-3.224 5.577-5.869z",
    fill: "#f9d189"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path29-5",
    d: "m269.63 1198.7c2.033-0.836 2.746-3.301 3.209-5.45 0.739-3.435 1.471-7.059 0.4-10.405-1.084-3.385-3.85-5.944-6.7-8.067-2.642-1.968-8.899-7.485-12.433-4.897-2.59 1.896-1.543 9.195-1.499 12.107 0.119 7.749 6.023 15.036 13.579 16.759 1.137 0.26 2.365 0.398 3.444-0.047z",
    fill: "#f9d189"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect31",
    transform: "matrix(.8664 .4993 -.4993 .8664 412.39 -340.54)",
    x: 633.72,
    y: 448.56,
    width: 418,
    height: 304,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect32",
    transform: "matrix(.8664 .4993 -.4993 .8664 412.03 -340.9)",
    x: 657.22,
    y: 470.69,
    width: 372,
    height: 258,
    fill: "#fff6e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g38-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect34-5",
    transform: "matrix(.9612 .2758 -.2758 .9612 211.06 -192.57)",
    x: 581.32,
    y: 502.22,
    width: 418,
    height: 304,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect35",
    transform: "matrix(.9612 .2758 -.2758 .9612 210.8 -192.69)",
    x: 604.59,
    y: 524.26,
    width: 372,
    height: 258,
    fill: "#fff6e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g39"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon37",
    points: "956.5 753.34 598.07 649.84 576 725.84 934 828.84",
    fill: "#6596c1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path38-3",
    d: "m782 593.84-178.28 36.327-14.808 51.615s38.092 15.058 119.09 36.058 115 22 102 4c-6.712-9.293 15.897-5.258 39.339 0.819l-35.339-68.819z",
    fill: "#787648"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path39-3",
    d: "m843 649.84-29 4 35.339 68.819c21.965 5.693 44.661 13.181 44.661 13.181z",
    fill: "#53594d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path41-7",
    d: "m909 579.84s-66-20-66 0 41 11 66 40 33 24 55 25 12-19 6-23 8-4 17-7-11-13-78-35z",
    fill: "#cee0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42-1",
    d: "m778 558.84s-73-33-86-28 3.568 20.995-35.216 14.998c-38.784-5.998-25.784 3.002 18.216 18.002s126 28 103 14 17-11 0-19z",
    fill: "#cee0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g45-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path43-11",
    d: "m772.54 532.17s4.099-7.378 38.53 4.099 77.681 28.129 40.89 23.082-21.215 16.268-62.205-0.128-50.826-29.512-17.215-27.053z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path44-3",
    d: "m840.54 639.17s4.099-7.378 38.53 4.099 77.681 28.129 40.89 23.082-21.215 16.268-62.205-0.128-50.826-29.512-17.215-27.053z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48-1",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "g47-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path45-1",
    d: "m1033.1 565.86-0.099-0.019s-122 234.46-459.96 184.18l376.26 107.94z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g49"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon47",
    points: "808.32 816.5 821.46 851.83 893 911.84 904.26 1200.8 1059.4 1134.7 980.33 902.4 1027.3 831.54 1002.2 768.98 942.68 745.88 925.9 773.95 965 802.84 923 850.84",
    fill: "#ebceb1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g51",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "g50"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon48",
    points: "1047 558.84 989.03 763.86 977.57 759.41 1033 565.84 679.95 464.42"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "m436.24 1237.5c-7.32-2.098-15.171-0.215-22.346 2.336-6.652 2.365-23.927 6.943-23.523 16.322 0.205 4.747 7.065 9.469 13.016 13.052h41.576l0.817-26.593c-2.89-2.255-6.019-4.107-9.54-5.117z",
    fill: "#d18f00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g53-0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path51",
    d: "m365.57 1258.4c-4.392-1.526-10.373 1.171-16.207 4.899-0.461 0.327-0.93 0.637-1.414 0.924-2.4 1.604-4.741 3.335-6.919 4.98h32.012c-0.591-4.97-2.607-9.113-7.472-10.803z",
    fill: "#d18f00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "m378.05 1269.2h22.09c-1.904-1.644-3.756-3.357-5.801-4.823-8.666-6.206-13.429-2.247-16.289 4.823z",
    fill: "#d18f00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path53",
    d: "m952.98 1266.1c-0.521-9.373-18.163-12.229-25.014-13.928-7.391-1.832-15.39-2.933-22.468-0.125-3.405 1.351-6.336 3.502-8.99 6.031l1.443 11.1h54.37c0.467-1.042 0.715-2.074 0.659-3.078z",
    fill: "#cc9d37"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g57"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon55",
    points: "1120 1269.8 1077.1 1127.1 889.38 1203.3 898 1269.8",
    fill: "#ad6f5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "m947.17 1255.1c-7.751-3.258-14.586-8.318-21.338-13.328-5.262-3.906-11.177-9.734-9.001-15.915 0.559-1.588 1.616-2.946 2.362-4.455 1.428-2.886 1.667-6.194 2.503-9.304 3.674-13.672 20.4-21.882 33.711-17.063 2.531 0.916 5.079 2.24 7.754 1.936 1.906-0.217 4.144-1.159 5.52 0.177 0.584 0.567 0.802 1.402 0.996 2.193 4.947 20.197 13.72 70.985-22.507 55.759z",
    fill: "#cc9d37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path57",
    d: "m995.99 1270c-0.51-0.238-1.008-0.501-1.498-0.781 0.5 0.254 1 0.515 1.498 0.781z",
    fill: "#d18f00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "m1074.3 1166.3c-3.274 2.164-7.01 3.504-10.705 4.825-2.88 1.03-6.675 1.814-8.51-0.633-0.471-0.629-0.724-1.391-1.116-2.072-0.75-1.302-1.972-2.253-2.962-3.383-4.353-4.971-3.203-13.591 2.119-17.507 1.012-0.745 2.186-1.39 2.762-2.507 0.41-0.796 0.625-1.909 1.5-2.097 0.372-0.08 0.752 0.052 1.109 0.182 9.12 3.316 31.105 13.08 15.803 23.192z",
    fill: "#f9d189"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path59",
    d: "m1080.8 1154.4c-1.924-0.77-1.489-2.22-2.765-3.841-2.503-3.179-6.208-5.999-7.8-9.788-1.498-3.565-0.514-7.942 2.132-10.761 0.764-0.814 1.658-1.483 2.623-2.033l2.109-0.856 7.906 26.79c-1.564 0.467-3.269 0.863-4.205 0.489z",
    fill: "#f9d189"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "m1085.1 1185.3c-1.416-3.294-0.391-7.09-0.807-10.651-0.221-1.893-0.853-3.719-1.102-5.61-0.596-4.518 1.601-5.812 4.696-5.707l8.369 28.359c-1.714-0.206-3.41-0.507-5.027-1.099-2.606-0.956-5.032-2.742-6.129-5.292z",
    fill: "#f9d189"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path61",
    d: "m1067.5 1197.1c-2.106-0.632-3.057-3.014-3.729-5.107-1.074-3.345-2.159-6.88-1.422-10.315 0.745-3.475 3.247-6.294 5.874-8.687 2.436-2.219 8.119-8.325 11.891-6.097 2.765 1.632 2.441 8.998 2.684 11.901 0.644 7.723-4.514 15.556-11.864 18.014-1.108 0.369-2.316 0.627-3.434 0.291z",
    fill: "#f9d189"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path65",
    d: "m1011.4 1265.5c4.73 2.724 11.376 5.205 15.019 1.142 0.973-1.085 1.521-2.487 2.417-3.638 1.3-1.669 3.229-2.698 4.949-3.929 6.764-4.84 10.364-14.939 5.644-21.787-3.178-4.611-8.964-6.498-14.332-8.093-1.255-1.867 3.63-2.416 3.909-4.648 0.065-0.522-0.162-1.032-0.397-1.503-3.694-7.416-10.827-13.212-19-14.57s-17.141 2.098-21.71 9.01c-4.854 7.345-5.47 17.303-8.154 25.545-1.368 4.203-4.468 5.153-3.55 9.498 0.751 3.557 7.995 8.422 10.605 10.766 2.215 1.989 4.515 4.003 7.041 5.55h15.364c1.002-0.896 1.782-2.009 2.195-3.343z",
    fill: "#cc9d37"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "link-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect46-7",
    x: 135.42,
    y: 88.797,
    width: 28.235,
    height: 36.097,
    ry: 3.2166,
    fill: "#08a",
    stroke: "#5fd",
    strokeWidth: 0.849
  }), /*#__PURE__*/React.createElement("g", {
    id: "g108",
    transform: "matrix(.050953 0 0 .050953 137 97.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1-7",
    d: "m104.48 141.79c62.724-62.429 148.86-85.357 214.79-78.503 75.357 7.834 127.9 55.959 141.86 121.06 0.962 4.484 1.743 9.058 2.327 13.718 3.693 29.446-0.7 62.456-14.732 96.181-55.346 133.01-221.22 162.47-313.66 133.41-101.37-31.869-147.91-169.1-30.589-285.87z",
    fill: "#dfe6ee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2-8",
    d: "m173.32 80.081c-0.078-2.841-0.153-5.682-0.238-8.523-9e-3 -0.302-0.143-2.197-0.378-2.402-0.22-0.457-45.264-0.035-54.112-0.098-8.687-0.062-51.971 0.116-52.218 0.12-1.156 0.021-0.948 1.348-0.975 1.348 2e-3 0.2-0.057 37.998-0.016 56.961 0.26 0.248 18.667 0.185 27.208 0.195 8.885 0.011 17.769-0.029 26.653-0.043 8.723-0.014 48.295 0.143 52.599-0.279 0.128-0.012 0.222-0.051 0.337-0.074 0.37-0.038 0.711-0.13 0.978-0.268 0.134-8.9 0.184-17.809 0.041-26.625-0.11-6.807-0.01-13.565 0.121-20.312z",
    fill: "#ffbb39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3-7",
    d: "m173.32 80.022c-0.077-2.821-0.152-5.643-0.236-8.464-9e-3 -0.302-0.143-2.197-0.378-2.402-0.22-0.457-45.264-0.035-54.112-0.098-8.687-0.062-51.971 0.116-52.218 0.12-1.156 0.021-0.948 1.348-0.975 1.348 1e-3 0.063-5e-3 3.814-0.011 9.519 6.571 0.022 18.341 0.015 24.851 0.019 9.671 5e-3 19.341-5e-3 29.011-7e-3 8.368-2e-3 42.804 0.042 54.068-0.035z",
    fill: "#b345b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4-2",
    d: "m164.9 76.12c-0.455-0.837-0.547-1.716-0.175-2.593 0.089-0.209 0.337-0.593 0.495-0.756 0.118-0.123 0.272-0.289 0.413-0.385 0.316-0.216 0.559-0.352 0.928-0.458 0.198-0.057 0.448-0.135 0.654-0.148 0.23-0.014 0.445 2e-3 0.674 0.028 0.651 0.073 1.245 0.418 1.697 0.893 0.807 0.847 1.039 2.105 0.484 3.261-0.828 1.722-2.773 2.129-4.211 1.19-0.398-0.259-0.732-0.615-0.959-1.032z",
    fill: "#ffd075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5-5",
    d: "m156.22 76.12c-0.455-0.837-0.546-1.716-0.175-2.593 0.089-0.209 0.337-0.593 0.495-0.756 0.118-0.123 0.272-0.289 0.413-0.385 0.316-0.216 0.559-0.352 0.928-0.458 0.198-0.057 0.449-0.135 0.654-0.148 0.23-0.014 0.445 2e-3 0.674 0.028 0.651 0.073 1.245 0.418 1.697 0.893 0.807 0.847 1.039 2.105 0.484 3.261-0.827 1.722-2.773 2.129-4.211 1.19-0.398-0.259-0.732-0.615-0.959-1.032z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6-0",
    d: "m147.55 76.12c-0.455-0.837-0.547-1.716-0.175-2.593 0.089-0.209 0.337-0.593 0.495-0.756 0.118-0.123 0.272-0.289 0.413-0.385 0.316-0.216 0.559-0.352 0.928-0.458 0.198-0.057 0.449-0.135 0.654-0.148 0.23-0.014 0.445 2e-3 0.674 0.028 0.651 0.073 1.245 0.418 1.697 0.893 0.807 0.847 1.039 2.105 0.484 3.261-0.827 1.722-2.773 2.129-4.211 1.19-0.398-0.259-0.732-0.615-0.959-1.032z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7-6",
    d: "m167.42 92.688c-0.07-1.761-0.137-3.521-0.213-5.282-8e-3 -0.187-0.128-1.361-0.337-1.488-0.196-0.284-40.312-0.026-48.192-0.065-7.737-0.039-46.285 0.067-46.505 0.07-1.029 0.013-0.844 0.835-0.868 0.835 2e-3 0.124-0.048 23.548-0.01 35.3 0.232 0.154 16.624 0.116 24.231 0.123 7.913 7e-3 15.825-0.017 23.737-0.025 7.769-8e-3 43.011 0.092 46.844-0.169 0.114-8e-3 0.197-0.032 0.3-0.046 0.329-0.024 0.633-0.081 0.871-0.166 0.119-5.516 0.162-11.037 0.035-16.5-0.097-4.218-9e-3 -8.406 0.107-12.587z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "text7",
    transform: "translate(81.713 110.83)",
    fill: "#4c5980",
    fontFamily: "Rubik-Medium",
    fontSize: "19.493px"
  }, "{...}/&lt;...&gt;"))), /*#__PURE__*/React.createElement("g", {
    id: "g33-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8-6",
    d: "m191.99 286.93c-0.096-9.387-0.188-18.773-0.293-28.161-0.011-0.997-0.179-7.258-0.473-7.936-0.276-1.511-56.73-0.09-67.819-0.292-10.887-0.199-65.136 0.413-65.445 0.428-1.448 0.069-1.189 4.455-1.223 4.453 3e-3 0.662-0.095 125.55-0.055 188.21 0.326 0.821 23.395 0.599 34.099 0.628 11.135 0.03 22.27-0.106 33.405-0.159 10.933-0.053 60.528 0.443 65.923-0.955 0.16-0.041 0.278-0.17 0.422-0.244 0.464-0.127 0.891-0.431 1.226-0.887 0.174-29.408 0.241-58.845 0.068-87.975-0.131-22.491-3e-3 -44.82 0.165-67.112z",
    fill: "#4c5980"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9-3",
    d: "m191.74 262.53c-0.014-1.252-0.025-2.505-0.039-3.757-0.011-0.997-0.178-7.258-0.473-7.936-0.276-1.511-56.73-0.09-67.819-0.292-10.888-0.199-65.136 0.413-65.445 0.428-1.448 0.069-1.189 4.455-1.223 4.453 0 0.093-1e-3 2.639-4e-3 7.119 8.374 0.022 22.831 0.016 30.89 0.02 12.202 6e-3 24.404-4e-3 36.605-6e-3 10.386-1e-3 52.596 0.046 67.508-0.029z",
    fill: "#b345b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10-4",
    d: "m181.79 257.75c-0.456-0.837-0.547-1.716-0.175-2.593 0.089-0.209 0.337-0.593 0.495-0.757 0.118-0.123 0.272-0.289 0.413-0.385 0.316-0.216 0.559-0.352 0.928-0.458 0.198-0.057 0.449-0.135 0.654-0.148 0.23-0.014 0.445 2e-3 0.674 0.028 0.651 0.073 1.245 0.418 1.697 0.893 0.807 0.847 1.039 2.105 0.484 3.261-0.828 1.722-2.773 2.129-4.211 1.19-0.397-0.258-0.732-0.614-0.959-1.031z",
    fill: "#ffd075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11-3",
    d: "m173.11 257.75c-0.455-0.837-0.546-1.716-0.175-2.593 0.089-0.209 0.337-0.593 0.495-0.757 0.118-0.123 0.272-0.289 0.413-0.385 0.316-0.216 0.559-0.352 0.927-0.458 0.198-0.057 0.449-0.135 0.654-0.148 0.23-0.014 0.445 2e-3 0.674 0.028 0.651 0.073 1.245 0.418 1.697 0.893 0.807 0.847 1.039 2.105 0.484 3.261-0.827 1.722-2.773 2.129-4.211 1.19-0.396-0.258-0.731-0.614-0.958-1.031z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12-1",
    d: "m164.44 257.75c-0.456-0.837-0.547-1.716-0.175-2.593 0.089-0.209 0.337-0.593 0.495-0.757 0.118-0.123 0.272-0.289 0.413-0.385 0.316-0.216 0.559-0.352 0.928-0.458 0.198-0.057 0.448-0.135 0.654-0.148 0.23-0.014 0.445 2e-3 0.674 0.028 0.651 0.073 1.245 0.418 1.697 0.893 0.807 0.847 1.039 2.105 0.484 3.261-0.827 1.722-2.773 2.129-4.211 1.19-0.397-0.258-0.732-0.614-0.959-1.031z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g32-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13-5",
    d: "m117.78 271.89c-6.645 0.189-22.036 0.092-25.974 0.104-4.873 0.014-9.747 0.053-14.621 0.043-2.921-6e-3 -7.939 0.016-11.342-0.024-0.167 0.376-0.12 0.998-0.13 0.998 0 0.037-1e-3 1.412-3e-3 3.73 3.297 0.054 8.743 0.028 11.814 0.034 4.761 9e-3 9.521-0.029 14.282-0.043 4.007-0.012 20.164 0.093 26.146-0.129-0.012-0.874-0.024-1.748-0.037-2.623-3e-3 -0.243-0.051-1.575-0.135-2.09z",
    fill: "#d66ec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14-3",
    d: "m102.97 285.54c-3.188 0.189-10.571 0.092-12.46 0.104-2.338 0.014-4.676 0.053-7.014 0.043-1.401-6e-3 -3.808 0.016-5.441-0.024-0.08 0.376-0.058 0.998-0.062 0.998 0 0.037 0 1.412-1e-3 3.73 1.581 0.053 4.194 0.028 5.667 0.034 2.284 0.01 4.567-0.029 6.851-0.043 1.922-0.012 9.673 0.093 12.542-0.129-6e-3 -0.874-0.011-1.748-0.018-2.623-1e-3 -0.243-0.024-1.575-0.064-2.09z",
    fill: "#ffd075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15-9",
    d: "m122.16 421.96c-5.637 0.189-18.693 0.092-22.034 0.104-4.134 0.014-8.268 0.053-12.403 0.043-2.477-6e-3 -6.734 0.016-9.622-0.024-0.141 0.376-0.102 0.998-0.11 0.998 0 0.037-1e-3 1.412-2e-3 3.73 2.797 0.053 7.417 0.028 10.022 0.034 4.039 9e-3 8.077-0.029 12.115-0.043 3.4-0.012 17.106 0.093 22.18-0.129-0.01-0.874-0.02-1.748-0.032-2.623-2e-3 -0.244-0.042-1.576-0.114-2.09z",
    fill: "#ffd075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16-6",
    d: "m122.8 285.54c-2.15 0.189-7.131 0.092-8.405 0.104-1.577 0.014-3.154 0.053-4.731 0.043-0.945-6e-3 -2.569 0.016-3.671-0.024-0.054 0.376-0.039 0.998-0.042 0.998 0 0.037 0 1.412-1e-3 3.73 1.067 0.053 2.829 0.028 3.823 0.034 1.541 0.01 3.081-0.029 4.622-0.043 1.297-0.012 6.525 0.093 8.461-0.129-4e-3 -0.874-8e-3 -1.748-0.012-2.623-1e-3 -0.243-0.017-1.575-0.044-2.09z",
    fill: "#7991d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17-8",
    d: "m134.3 340.68c-3.188 0.189-10.571 0.092-12.46 0.104-2.338 0.014-4.676 0.053-7.014 0.043-1.401-6e-3 -3.808 0.016-5.441-0.024-0.08 0.376-0.058 0.998-0.062 0.998 0 0.037-1e-3 1.412-1e-3 3.73 1.581 0.053 4.194 0.028 5.667 0.034 2.284 0.01 4.567-0.029 6.851-0.043 1.922-0.012 9.673 0.093 12.542-0.129-6e-3 -0.874-0.011-1.748-0.018-2.623-1e-3 -0.243-0.024-1.575-0.064-2.09z",
    fill: "#ffd075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18-3",
    d: "m154.13 340.68c-2.15 0.189-7.131 0.092-8.405 0.104-1.577 0.014-3.154 0.053-4.731 0.043-0.945-6e-3 -2.569 0.016-3.67-0.024-0.054 0.376-0.039 0.998-0.042 0.998 0 0.037 0 1.412-1e-3 3.73 1.067 0.053 2.829 0.028 3.823 0.034 1.541 0.01 3.081-0.029 4.622-0.043 1.297-0.012 6.525 0.093 8.461-0.129-4e-3 -0.874-8e-3 -1.748-0.012-2.623-2e-3 -0.243-0.018-1.575-0.045-2.09z",
    fill: "#7991d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19-9",
    d: "m131.09 381.84c-2.15 0.189-7.131 0.092-8.405 0.104-1.577 0.014-3.154 0.053-4.731 0.043-0.945-6e-3 -2.569 0.016-3.67-0.024-0.054 0.376-0.039 0.998-0.042 0.998 0 0.037 0 1.412-1e-3 3.73 1.067 0.053 2.829 0.028 3.823 0.034 1.541 9e-3 3.081-0.029 4.622-0.043 1.297-0.012 6.525 0.093 8.461-0.129-4e-3 -0.874-8e-3 -1.748-0.012-2.623-3e-3 -0.243-0.018-1.576-0.045-2.09z",
    fill: "#7991d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20-1",
    d: "m131.09 390.77c-2.15 0.189-7.131 0.092-8.405 0.104-1.577 0.014-3.154 0.053-4.731 0.043-0.945-6e-3 -2.569 0.016-3.67-0.024-0.054 0.376-0.039 0.998-0.042 0.998 0 0.037 0 1.412-1e-3 3.73 1.067 0.054 2.829 0.028 3.823 0.034 1.541 9e-3 3.081-0.029 4.622-0.043 1.297-0.012 6.525 0.093 8.461-0.129-4e-3 -0.874-8e-3 -1.748-0.012-2.623-3e-3 -0.243-0.018-1.576-0.045-2.09z",
    fill: "#7991d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21-46",
    d: "m156.82 285.54c-3.925 0.189-13.016 0.092-15.342 0.104-2.879 0.014-5.757 0.053-8.636 0.043-1.725-6e-3 -4.689 0.016-6.7-0.024-0.098 0.376-0.071 0.998-0.076 0.998 0 0.037-1e-3 1.412-2e-3 3.73 1.947 0.053 5.164 0.028 6.978 0.034 2.812 0.01 5.624-0.029 8.436-0.043 2.367-0.012 11.91 0.093 15.444-0.129-7e-3 -0.874-0.014-1.748-0.022-2.623-2e-3 -0.243-0.03-1.575-0.08-2.09z",
    fill: "#7991d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22-6",
    d: "m170.49 299.26c-9.016 0.203-29.896 0.099-35.238 0.112-6.612 0.015-13.223 0.057-19.836 0.046-3.962-6e-3 -10.77 0.017-15.388-0.025-0.226 0.404-0.163 1.073-0.176 1.073 0 0.039-1e-3 1.517-3e-3 4.007 4.472 0.058 11.862 0.03 16.028 0.036 6.459 0.01 12.917-0.031 19.376-0.046 5.437-0.013 27.356 0.1 35.471-0.139-0.017-0.939-0.032-1.878-0.051-2.818-4e-3 -0.262-0.069-1.693-0.183-2.246z",
    fill: "#ffd075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23-1",
    d: "m170.49 308.58c-9.016 0.203-29.896 0.099-35.238 0.112-6.612 0.015-13.223 0.057-19.836 0.046-3.962-6e-3 -10.77 0.017-15.388-0.025-0.226 0.404-0.163 1.073-0.176 1.072 0 0.039-1e-3 1.517-3e-3 4.007 4.472 0.057 11.862 0.03 16.028 0.036 6.459 0.01 12.917-0.031 19.376-0.046 5.437-0.013 27.356 0.1 35.471-0.139-0.017-0.939-0.032-1.879-0.051-2.818-4e-3 -0.26-0.069-1.692-0.183-2.245z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24-6",
    d: "m152.68 317.9c-6.743 0.203-22.361 0.099-26.357 0.112-4.945 0.015-9.891 0.057-14.837 0.047-2.964-6e-3 -8.056 0.017-11.51-0.026-0.169 0.404-0.122 1.073-0.132 1.073 0 0.039-1e-3 1.517-3e-3 4.007 3.345 0.057 8.872 0.03 11.988 0.036 4.831 0.01 9.662-0.031 14.493-0.046 4.067-0.013 20.462 0.1 26.532-0.139-0.013-0.939-0.024-1.878-0.038-2.818-2e-3 -0.261-0.051-1.693-0.136-2.246z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25-7",
    d: "m152.68 410.84c-6.743 0.203-22.361 0.099-26.357 0.112-4.945 0.015-9.891 0.057-14.837 0.046-2.964-6e-3 -8.056 0.017-11.51-0.025-0.169 0.404-0.122 1.073-0.132 1.072 0 0.04-1e-3 1.517-3e-3 4.007 3.345 0.057 8.872 0.03 11.988 0.036 4.831 0.01 9.662-0.031 14.493-0.046 4.067-0.013 20.462 0.1 26.532-0.139-0.013-0.939-0.024-1.878-0.038-2.818-2e-3 -0.261-0.051-1.693-0.136-2.245z",
    fill: "#ffd075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26-5",
    d: "m184.72 353.89c-9.016 0.203-29.895 0.099-35.238 0.112-6.612 0.015-13.223 0.057-19.836 0.046-3.962-6e-3 -10.77 0.017-15.388-0.025-0.226 0.404-0.163 1.073-0.176 1.072 0 0.04-1e-3 1.517-4e-3 4.007 4.472 0.058 11.862 0.03 16.028 0.036 6.459 0.01 12.917-0.031 19.376-0.046 5.437-0.013 27.356 0.1 35.471-0.139-0.017-0.939-0.033-1.878-0.051-2.818-3e-3 -0.261-0.067-1.692-0.182-2.245z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27-6",
    d: "m184.72 363.2c-9.016 0.203-29.895 0.099-35.238 0.112-6.612 0.015-13.223 0.057-19.836 0.046-3.962-6e-3 -10.77 0.017-15.388-0.025-0.226 0.404-0.163 1.073-0.176 1.072 0 0.039-1e-3 1.517-4e-3 4.007 4.472 0.057 11.862 0.03 16.028 0.036 6.459 0.01 12.917-0.031 19.376-0.047 5.437-0.013 27.356 0.1 35.471-0.139-0.017-0.939-0.033-1.878-0.051-2.818-3e-3 -0.259-0.067-1.691-0.182-2.244z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28-8",
    d: "m166.92 372.52c-6.743 0.203-22.361 0.099-26.357 0.112-4.945 0.015-9.891 0.057-14.837 0.046-2.964-6e-3 -8.056 0.017-11.51-0.025-0.169 0.404-0.122 1.073-0.131 1.072 0 0.039-1e-3 1.517-3e-3 4.007 3.345 0.057 8.872 0.03 11.988 0.036 4.831 0.01 9.662-0.031 14.493-0.046 4.067-0.013 20.462 0.1 26.532-0.139-0.013-0.939-0.024-1.879-0.038-2.818-4e-3 -0.26-0.052-1.692-0.137-2.245z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29-4",
    d: "m142.09 399.51c-3.574 0.203-11.852 0.099-13.969 0.112-2.621 0.015-5.242 0.057-7.863 0.046-1.571-6e-3 -4.27 0.017-6.1-0.025-0.09 0.404-0.065 1.073-0.07 1.072 0 0.04 0 1.517-1e-3 4.007 1.773 0.058 4.702 0.03 6.354 0.036 2.561 0.01 5.121-0.031 7.681-0.046 2.155-0.013 10.845 0.1 14.062-0.139-7e-3 -0.939-0.013-1.878-0.02-2.818-3e-3 -0.26-0.029-1.692-0.074-2.245z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30-0",
    d: "m178.37 399.51c-4.33 0.203-14.359 0.099-16.925 0.112-3.176 0.015-6.351 0.057-9.527 0.046-1.903-6e-3 -5.173 0.017-7.391-0.025-0.108 0.404-0.078 1.073-0.084 1.072 0 0.04-1e-3 1.517-2e-3 4.007 2.148 0.058 5.697 0.03 7.698 0.036 3.102 0.01 6.204-0.031 9.306-0.046 2.611-0.013 13.139 0.1 17.037-0.139-8e-3 -0.939-0.016-1.878-0.024-2.818-3e-3 -0.26-0.034-1.692-0.088-2.245z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31-3",
    d: "m79.827 404.05c-0.022-3.845-0.045-7.69-0.067-11.534-0.045-7.69-0.089-15.379-0.134-23.069-0.09-15.546-0.181-31.093-0.272-46.639-0.052-8.86-0.103-17.72-0.141-26.579-2e-3 -0.56-0.874-0.561-0.87 0 0.212 31.092 0.346 62.186 0.514 93.278 0.023 4.346 0.047 8.693 0.07 13.039 0.024 4.481-0.2 9.081 0.263 13.54 0.034 0.331 0.486 0.334 0.517 0 0.367-3.97 0.143-8.051 0.12-12.036z",
    fill: "#7991d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32-8",
    d: "m101.32 345.05c0.038-5.572 0.095-11.145 0.094-16.717 0-0.514-0.791-0.525-0.799-0.01-0.3 19.707-0.322 39.422-0.459 59.131-0.039 5.573-0.11 11.145-0.048 16.717 5e-3 0.438 0.67 0.448 0.682 8e-3 0.514-19.695 0.394-39.426 0.53-59.129z",
    fill: "#7991d1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g50-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g39-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "m442.53 171.63c-0.187-9.809-0.368-19.618-0.573-29.428-0.022-1.042-0.346-7.584-0.915-8.293-0.533-1.579-109.52-0.109-130.92-0.323-21.018-0.211-125.75 0.415-126.34 0.431-2.796 0.072-2.294 4.655-2.359 4.653 5e-3 0.691-0.15 131.2-0.057 196.68 0.63 0.858 108.82 0.56 130.32 0.508 21.106-0.052 116.85 0.478 127.27-0.98 0.31-0.043 0.536-0.178 0.815-0.255 0.895-0.133 1.72-0.45 2.367-0.927 0.328-30.731 0.45-61.491 0.108-91.932-0.264-23.502-0.021-46.835 0.297-70.13z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34-2",
    d: "m311.65 145.62c19.604-0.052 94.007 0.358 130.37-0.379-0.021-1.014-0.038-2.027-0.059-3.041-0.022-1.041-0.346-7.584-0.914-8.293-0.533-1.579-109.52-0.109-130.92-0.323-21.019-0.211-125.75 0.415-126.34 0.431-2.796 0.072-2.294 4.655-2.359 4.653 1e-3 0.093-2e-3 2.562-6e-3 6.893 37.96 0.321 111.66 0.106 130.24 0.059z",
    fill: "#b345b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35-2",
    d: "m441.74 204.74c-0.018 16.884-0.028 33.767-0.039 50.65s-0.011 33.767 7e-3 50.65c0.01 9.316-0.147 18.653 0.11 27.966-11.634 0.499-23.297 0.922-34.91 1.788-0.305 0.023-0.314 0.485 0 0.482 11.639-0.131 23.289-0.707 34.918-1.206 0.092-4e-3 0.169-0.029 0.236-0.065 0.208 0.073 0.482-0.036 0.492-0.327 0.271-8.469 0.147-16.959 0.174-25.432 0.027-8.406 0.044-16.812 0.057-25.218 0.026-16.883 0.13-33.767 0.108-50.65-0.012-9.546 0.021-19.092 0.031-28.638 1e-3 -0.762-1.183-0.763-1.184 0z",
    fill: "#d5dfe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36-1",
    d: "m442.76 156.79c-0.048-0.636-1.02-0.653-1.004 0 0.168 6.633 0.468 13.251 0.464 19.889-4e-3 6.632-0.196 13.263-0.472 19.889-0.028 0.674 1.005 0.667 1.044 0 0.387-6.623 0.535-13.255 0.526-19.889-7e-3 -6.619-0.057-13.286-0.558-19.889z",
    fill: "#d5dfe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37-7",
    d: "m431.9 141.04c-0.389-0.714-0.466-1.465-0.149-2.214 0.076-0.179 0.288-0.506 0.423-0.646 0.101-0.105 0.232-0.247 0.352-0.329 0.27-0.185 0.477-0.301 0.792-0.391 0.169-0.048 0.383-0.115 0.558-0.126 0.196-0.012 0.38 2e-3 0.575 0.024 0.556 0.062 1.063 0.357 1.449 0.762 0.689 0.723 0.887 1.797 0.413 2.784-0.706 1.47-2.367 1.818-3.595 1.016-0.338-0.22-0.624-0.524-0.818-0.88z",
    fill: "#ffd075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38-4",
    d: "m424.5 141.04c-0.389-0.714-0.466-1.465-0.149-2.214 0.076-0.179 0.288-0.506 0.423-0.646 0.101-0.105 0.232-0.247 0.352-0.329 0.27-0.185 0.478-0.301 0.792-0.391 0.169-0.048 0.383-0.115 0.558-0.126 0.196-0.012 0.38 2e-3 0.575 0.024 0.556 0.062 1.063 0.357 1.449 0.762 0.689 0.723 0.887 1.797 0.413 2.784-0.706 1.47-2.367 1.818-3.595 1.016-0.338-0.22-0.624-0.524-0.818-0.88z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39-1",
    d: "m417.1 141.04c-0.389-0.714-0.467-1.465-0.149-2.214 0.076-0.179 0.288-0.506 0.423-0.646 0.101-0.105 0.232-0.247 0.352-0.329 0.27-0.185 0.478-0.301 0.792-0.391 0.169-0.048 0.383-0.115 0.558-0.126 0.196-0.012 0.38 2e-3 0.575 0.024 0.556 0.062 1.063 0.357 1.449 0.762 0.689 0.723 0.887 1.797 0.413 2.784-0.706 1.47-2.367 1.818-3.595 1.016-0.339-0.22-0.625-0.524-0.818-0.88z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g49-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g48-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g41-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40-8",
    d: "m209.3 182.74v-11.452c0-0.754 0.7-1.166 1.335-1.175 4.781-0.069 9.563-0.138 14.344-0.208 4.502-0.065 9.003-0.13 13.504-0.196 2.97 3.605 5.405 7.725 6.582 12.571-9.004 1.044-18.057 1.315-27.1 1.585-2.812 0.084-5.674 0.161-8.382-0.742-0.069-0.275-0.283-0.095-0.283-0.383z",
    fill: "#ffbb39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41-31",
    d: "m296.4 233.54c0.249-15.957 0.072-31.639-0.087-47.486-0.016-1.554-2e-3 -3.198-0.676-4.486s-2.205-1.485-3.409-1.511c-26.813-0.571-53.637-0.319-80.441 0.757-0.869 0.035-1.72-8e-3 -2.447 0.607s-0.629 1.25-0.598 2.907l0.693 51.069c0.034 2.504 2.302 4.148 4.244 4.145 26.19-0.038 52.538-1.67 78.728-1.708 1.034-2e-3 2.138-0.03 2.993-0.781 0.854-0.75 1.168-1.925 1-3.513z",
    fill: "#eb9921"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g43-0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42-7",
    d: "m325.65 182.74v-11.452c0-0.754 0.7-1.166 1.335-1.175 4.781-0.069 9.563-0.138 14.344-0.208 4.502-0.065 9.003-0.13 13.504-0.196 2.97 3.605 5.405 7.725 6.582 12.571-9.004 1.044-18.057 1.315-27.1 1.585-2.812 0.084-5.674 0.161-8.382-0.742-0.069-0.275-0.283-0.095-0.283-0.383z",
    fill: "#ffbb39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43-9",
    d: "m412.74 233.54c0.249-15.957 0.071-31.639-0.087-47.486-0.016-1.554-2e-3 -3.198-0.676-4.486s-2.205-1.485-3.409-1.511c-26.813-0.571-53.637-0.319-80.441 0.757-0.869 0.035-1.72-8e-3 -2.447 0.607s-0.629 1.25-0.598 2.907l0.693 51.069c0.034 2.504 2.302 4.148 4.244 4.145 26.19-0.038 52.538-1.67 78.728-1.708 1.034-2e-3 2.138-0.03 2.993-0.781 0.853-0.75 1.168-1.925 1-3.513z",
    fill: "#eb9921"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g45-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path44-4",
    d: "m209.3 264.29v-11.452c0-0.754 0.7-1.166 1.335-1.175 4.781-0.069 9.563-0.138 14.344-0.208 4.502-0.065 9.003-0.13 13.504-0.196 2.97 3.605 5.405 7.725 6.582 12.571-9.004 1.044-18.057 1.315-27.1 1.585-2.812 0.084-5.674 0.161-8.382-0.742-0.069-0.275-0.283-0.095-0.283-0.383z",
    fill: "#ffbb39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45-17",
    d: "m296.4 315.09c0.249-15.957 0.072-31.639-0.087-47.486-0.016-1.554-2e-3 -3.198-0.676-4.486s-2.205-1.485-3.409-1.511c-26.813-0.571-53.637-0.319-80.441 0.757-0.869 0.035-1.72-8e-3 -2.447 0.607s-0.629 1.25-0.598 2.906l0.693 51.069c0.034 2.504 2.302 4.148 4.244 4.146 26.19-0.038 52.538-1.67 78.728-1.708 1.034-2e-3 2.138-0.03 2.993-0.781 0.854-0.75 1.168-1.925 1-3.513z",
    fill: "#eb9921"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g47-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "m325.65 264.29v-11.452c0-0.754 0.7-1.166 1.335-1.175 4.781-0.069 9.563-0.138 14.344-0.208 4.502-0.065 9.003-0.13 13.504-0.196 2.97 3.605 5.405 7.725 6.582 12.571-9.004 1.044-18.057 1.315-27.1 1.585-2.812 0.084-5.674 0.161-8.382-0.742-0.069-0.275-0.283-0.095-0.283-0.383z",
    fill: "#ffbb39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "m412.74 315.09c0.249-15.957 0.071-31.639-0.087-47.486-0.016-1.554-2e-3 -3.198-0.676-4.486s-2.205-1.485-3.409-1.511c-26.813-0.571-53.637-0.319-80.441 0.757-0.869 0.035-1.72-8e-3 -2.447 0.607s-0.629 1.25-0.598 2.906l0.693 51.069c0.034 2.504 2.302 4.148 4.244 4.146 26.19-0.038 52.538-1.67 78.728-1.708 1.034-2e-3 2.138-0.03 2.993-0.781 0.853-0.75 1.168-1.925 1-3.513z",
    fill: "#eb9921"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "m405.83 215.61c-0.045-0.979-0.089-1.959-0.137-2.938-5e-3 -0.104-0.07-0.757-0.17-0.826-0.095-0.157-19.136 0.224-22.876 0.249-3.673 0.024-21.97 0.311-22.075 0.314-0.488 0.013-0.395 0.47-0.406 0.47 2e-3 0.069 0.139 13.104 0.237 19.643 0.111 0.084 7.892-0.034 11.503-0.075 3.756-0.043 7.512-0.103 11.268-0.154 3.688-0.051 20.417-0.203 22.235-0.371 0.054-5e-3 0.093-0.019 0.142-0.027 0.156-0.015 0.3-0.049 0.412-0.098 0.019-3.07 1e-3 -6.143-0.097-9.182-0.075-2.347-0.062-4.678-0.036-7.005z",
    fill: "#4c5980"
  }), /*#__PURE__*/React.createElement("text", {
    id: "text48-5",
    transform: "matrix(.9999 -.0124 .0124 .9999 366.79 227.86)",
    fill: "#ffffff",
    fontFamily: "Rubik-Bold",
    fontSize: "16.64px"
  }, "SQL"))), /*#__PURE__*/React.createElement("g", {
    id: "g57-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50-9",
    d: "m145.8 234.33c0.035-6.533 0.069-13.065 0.104-19.598 1e-3 -0.204-2e-3 -0.423-0.121-0.589-0.176-0.247-0.525-0.277-0.828-0.284-0.793-0.019-1.789 0.349-2.615 0.392 0.104-0.089 0.171-0.266 0.072-0.383-0.161-0.19-0.453-0.173-0.7-0.143-5.677 0.688-11.373-0.66-17.046-1.382-8.292-1.055-16.699-0.771-25.029-0.087-5.521 0.454-11.073 1.092-16.341 2.805-0.309 0.1-0.635 0.217-0.837 0.472-0.229 0.291-0.243 0.691-0.245 1.061-0.052 6.19-0.046 12.381 0.012 18.572-0.093 0.362-0.103 0.744 6e-3 1.142 0.667 2.449 6.165 2.877 8.314 3.055 4.649 0.386 9.367 0.371 14.029 0.351 9.282-0.041 18.553-0.547 27.818-1.053 4.209-0.23 8.589-0.507 12.26-2.578 0.489-0.276 0.998-0.63 1.147-1.171 0.055-0.203 0.043-0.396 0-0.582z",
    fill: "#d66ec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51-5",
    d: "m82.387 216.33c-0.524-1.922 1.598-3.48 3.471-4.164 3.872-1.415 8.019-1.883 12.129-2.204 12.814-0.999 25.732-0.663 38.476 1.002 2.615 0.342 5.253 0.747 7.696 1.739 0.971 0.395 2.073 1.22 1.795 2.23-0.149 0.541-0.658 0.895-1.147 1.171-3.671 2.071-8.05 2.348-12.259 2.578-9.266 0.506-18.537 1.012-27.819 1.053-4.662 0.02-9.38 0.035-14.029-0.351-2.149-0.177-7.646-0.605-8.313-3.054z",
    fill: "#eba7dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52-0",
    d: "m144.74 212.73c0.035-6.533 0.07-13.066 0.105-19.598 1e-3 -0.204-2e-3 -0.423-0.116-0.589-0.169-0.246-0.504-0.277-0.796-0.284-0.762-0.019-1.72 0.35-2.514 0.392 0.1-0.089 0.164-0.266 0.069-0.383-0.154-0.19-0.435-0.172-0.672-0.142-5.458 0.689-10.934-0.657-16.387-1.377-7.971-1.052-16.054-0.767-24.063-0.08-5.308 0.455-10.646 1.095-15.711 2.81-0.297 0.101-0.611 0.217-0.804 0.473-0.22 0.291-0.233 0.691-0.236 1.061-0.052 6.19-0.048 12.381 6e-3 18.572-0.089 0.362-0.099 0.744 5e-3 1.142 0.641 2.449 5.926 2.875 7.992 3.053 4.47 0.384 9.006 0.368 13.487 0.346 8.924-0.043 17.837-0.552 26.745-1.061 4.047-0.231 8.258-0.51 11.787-2.582 0.47-0.276 0.96-0.63 1.103-1.171 0.052-0.204 0.041-0.396 0-0.582z",
    fill: "#b345b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53-7",
    d: "m145.98 210.35c0.034-6.533 0.069-13.065 0.103-19.598 1e-3 -0.204-2e-3 -0.423-0.121-0.589-0.176-0.247-0.525-0.277-0.828-0.284-0.793-0.019-1.789 0.349-2.615 0.392 0.104-0.089 0.171-0.266 0.072-0.383-0.16-0.19-0.452-0.173-0.699-0.143-5.677 0.688-11.373-0.66-17.046-1.382-8.292-1.055-16.699-0.771-25.029-0.087-5.521 0.454-11.073 1.092-16.341 2.805-0.309 0.1-0.635 0.217-0.837 0.472-0.229 0.291-0.243 0.691-0.246 1.061-0.052 6.19-0.046 12.381 0.012 18.572-0.093 0.362-0.103 0.744 6e-3 1.142 0.667 2.449 6.164 2.877 8.314 3.055 4.649 0.386 9.367 0.371 14.029 0.351 9.282-0.041 18.553-0.547 27.819-1.053 4.209-0.23 8.589-0.507 12.259-2.578 0.489-0.276 0.998-0.63 1.147-1.171 0.056-0.203 0.044-0.396 1e-3 -0.582z",
    fill: "#d66ec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "m82.569 192.35c-0.524-1.922 1.598-3.48 3.471-4.164 3.872-1.415 8.019-1.883 12.129-2.204 12.814-0.999 25.731-0.663 38.476 1.002 2.615 0.342 5.253 0.747 7.696 1.739 0.971 0.395 2.073 1.22 1.795 2.23-0.148 0.541-0.658 0.895-1.147 1.171-3.671 2.071-8.05 2.348-12.26 2.578-9.266 0.506-18.537 1.012-27.818 1.053-4.662 0.02-9.38 0.035-14.029-0.351-2.148-0.178-7.645-0.605-8.313-3.054z",
    fill: "#eba7dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    d: "m144.92 188.75c0.035-6.533 0.07-13.066 0.105-19.598 1e-3 -0.204-2e-3 -0.423-0.116-0.589-0.169-0.247-0.504-0.277-0.796-0.284-0.762-0.019-1.72 0.35-2.514 0.392 0.1-0.089 0.164-0.266 0.069-0.383-0.154-0.19-0.435-0.172-0.672-0.142-5.458 0.689-10.934-0.657-16.387-1.377-7.971-1.052-16.054-0.766-24.063-0.08-5.308 0.455-10.646 1.095-15.711 2.81-0.297 0.101-0.611 0.217-0.804 0.473-0.22 0.291-0.233 0.691-0.236 1.061-0.052 6.19-0.048 12.381 6e-3 18.572-0.089 0.362-0.099 0.744 5e-3 1.142 0.641 2.449 5.926 2.875 7.992 3.053 4.47 0.384 9.006 0.368 13.487 0.347 8.923-0.044 17.837-0.553 26.745-1.061 4.047-0.231 8.258-0.51 11.787-2.582 0.47-0.276 0.96-0.63 1.103-1.171 0.052-0.205 0.041-0.398 0-0.583z",
    fill: "#b345b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56-1",
    d: "m146.17 186.37c0.035-6.533 0.069-13.066 0.104-19.598 1e-3 -0.204-2e-3 -0.423-0.121-0.589-0.176-0.247-0.525-0.277-0.828-0.284-0.793-0.019-1.789 0.349-2.615 0.392 0.104-0.089 0.171-0.266 0.072-0.383-0.161-0.19-0.453-0.173-0.7-0.143-5.677 0.688-11.373-0.66-17.046-1.382-8.292-1.055-16.699-0.771-25.029-0.087-5.521 0.454-11.073 1.092-16.341 2.805-0.309 0.101-0.635 0.217-0.837 0.472-0.229 0.291-0.243 0.691-0.245 1.061-0.052 6.19-0.046 12.381 0.012 18.571-0.093 0.362-0.103 0.744 6e-3 1.142 0.668 2.449 6.164 2.877 8.314 3.055 4.649 0.386 9.367 0.371 14.029 0.351 9.282-0.041 18.553-0.547 27.818-1.053 4.209-0.23 8.589-0.507 12.26-2.578 0.489-0.276 0.998-0.63 1.147-1.171 0.055-0.203 0.043-0.395 0-0.581z",
    fill: "#d66ec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57-4",
    d: "m82.752 168.36c-0.524-1.922 1.598-3.479 3.471-4.164 3.872-1.415 8.019-1.883 12.129-2.204 12.814-0.999 25.732-0.663 38.476 1.002 2.615 0.342 5.253 0.747 7.696 1.739 0.971 0.395 2.073 1.22 1.795 2.23-0.149 0.541-0.658 0.895-1.147 1.171-3.671 2.071-8.05 2.348-12.259 2.578-9.266 0.506-18.537 1.012-27.819 1.053-4.662 0.02-9.38 0.035-14.029-0.351-2.148-0.177-7.645-0.604-8.313-3.054z",
    fill: "#eba7dc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g71"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g62-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58-8",
    d: "m396.49 382.04c-0.107-4.56-0.21-9.12-0.326-13.68-0.013-0.484-0.197-3.526-0.519-3.855-0.302-0.734-62.1-0.054-74.237-0.154-11.918-0.099-71.301 0.189-71.639 0.196-1.586 0.033-1.301 2.164-1.338 2.163 3e-3 0.321-0.081 60.992-0.026 91.43 0.357 0.399 25.609 0.295 37.327 0.311 12.189 0.017 24.378-0.048 36.567-0.071 11.967-0.024 66.257 0.226 72.162-0.452 0.176-0.02 0.304-0.083 0.463-0.118 0.507-0.062 0.975-0.209 1.342-0.431 0.185-14.286 0.253-28.586 0.059-42.737-0.152-10.926-0.015-21.773 0.165-32.602z",
    fill: "#ffbb39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59-0",
    d: "m284.23 375.38c12.697 6e-3 25.392-2e-3 38.088-3e-3 11.896-1e-3 63.939 0.051 74.013-0.045-0.055-2.322-0.107-4.644-0.166-6.967-0.013-0.484-0.197-3.526-0.519-3.855-0.302-0.734-62.1-0.054-74.237-0.154-11.918-0.099-71.301 0.189-71.639 0.197-1.586 0.033-1.301 2.164-1.338 2.163 1e-3 0.074-3e-3 3.319-9e-3 8.634 7.346 0.032 26.063 0.025 35.807 0.03z",
    fill: "#b345b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60-2",
    d: "m387.38 371.38c-0.456-0.837-0.547-1.716-0.175-2.594 0.089-0.209 0.337-0.593 0.495-0.756 0.118-0.123 0.272-0.289 0.412-0.385 0.316-0.216 0.56-0.352 0.928-0.457 0.198-0.057 0.448-0.135 0.654-0.148 0.23-0.014 0.445 2e-3 0.674 0.027 0.651 0.073 1.245 0.418 1.697 0.893 0.807 0.847 1.039 2.105 0.484 3.261-0.828 1.722-2.773 2.129-4.211 1.19-0.397-0.258-0.732-0.614-0.958-1.031z",
    fill: "#ffd075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path61-2",
    d: "m378.7 371.38c-0.456-0.837-0.547-1.716-0.175-2.594 0.089-0.209 0.337-0.593 0.495-0.756 0.118-0.123 0.272-0.289 0.413-0.385 0.316-0.216 0.559-0.352 0.928-0.457 0.198-0.057 0.448-0.135 0.654-0.148 0.23-0.014 0.445 2e-3 0.674 0.027 0.651 0.073 1.245 0.418 1.697 0.893 0.807 0.847 1.039 2.105 0.484 3.261-0.828 1.722-2.773 2.129-4.211 1.19-0.398-0.258-0.733-0.614-0.959-1.031z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "m370.03 371.38c-0.455-0.837-0.546-1.716-0.175-2.594 0.089-0.209 0.337-0.593 0.495-0.756 0.118-0.123 0.272-0.289 0.413-0.385 0.316-0.216 0.559-0.352 0.927-0.457 0.198-0.057 0.449-0.135 0.654-0.148 0.23-0.014 0.445 2e-3 0.674 0.027 0.651 0.073 1.245 0.418 1.697 0.893 0.807 0.847 1.039 2.105 0.484 3.261-0.827 1.722-2.773 2.129-4.211 1.19-0.397-0.258-0.732-0.614-0.958-1.031z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g70-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path63",
    d: "m321.75 422.82c-4.152 0.297-8.316 0.426-12.478 0.386-0.404-4e-3 -1.007-0.014-1.055-0.415-0.401-3.4-0.393-6.847 0.023-10.245 0.029-0.238 0.063-0.485 0.189-0.689s0.226-0.244 0.466-0.241c4.243 0.062 8.488 0.016 12.728-0.139 0.041-2.05-0.026-4.319-0.148-6.366 0.579-0.521 1.557-0.046 2.163 0.444 4.363 3.526 8.751 6.697 12.195 10.731 0.89 1.043 0.239 2.155-0.694 3.16s-3.502 3.199-4.527 4.111c-1.757 1.562-4.566 4.314-7.586 6.795-0.27 0.222-0.944-0.515-0.971-0.863-0.183-2.347-0.122-4.322-0.305-6.669z",
    fill: "#4c5980"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g69-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "m298.79 398.49c-3.951-3.053-8.147-6.194-12.162-9.163-2.166-2e-3 -4.666 0.013-6.832-0.042-4.719-0.119-17.591 0.168-18.034 0.562-0.443 0.393-0.612 1.029-0.602 1.621 0.28 16.99-0.374 29.352-0.04 50.863 0.013 0.811 0.453 1.503 1.265 1.517 12.486 0.209 22.061 0.35 33.08-0.206 0.45-0.023 3.026 0.082 3.274-0.294s0.405-0.828 0.405-1.278c1e-3 -6.836-0.175-15.136-0.212-22.601-0.035-6.944 0.129-14.226-0.142-20.979z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path65-3",
    d: "m298.92 398.42c-2.559 1.176-5.082 2.431-7.564 3.762-0.438 0.235-0.882 0.475-1.369 0.578-0.486 0.103-0.913 0.126-1.304-0.181-0.882-4.389-1.542-8.823-1.975-13.279 0.726 0.208 1.485 0.435 2.119 0.846 3.507 2.274 6.81 4.864 9.854 7.728 0.175 0.166 0.458 0.445 0.239 0.546z",
    fill: "#d5dfe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "m294.88 408.1c-3.829 0.156-12.698 0.076-14.967 0.086-2.808 0.012-5.617 0.044-8.425 0.036-1.683-5e-3 -4.574 0.013-6.536-0.02-0.096 0.311-0.069 0.826-0.075 0.826 0 0.03-1e-3 1.168-1e-3 3.085 1.9 0.044 5.038 0.023 6.808 0.028 2.743 8e-3 5.487-0.024 8.23-0.036 2.309-0.01 11.62 0.077 15.066-0.107-7e-3 -0.723-0.014-1.446-0.021-2.169-3e-3 -0.202-0.031-1.304-0.079-1.729z",
    fill: "#a1b0ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path67",
    d: "m294.88 415.88c-3.829 0.156-12.698 0.077-14.967 0.086-2.808 0.012-5.617 0.044-8.425 0.036-1.683-5e-3 -4.574 0.013-6.536-0.02-0.096 0.311-0.069 0.826-0.075 0.826 0 0.03-1e-3 1.168-1e-3 3.085 1.9 0.044 5.038 0.023 6.808 0.028 2.743 8e-3 5.487-0.024 8.23-0.036 2.309-0.01 11.62 0.077 15.066-0.107-7e-3 -0.723-0.014-1.446-0.021-2.169-3e-3 -0.202-0.031-1.304-0.079-1.729z",
    fill: "#a1b0ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "m294.88 423.67c-3.829 0.156-12.698 0.076-14.967 0.086-2.808 0.012-5.617 0.044-8.425 0.036-1.683-5e-3 -4.574 0.013-6.536-0.02-0.096 0.311-0.069 0.826-0.075 0.826 0 0.031-1e-3 1.168-1e-3 3.085 1.9 0.044 5.038 0.023 6.808 0.028 2.743 8e-3 5.487-0.024 8.23-0.036 2.309-0.01 11.62 0.077 15.066-0.107-7e-3 -0.723-0.014-1.446-0.021-2.169-3e-3 -0.201-0.031-1.303-0.079-1.729z",
    fill: "#a1b0ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path69",
    d: "m286.38 431.46c-2.745 0.156-9.101 0.076-10.727 0.086-2.013 0.012-4.025 0.044-6.038 0.036-1.206-5e-3 -3.279 0.013-4.684-0.02-0.069 0.311-0.05 0.826-0.054 0.826 0 0.03 0 1.168-1e-3 3.085 1.362 0.044 3.611 0.023 4.879 0.028 1.966 8e-3 3.932-0.024 5.898-0.036 1.655-0.01 8.328 0.077 10.799-0.107l-0.015-2.169c-3e-3 -0.202-0.022-1.304-0.057-1.729z",
    fill: "#a1b0ba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "m385.75 426.23-5e-3 -2.762c-4e-3 -5.764-0.056-11.517-0.156-17.1-0.068-3.828-0.145-6.948-0.241-9.819-6e-3 -0.155-0.069-0.291-0.177-0.387-0.437-2.311-3.57-2.673-4.609-2.793-3.304-0.383-6.356-0.643-9.332-0.797-6.798-0.352-12.965-0.165-18.848 0.57l-0.222 0.028c-2.137 0.265-4.559 0.565-5.892 2.699-0.157 0.155-0.28 0.512-0.277 0.687 0.064 3.687 0.045 7.44 0.027 11.069-0.01 1.945-0.02 3.888-0.018 5.83l0.016 17.074-1e-3 0.889 1e-3 0.276c-0.117 1.26-0.141 2.544-0.163 3.786-0.015 0.814-0.025 1.628-0.022 2.441 4e-3 1.136 0.036 2.521 0.162 2.673 1.475 1.768 4.05 2.318 5.859 2.577 2.185 0.315 4.434 0.39 6.608 0.463l1.099 0.038c1.811 0.066 3.527 0.099 5.168 0.099 4.132 0 7.782-0.211 11.23-0.643 3.101-0.388 6.117-0.988 8.964-1.783 0.182-0.051 0.316-0.175 0.378-0.343 0.152-0.083 0.249-0.239 0.258-0.43 0.217-4.772 0.205-9.636 0.193-14.342zm-33.308-31.995c2.613-0.328 5.365-0.551 8.181-0.661 4.97-0.197 10.239-0.05 16.107 0.442l0.339 0.029c1.351 0.113 2.748 0.23 4.11 0.408 0.911 0.118 2.462 0.486 3.028 1.632-6.059 1.726-12.308 2.6-18.583 2.6h-0.039c-3.246-2e-3 -6.478-0.233-9.604-0.688-1.556-0.226-3.142-0.515-4.715-0.86-0.54-0.119-1.08-0.259-1.621-0.4-0.729-0.19-1.479-0.385-2.23-0.525 1.239-1.391 3.233-1.751 5.027-1.977zm-5.301 3.021c0.842 0.311 1.729 0.52 2.591 0.723l0.376 0.089c1.139 0.271 2.349 0.518 3.698 0.755 2.44 0.428 4.935 0.73 7.416 0.898 4.968 0.339 10.052 0.106 15.11-0.688 2.619-0.411 5.296-0.998 7.963-1.749 0.089 4.682 0.159 9.056 0.215 13.353-0.827 0.125-1.657 0.297-2.461 0.464-0.706 0.147-1.437 0.297-2.156 0.415-1.551 0.255-3.136 0.467-4.711 0.628-3.087 0.317-6.247 0.459-9.367 0.429-3.108-0.031-6.256-0.248-9.356-0.646-1.933-0.247-3.878-0.623-5.759-0.987-1.151-0.223-2.338-0.452-3.551-0.652l1e-3 -1.551c1e-3 -0.85 2e-3 -1.701 0-2.551-2e-3 -0.93-7e-3 -1.859-0.012-2.788-0.011-2.013-0.023-4.093 3e-3 -6.142zm37.469 30.362c1e-3 1.041 2e-3 2.083-5e-3 3.126-7e-3 1.066-0.019 2.133-0.032 3.199-0.025 2.048-0.051 4.164-0.026 6.25-10.836 3.014-22.169 2.671-30.838 2.033-1.031-0.076-2.382-0.211-3.692-0.578-1.131-0.316-2.097-0.864-2.987-1.414 3e-3 -0.02 5e-3 -0.039 6e-3 -0.06 0.176-4.096 0.151-8.272 0.127-12.311l-0.011-2.19c1.786 1.137 4.062 1.596 6.253 1.965 2.098 0.355 4.35 0.586 7.303 0.749 5.101 0.281 10.373 0.115 15.661-0.494 2.67-0.307 5.439-0.76 8.24-1.349v1.074zm-19.24-0.301c-3.418-0.059-6.523-0.255-9.492-0.598-1.801-0.209-3.261-0.465-4.594-0.809-0.858-0.221-1.704-0.539-2.521-0.846-0.525-0.197-1.067-0.4-1.614-0.58l-4e-3 -1.225c5e-3 -3.982 4e-3 -7.964 4e-3 -11.946 2.964 0.961 6.164 1.432 8.947 1.8 3.195 0.422 6.463 0.657 9.713 0.696 3.218 0.039 6.493-0.126 9.725-0.492 1.543-0.174 3.095-0.394 4.614-0.654l0.641-0.108c1.237-0.208 2.514-0.422 3.736-0.774 0.056 4.652 0.085 9.222 0.086 13.592-6.698 1.396-13.173 2.053-19.241 1.944z",
    fill: "#4c5980"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g76",
    fill: "#4c5980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path71",
    d: "m433.29 386.45c-0.08-9.128-0.265-32.251-0.632-41.372-0.024-0.602-0.956-0.608-0.941 0 0.229 9.122 0.421 32.248 0.486 41.372 0.065 9.089-0.092 18.178-0.05 27.267-0.826-0.21-1.757-0.059-2.606-0.051-1.165 0.011-2.33 0.023-3.495 0.034-2.413 0.023-4.826 0.047-7.239 0.07s-4.826 0.041-7.239 0.073c-2.34 0.031-4.778-0.126-7.092 0.236-0.367 0.057-0.374 0.698 0 0.748 2.319 0.314 4.755 0.11 7.092 0.093 2.413-0.018 4.826-0.05 7.239-0.076s4.826-0.052 7.239-0.078c1.165-0.013 2.33-0.025 3.495-0.038 1.038-0.011 2.213 0.202 3.144-0.308 0.071-0.039 0.108-0.109 0.126-0.184 0.149-0.064 0.269-0.197 0.277-0.409 0.348-9.115 0.276-18.257 0.196-27.377z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "m433.59 342.85c-1.059-0.635-2.604-0.42-3.329 0.625-0.396 0.57-0.488 1.324-0.306 1.987 0.051 0.185 0.123 0.358 0.209 0.521 0.126 0.306 0.322 0.582 0.584 0.805 1.055 0.896 2.794 0.645 3.519-0.538 0.671-1.092 0.478-2.707-0.677-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73",
    d: "m405.63 412.37c-1.059-0.635-2.604-0.42-3.329 0.625-0.395 0.57-0.488 1.324-0.305 1.987 0.051 0.185 0.123 0.358 0.209 0.521 0.126 0.306 0.322 0.582 0.584 0.805 1.055 0.896 2.795 0.645 3.519-0.538 0.67-1.092 0.477-2.707-0.678-3.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "m243.82 68.328c-1.059-0.635-2.604-0.42-3.329 0.625-0.251 0.361-0.366 0.797-0.381 1.236-0.748-4e-3 -1.498 0.011-2.234-2e-3 -1.473-0.026-2.947-0.052-4.42-0.078s-2.947-0.064-4.421-0.069c-1.217-4e-3 -4.385 0.142-4.412 0.461-0.382 4.482-0.161 9.092-0.223 13.591-0.061 4.4-0.251 8.831-0.079 13.229-7.379-0.292-14.762-0.449-22.146-0.451-3.669-1e-3 -7.34 0.022-11.008 0.102-3.053 0.066-6.154 0.05-9.214 0.27-0.072-0.695-0.406-1.352-1.039-1.731-1.059-0.635-2.604-0.42-3.329 0.625-0.396 0.57-0.488 1.324-0.305 1.987 0.051 0.185 0.123 0.358 0.209 0.521 0.127 0.306 0.322 0.582 0.584 0.805 1.055 0.896 2.795 0.645 3.519-0.538 0.156-0.254 0.26-0.538 0.321-0.831 2.998 0.012 6.012-0.169 9.003-0.216 3.753-0.058 7.505-0.102 11.259-0.101 7.423 3e-3 14.845 0.139 22.263 0.408 0.209 8e-3 0.336-0.112 0.385-0.264 0.063-0.049 0.111-0.121 0.119-0.226 0.322-4.51 0.243-9.07 0.305-13.591 0.06-4.343 0.376-8.782 0.165-13.125 1.149 0.264 2.485 0.119 3.623 0.143 1.473 0.031 2.947 0.028 4.421 0.038 1.473 0.01 2.947 0.019 4.42 0.029 0.798 5e-3 1.613 0.041 2.425 0.052 0.032 0.077 0.055 0.161 0.094 0.234 0.127 0.306 0.322 0.582 0.584 0.805 1.055 0.896 2.795 0.645 3.519-0.538 0.67-1.092 0.477-2.707-0.678-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path75",
    d: "m243.9 412.37c-1.059-0.635-2.604-0.42-3.329 0.625-0.224 0.323-0.34 0.706-0.375 1.097-3.589-0.031-18.178-0.058-21.768-0.083-2.157-0.015-12.314-0.03-14.471-0.045-1.308-9e-3 -2.698-0.105-4.055-0.062-0.112-0.62-0.447-1.189-1.019-1.532-1.059-0.635-2.604-0.42-3.329 0.625-0.396 0.57-0.488 1.324-0.306 1.987 0.051 0.185 0.123 0.358 0.21 0.521 0.126 0.306 0.322 0.582 0.584 0.805 1.055 0.897 2.795 0.645 3.519-0.538 0.178-0.29 0.29-0.617 0.344-0.954 1.273 0.052 2.574-0.018 3.802-0.011 2.24 0.013 12.48 0.026 14.72 0.038 3.608 0.021 18.215 0.04 21.823 0.054 7e-3 0.028 6e-3 0.057 0.014 0.084 0.051 0.185 0.123 0.358 0.209 0.521 0.127 0.306 0.322 0.582 0.584 0.805 1.055 0.897 2.795 0.645 3.519-0.538 0.673-1.091 0.48-2.706-0.676-3.399z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "m115.57 150.66c-0.31-0.186-0.662-0.29-1.022-0.331 0.018-0.863-3e-3 -1.732-5e-3 -2.573l-0.016-4.924c-9e-3 -2.636-0.018-5.272-0.026-7.909 0.699-0.073 1.366-0.429 1.749-1.054 0.67-1.093 0.477-2.708-0.679-3.4-1.059-0.635-2.604-0.42-3.329 0.625-0.395 0.57-0.488 1.324-0.305 1.987 0.051 0.185 0.123 0.358 0.21 0.521 0.126 0.306 0.322 0.582 0.584 0.805 0.297 0.253 0.65 0.404 1.018 0.479 9e-3 2.648 0.018 5.297 0.026 7.945l0.016 4.924c3e-3 0.843-0.012 1.717 0.012 2.585-0.617 0.101-1.194 0.416-1.561 0.945-0.395 0.57-0.488 1.324-0.305 1.987 0.051 0.185 0.123 0.358 0.21 0.521 0.126 0.306 0.322 0.582 0.584 0.805 1.054 0.896 2.795 0.645 3.519-0.538 0.669-1.093 0.476-2.708-0.68-3.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path77",
    d: "m376.16 60.33c-0.092-4.791-0.18-9.582-0.28-14.373-0.011-0.509-0.169-3.704-0.447-4.051-0.261-0.771-53.571-0.053-64.042-0.158-10.281-0.103-61.509 0.203-61.801 0.21-1.368 0.035-1.122 2.274-1.154 2.273 2e-3 0.338-0.073 64.082-0.028 96.062 0.308 0.419 22.093 0.309 32.201 0.325 10.515 0.017 21.03-0.051 31.545-0.077 10.324-0.026 57.158 0.234 62.252-0.479 0.151-0.021 0.262-0.087 0.399-0.124 0.438-0.065 0.842-0.22 1.158-0.453 0.16-15.01 0.22-30.034 0.053-44.902-0.131-11.478-0.012-22.875 0.144-34.253z",
    fill: "#ffbb39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "m375.87 45.957c-0.011-0.509-0.169-3.704-0.447-4.051-0.172-0.51-23.535-0.369-42.374-0.245-8e-3 15.114-0.035 66.595-0.031 98.905 17.098 0.013 38.065-0.039 41.378-0.503 0.151-0.021 0.262-0.087 0.399-0.124 0.438-0.065 0.842-0.22 1.158-0.453 0.16-15.01 0.22-30.034 0.053-44.902-0.129-11.479-0.01-22.876 0.145-34.254-0.092-4.791-0.18-9.582-0.281-14.373z",
    fill: "#4c5980"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path79",
    d: "m277.66 53.274c11.502 6e-3 23.003-2e-3 34.504-3e-3 9.84-1e-3 49.999 0.039 63.854-0.023-0.047-2.431-0.091-4.861-0.142-7.292-0.011-0.509-0.169-3.704-0.447-4.051-0.261-0.771-53.571-0.053-64.042-0.158-10.281-0.103-61.509 0.203-61.801 0.21-1.368 0.035-1.122 2.273-1.154 2.273 1e-3 0.077-3e-3 3.468-8e-3 9.025 7.871 0.02 21.599 0.016 29.236 0.019z",
    fill: "#b345b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "m367.75 48.943c-0.455-0.837-0.546-1.716-0.175-2.593 0.089-0.209 0.337-0.593 0.495-0.756 0.118-0.123 0.272-0.289 0.413-0.385 0.316-0.216 0.56-0.352 0.928-0.457 0.198-0.057 0.448-0.135 0.654-0.148 0.23-0.015 0.445 2e-3 0.674 0.027 0.651 0.073 1.245 0.418 1.697 0.893 0.808 0.847 1.04 2.105 0.484 3.261-0.828 1.722-2.773 2.129-4.211 1.191-0.397-0.26-0.732-0.616-0.959-1.033z",
    fill: "#ffd075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path81",
    d: "m359.08 48.943c-0.455-0.837-0.547-1.716-0.175-2.593 0.089-0.209 0.337-0.593 0.495-0.756 0.118-0.123 0.272-0.289 0.413-0.385 0.316-0.216 0.559-0.352 0.928-0.457 0.198-0.057 0.448-0.135 0.654-0.148 0.23-0.015 0.445 2e-3 0.674 0.027 0.651 0.073 1.245 0.418 1.697 0.893 0.807 0.847 1.039 2.105 0.484 3.261-0.828 1.722-2.773 2.129-4.211 1.191-0.397-0.26-0.732-0.616-0.959-1.033z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "m350.41 48.943c-0.455-0.837-0.546-1.716-0.175-2.593 0.089-0.209 0.337-0.593 0.495-0.756 0.118-0.123 0.272-0.289 0.413-0.385 0.316-0.216 0.559-0.352 0.927-0.457 0.198-0.057 0.449-0.135 0.654-0.148 0.23-0.015 0.445 2e-3 0.674 0.027 0.651 0.073 1.245 0.418 1.697 0.893 0.807 0.847 1.039 2.105 0.484 3.261-0.827 1.722-2.773 2.129-4.211 1.191-0.397-0.26-0.731-0.616-0.958-1.033z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path83",
    d: "m281.74 123.5c-1.588-0.041-3.171-0.086-4.759-0.056 0.168-4.34 0.04-8.703 8e-3 -13.046-0.028-3.758-0.056-7.517-0.084-11.275 0.092 8e-3 0.187 6e-3 0.279 9e-3 0.225 7e-3 0.45 0.015 0.675 0.022 0.434 0.014 0.868 0.03 1.301 0.042 0.434 0.012 0.868 0.011 1.302 0.015 0.433 4e-3 0.958 0.092 1.357-0.098 0.264-0.126 0.256-0.599 0-0.727-0.392-0.197-0.928-0.118-1.357-0.122-0.434-4e-3 -0.868-0.015-1.302-0.011s-0.868 0.01-1.301 0.016c-0.225 3e-3 -0.45 6e-3 -0.675 8e-3 -0.093 1e-3 -0.192-4e-3 -0.285 3e-3l-6e-3 -0.813c-0.064-8.681-0.128-17.362-0.19-26.043 0.8 0.029 1.595 0.047 2.397 0.032 0.446-8e-3 0.891-0.016 1.337-0.025 0.443-8e-3 0.973 0.069 1.383-0.122 0.348-0.162 0.184-0.655-0.095-0.77-0.223-0.091-0.487-0.046-0.723-0.039-0.206 6e-3 -0.411 0.012-0.617 0.018-0.446 0.013-0.891 0.026-1.337 0.039-0.896 0.026-1.781 0.085-2.674 0.166-0.089 8e-3 -0.156 0.047-0.207 0.099-0.114 0.054-0.202 0.163-0.2 0.335 0.078 8.769 0.154 17.539 0.229 26.308 2e-3 0.274 5e-3 0.548 7e-3 0.822-1.373-0.019-2.745-0.042-4.118-0.034-0.715 4e-3 -1.43 9e-3 -2.145 0.013-0.671 4e-3 -1.387-0.035-2.027 0.192-0.171 0.061-0.168 0.303 0 0.365 0.638 0.237 1.355 0.206 2.027 0.219 0.715 0.014 1.43 0.028 2.145 0.043 1.375 0.027 2.75 0.023 4.125 0.023 0.032 3.763 0.065 7.525 0.097 11.287 0.038 4.454-0.029 8.931 0.23 13.377 5e-3 0.084 0.044 0.138 0.093 0.175 0.047 0.11 0.141 0.2 0.29 0.209 1.607 0.105 3.212 0.13 4.821 0.162 0.498 0.013 0.497-0.805-1e-3 -0.818z",
    fill: "#b345b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    d: "m310.1 123.5c-1.588-0.041-3.171-0.086-4.759-0.056 0.168-4.34 0.04-8.703 7e-3 -13.046-0.028-3.758-0.056-7.517-0.084-11.275 0.092 8e-3 0.187 6e-3 0.279 9e-3 0.225 7e-3 0.45 0.015 0.675 0.022 0.434 0.014 0.868 0.03 1.302 0.042s0.868 0.011 1.302 0.015c0.432 4e-3 0.958 0.092 1.357-0.098 0.264-0.126 0.256-0.599 0-0.727-0.392-0.197-0.928-0.118-1.357-0.122-0.434-4e-3 -0.868-0.015-1.302-0.011s-0.868 0.01-1.302 0.016c-0.225 3e-3 -0.45 6e-3 -0.675 8e-3 -0.093 1e-3 -0.192-4e-3 -0.285 3e-3l-6e-3 -0.813c-0.064-8.681-0.128-17.362-0.19-26.043 0.8 0.029 1.595 0.047 2.397 0.032 0.446-8e-3 0.891-0.016 1.337-0.025 0.443-8e-3 0.973 0.069 1.383-0.122 0.348-0.162 0.184-0.655-0.095-0.77-0.223-0.091-0.487-0.046-0.723-0.039-0.206 6e-3 -0.411 0.012-0.617 0.018-0.446 0.013-0.891 0.026-1.337 0.039-0.896 0.026-1.781 0.085-2.674 0.166-0.089 8e-3 -0.156 0.047-0.207 0.099-0.114 0.054-0.202 0.163-0.2 0.335 0.078 8.769 0.154 17.539 0.229 26.308 2e-3 0.274 5e-3 0.548 7e-3 0.822-1.373-0.019-2.745-0.042-4.118-0.034-0.715 4e-3 -1.43 9e-3 -2.145 0.013-0.67 4e-3 -1.387-0.035-2.027 0.192-0.171 0.061-0.168 0.303 0 0.365 0.638 0.237 1.355 0.206 2.027 0.219 0.715 0.014 1.43 0.028 2.145 0.043 1.375 0.027 2.75 0.023 4.126 0.023 0.032 3.763 0.064 7.525 0.097 11.287 0.038 4.454-0.029 8.931 0.23 13.377 5e-3 0.084 0.044 0.138 0.093 0.175 0.047 0.11 0.141 0.2 0.29 0.209 1.607 0.105 3.212 0.13 4.821 0.162 0.498 0.013 0.497-0.805-1e-3 -0.818z",
    fill: "#b345b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path85",
    d: "m312.49 62.215c-0.809 0.014-1.617 0.027-2.426 0.042-0.086 2e-3 -0.625 0.026-0.684 0.068-0.13 0.039-9e-3 8.074-0.026 9.652-0.017 1.55 0.035 9.27 0.036 9.314 6e-3 0.206 0.384 0.169 0.384 0.174 0.057 0 10.818 0.012 16.217 5e-3 0.071-0.046 0.052-3.33 0.055-4.853 3e-3 -1.585-9e-3 -3.17-0.013-4.754-4e-3 -1.556 0.039-8.615-0.081-9.382-4e-3 -0.023-0.015-0.039-0.021-0.06-0.011-0.066-0.037-0.127-0.076-0.175-2.534-0.024-5.07-0.033-7.58-8e-3 -1.941 0.019-3.865 1e-3 -5.785-0.023z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "m312.49 87.596c-0.809 0.014-1.617 0.027-2.426 0.042-0.086 2e-3 -0.625 0.026-0.684 0.068-0.13 0.039-9e-3 8.074-0.026 9.652-0.017 1.55 0.035 9.27 0.036 9.314 6e-3 0.206 0.384 0.169 0.384 0.174 0.057 0 10.818 0.012 16.217 5e-3 0.071-0.046 0.052-3.33 0.055-4.853 3e-3 -1.585-9e-3 -3.17-0.013-4.754-4e-3 -1.556 0.039-8.615-0.081-9.382-4e-3 -0.023-0.015-0.039-0.021-0.06-0.011-0.066-0.037-0.127-0.076-0.174-2.534-0.024-5.07-0.034-7.58-8e-3 -1.941 0.018-3.865 0-5.785-0.024z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path87",
    d: "m312.49 112.98c-0.809 0.014-1.617 0.027-2.426 0.042-0.086 2e-3 -0.625 0.025-0.684 0.067-0.13 0.039-9e-3 8.074-0.026 9.652-0.017 1.55 0.035 9.27 0.036 9.314 6e-3 0.206 0.384 0.169 0.384 0.174 0.057 0 10.818 0.011 16.217 5e-3 0.071-0.046 0.052-3.33 0.055-4.853 3e-3 -1.585-9e-3 -3.17-0.013-4.754-4e-3 -1.556 0.039-8.615-0.081-9.382-4e-3 -0.023-0.015-0.04-0.021-0.06-0.011-0.066-0.037-0.127-0.076-0.175-2.534-0.024-5.07-0.034-7.58-8e-3 -1.941 0.02-3.865 2e-3 -5.785-0.022z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "m284.13 62.215c-0.809 0.014-1.618 0.027-2.426 0.042-0.086 2e-3 -0.625 0.026-0.684 0.068-0.13 0.039-9e-3 8.074-0.026 9.652-0.017 1.55 0.035 9.27 0.036 9.314 6e-3 0.206 0.384 0.169 0.384 0.174 0.057 0 10.818 0.012 16.217 5e-3 0.071-0.046 0.052-3.33 0.055-4.853 3e-3 -1.585-9e-3 -3.17-0.013-4.754-4e-3 -1.556 0.039-8.615-0.081-9.382-4e-3 -0.023-0.015-0.039-0.021-0.06-0.011-0.066-0.037-0.127-0.076-0.175-2.534-0.024-5.07-0.033-7.58-8e-3 -1.941 0.019-3.865 1e-3 -5.785-0.023z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path89",
    d: "m284.13 87.596c-0.809 0.014-1.618 0.027-2.426 0.042-0.086 2e-3 -0.625 0.026-0.684 0.068-0.13 0.039-9e-3 8.074-0.026 9.652-0.017 1.55 0.035 9.27 0.036 9.314 6e-3 0.206 0.384 0.169 0.384 0.174 0.057 0 10.818 0.012 16.217 5e-3 0.071-0.046 0.052-3.33 0.055-4.853 3e-3 -1.585-9e-3 -3.17-0.013-4.754-4e-3 -1.556 0.039-8.615-0.081-9.382-4e-3 -0.023-0.015-0.039-0.021-0.06-0.011-0.066-0.037-0.127-0.076-0.174-2.534-0.024-5.07-0.034-7.58-8e-3 -1.941 0.018-3.865 0-5.785-0.024z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "m284.13 112.98c-0.809 0.014-1.618 0.027-2.426 0.042-0.086 2e-3 -0.625 0.025-0.684 0.067-0.13 0.039-9e-3 8.074-0.026 9.652-0.017 1.55 0.035 9.27 0.036 9.314 6e-3 0.206 0.384 0.169 0.384 0.174 0.057 0 10.818 0.011 16.217 5e-3 0.071-0.046 0.052-3.33 0.055-4.853 3e-3 -1.585-9e-3 -3.17-0.013-4.754-4e-3 -1.556 0.039-8.615-0.081-9.382-4e-3 -0.023-0.015-0.04-0.021-0.06-0.011-0.066-0.037-0.127-0.076-0.175-2.534-0.024-5.07-0.034-7.58-8e-3 -1.941 0.02-3.865 2e-3 -5.785-0.022z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path91",
    d: "m257.25 86.379c-0.809 0.017-1.618 0.034-2.426 0.052-0.086 2e-3 -0.625 0.031-0.684 0.083-0.13 0.049-9e-3 9.969-0.027 11.918-0.017 1.913 0.034 11.447 0.035 11.501 6e-3 0.255 0.384 0.209 0.384 0.215 0.057 0 10.818 0.014 16.217 5e-3 0.071-0.057 0.052-4.111 0.055-5.993 3e-3 -1.957-9e-3 -3.913-0.013-5.87-4e-3 -1.921 0.039-10.637-0.081-11.585-4e-3 -0.028-0.015-0.049-0.021-0.074-0.011-0.081-0.037-0.157-0.076-0.216-2.534-0.03-5.07-0.041-7.58-0.01-1.939 0.025-3.862 3e-3 -5.783-0.026z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "m357.17 57.153c-2.589 0.138-8.584 0.068-10.118 0.076-1.898 0.011-3.797 0.039-5.696 0.032-1.138-4e-3 -3.092 0.012-4.419-0.017-0.065 0.275-0.047 0.73-0.05 0.73 0 0.027 0 1.032-1e-3 2.727 1.284 0.039 3.406 0.02 4.602 0.025 1.855 7e-3 3.709-0.021 5.564-0.032 1.561-9e-3 7.855 0.068 10.185-0.094-5e-3 -0.639-9e-3 -1.278-0.014-1.918-2e-3 -0.178-0.02-1.152-0.053-1.529z",
    fill: "#d66ec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path93",
    d: "m356.88 65.308c-1.152 0.134-3.821 0.066-4.503 0.074-0.845 0.01-1.69 0.038-2.535 0.031-0.506-4e-3 -1.376 0.011-1.967-0.017-0.029 0.268-0.021 0.71-0.022 0.71v2.653c0.572 0.038 1.516 0.02 2.048 0.024 0.826 7e-3 1.651-0.021 2.476-0.031 0.695-9e-3 3.496 0.066 4.533-0.092-2e-3 -0.622-4e-3 -1.244-7e-3 -1.866 0-0.172-9e-3 -1.12-0.023-1.486z",
    fill: "#7991d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "m371.3 70.938c-2.992 0.134-9.922 0.066-11.695 0.074-2.194 0.01-4.389 0.037-6.583 0.031-1.315-4e-3 -3.574 0.011-5.107-0.017-0.075 0.268-0.054 0.71-0.058 0.71 0 0.026 0 1.004-1e-3 2.653 1.484 0.038 3.937 0.02 5.319 0.024 2.143 7e-3 4.287-0.021 6.43-0.031 1.804-9e-3 9.079 0.066 11.772-0.092-6e-3 -0.622-0.011-1.244-0.017-1.866-1e-3 -0.172-0.022-1.12-0.06-1.486z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path95",
    d: "m371.3 76.277c-2.992 0.134-9.922 0.066-11.695 0.074-2.194 0.01-4.389 0.037-6.583 0.031-1.315-4e-3 -3.574 0.011-5.107-0.017-0.075 0.268-0.054 0.71-0.058 0.71 0 0.026 0 1.004-1e-3 2.653 1.484 0.038 3.937 0.02 5.319 0.024 2.143 7e-3 4.287-0.021 6.43-0.031 1.804-9e-3 9.079 0.066 11.772-0.092-6e-3 -0.622-0.011-1.244-0.017-1.866-1e-3 -0.172-0.022-1.12-0.06-1.486z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "m371.3 81.617c-2.992 0.134-9.922 0.066-11.695 0.074-2.194 0.01-4.389 0.038-6.583 0.031-1.315-4e-3 -3.574 0.012-5.107-0.017-0.075 0.268-0.054 0.71-0.058 0.71 0 0.026 0 1.004-1e-3 2.653 1.484 0.038 3.937 0.02 5.319 0.024 2.143 7e-3 4.287-0.021 6.43-0.031 1.804-9e-3 9.079 0.066 11.772-0.092-6e-3 -0.622-0.011-1.244-0.017-1.866-1e-3 -0.173-0.022-1.121-0.06-1.486z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97",
    d: "m369.4 65.308c-1.35 0.134-4.476 0.066-5.276 0.074-0.99 0.01-1.98 0.038-2.97 0.031-0.593-4e-3 -1.612 0.011-2.304-0.017-0.034 0.268-0.024 0.71-0.026 0.71 0 0.026 0 1.004-1e-3 2.653 0.669 0.038 1.776 0.02 2.4 0.024 0.967 7e-3 1.934-0.021 2.901-0.031 0.814-9e-3 4.096 0.066 5.311-0.092-3e-3 -0.622-5e-3 -1.244-8e-3 -1.866 0-0.172-0.01-1.12-0.027-1.486z",
    fill: "#7991d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "m357.17 91.065c-2.589 0.138-8.584 0.068-10.118 0.076-1.898 0.01-3.797 0.039-5.696 0.032-1.138-4e-3 -3.092 0.012-4.419-0.017-0.065 0.275-0.047 0.73-0.05 0.73 0 0.027 0 1.033-1e-3 2.727 1.284 0.039 3.406 0.02 4.602 0.025 1.855 7e-3 3.709-0.021 5.564-0.031 1.561-9e-3 7.855 0.068 10.185-0.095-5e-3 -0.639-9e-3 -1.278-0.014-1.918-2e-3 -0.178-0.02-1.153-0.053-1.529z",
    fill: "#d66ec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path99",
    d: "m356.88 99.219c-1.152 0.134-3.821 0.066-4.503 0.074-0.845 0.01-1.69 0.037-2.535 0.031-0.506-4e-3 -1.376 0.011-1.967-0.017-0.029 0.268-0.021 0.71-0.022 0.71v2.653c0.572 0.038 1.516 0.02 2.048 0.024 0.826 7e-3 1.651-0.021 2.476-0.031 0.695-9e-3 3.496 0.066 4.533-0.092-2e-3 -0.622-4e-3 -1.244-7e-3 -1.866 0-0.172-9e-3 -1.12-0.023-1.486z",
    fill: "#7991d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "m371.3 104.85c-2.992 0.134-9.922 0.066-11.695 0.074-2.194 0.01-4.389 0.037-6.583 0.031-1.315-4e-3 -3.574 0.012-5.107-0.017-0.075 0.268-0.054 0.71-0.058 0.71 0 0.026 0 1.004-1e-3 2.653 1.484 0.038 3.937 0.02 5.319 0.024 2.143 7e-3 4.287-0.021 6.43-0.031 1.804-9e-3 9.079 0.066 11.772-0.092-6e-3 -0.622-0.011-1.244-0.017-1.866-1e-3 -0.172-0.022-1.12-0.06-1.486z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path101",
    d: "m371.3 110.19c-2.992 0.134-9.922 0.066-11.695 0.074-2.194 0.01-4.389 0.037-6.583 0.031-1.315-4e-3 -3.574 0.011-5.107-0.017-0.075 0.268-0.054 0.71-0.058 0.71 0 0.026 0 1.004-1e-3 2.653 1.484 0.038 3.937 0.02 5.319 0.024 2.143 7e-3 4.287-0.021 6.43-0.031 1.804-9e-3 9.079 0.066 11.772-0.092-6e-3 -0.622-0.011-1.244-0.017-1.866-1e-3 -0.172-0.022-1.12-0.06-1.486z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "m371.3 115.53c-2.992 0.134-9.922 0.066-11.695 0.074-2.194 0.01-4.389 0.037-6.583 0.031-1.315-4e-3 -3.574 0.011-5.107-0.017-0.075 0.268-0.054 0.71-0.058 0.71 0 0.026 0 1.004-1e-3 2.653 1.484 0.038 3.937 0.02 5.319 0.024 2.143 7e-3 4.287-0.021 6.43-0.031 1.804-9e-3 9.079 0.066 11.772-0.092-6e-3 -0.622-0.011-1.244-0.017-1.866-1e-3 -0.172-0.022-1.12-0.06-1.486z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path103",
    d: "m369.4 99.219c-1.35 0.134-4.476 0.066-5.276 0.074-0.99 0.01-1.98 0.037-2.97 0.031-0.593-4e-3 -1.612 0.011-2.304-0.017-0.034 0.268-0.024 0.71-0.026 0.71 0 0.026 0 1.004-1e-3 2.653 0.669 0.038 1.776 0.02 2.4 0.024 0.967 7e-3 1.934-0.021 2.901-0.031 0.814-9e-3 4.096 0.066 5.311-0.092-3e-3 -0.622-5e-3 -1.244-8e-3 -1.866 0-0.172-0.01-1.12-0.027-1.486z",
    fill: "#7991d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "m357.17 124.98c-2.589 0.138-8.584 0.067-10.118 0.076-1.898 0.01-3.797 0.038-5.696 0.032-1.138-4e-3 -3.092 0.012-4.419-0.017-0.065 0.275-0.047 0.73-0.05 0.73 0 0.027 0 1.033-1e-3 2.727 1.284 0.039 3.406 0.02 4.602 0.025 1.855 7e-3 3.709-0.021 5.564-0.031 1.561-9e-3 7.855 0.068 10.185-0.094-5e-3 -0.639-9e-3 -1.278-0.014-1.918-2e-3 -0.18-0.02-1.154-0.053-1.53z",
    fill: "#d66ec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path105",
    d: "m356.88 133.13c-1.152 0.134-3.821 0.066-4.503 0.074-0.845 0.01-1.69 0.038-2.535 0.031-0.506-4e-3 -1.376 0.012-1.967-0.017-0.029 0.268-0.021 0.71-0.022 0.71v2.653c0.572 0.038 1.516 0.02 2.048 0.024 0.826 7e-3 1.651-0.02 2.476-0.031 0.695-9e-3 3.496 0.066 4.533-0.092-2e-3 -0.622-4e-3 -1.244-7e-3 -1.866 0-0.172-9e-3 -1.12-0.023-1.486z",
    fill: "#7991d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "m369.4 133.13c-1.35 0.134-4.476 0.066-5.276 0.074-0.99 0.01-1.98 0.038-2.97 0.031-0.593-4e-3 -1.612 0.012-2.304-0.017-0.034 0.268-0.024 0.71-0.026 0.71 0 0.026 0 1.004-1e-3 2.653 0.669 0.038 1.776 0.02 2.4 0.024 0.967 7e-3 1.934-0.02 2.901-0.031 0.814-9e-3 4.096 0.066 5.311-0.092-3e-3 -0.622-5e-3 -1.244-8e-3 -1.866 0-0.172-0.01-1.12-0.027-1.486z",
    fill: "#7991d1"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "link-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect46-9",
    x: 168.98,
    y: 88.797,
    width: 28.235,
    height: 36.097,
    ry: 3.2166,
    fill: "#08a",
    stroke: "#5fd",
    strokeWidth: 0.849
  }), /*#__PURE__*/React.createElement("g", {
    id: "g145",
    transform: "matrix(.0074391 0 0 .0074391 169.66 95.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3-15",
    d: "m2890.5 2844.3c-55.887 58.836-108.77 96.778-150.55 126.76-491.11 352.38-1072.2 249.66-1195.7 224.58-182.38-37.041-534.9-108.64-789.77-408.36-385.6-453.46-325.56-1167.9-26.459-1639.5 54.709-86.262 343.7-565.04 931.07-641.82 355.47-46.466 769.84 47.251 1069.9 298.65 629.88 527.71 585.04 1593.8 161.52 2039.7z",
    fill: "url(#SVGID_1_)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5-6",
    d: "m482.75 468.84c-2.59-11.023 12.917-18.35 22.412-10.65 96.42 78.187 328.09 312.32 270.35 721.49-72.439 513.36 51.404 700.68 205.56 814.94 0 0-211.7-53.733-344.9-243.81-327.02-466.68-107.38-1086-153.42-1282z",
    fill: "url(#SVGID_00000082341467367301374580000012278336009540478380_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6-01",
    d: "m556.13 629.18c12.062 57.15 22.813 114.47 31.121 172.06 8.656 57.534 15.29 115.27 19.829 173.1 4.282 57.84 7.307 115.74 7.479 173.67 0.473 57.923-1.935 115.8-4.588 173.9-2.276 58.079-4.951 116.58-0.699 175.49 4.181 58.792 16.556 118.1 41.115 173.69 6.139 13.856 12.594 27.669 19.928 41.016 7.05 13.47 14.793 26.674 22.806 39.753 16.181 26.095 34.396 51.307 54.694 75.238 40.743 47.779 89.882 90.163 144.01 126.03 5.697 3.775 13.86 2.847 18.233-2.072 4.293-4.831 3.334-11.715-2.096-15.537l-0.038-0.027c-12.88-9.046-25.625-18.209-37.852-27.831-6.204-4.727-12.152-9.682-18.206-14.539-5.833-5.048-11.896-9.903-17.542-15.101-22.986-20.459-44.281-42.286-63.6-65.366-38.86-45.944-69.97-97.141-93.539-150.22-11.441-26.661-20.587-54.003-27.264-81.859-6.654-27.862-10.838-56.209-13.153-84.784-4.635-57.182-2.541-115.1-0.749-173.19 1.706-58.105 2.957-116.5 1.424-174.86-0.675-29.174-1.958-58.335-3.844-87.462-0.846-14.567-2.019-29.118-3.161-43.667-1.304-14.541-2.701-29.073-4.234-43.592-6.259-58.071-14.567-115.95-24.981-173.52-10.733-57.527-23.231-114.79-38.262-171.54-0.43-1.623-2.3-2.636-4.179-2.265-1.826 0.362-2.985 1.904-2.656 3.477z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g9-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7-3",
    d: "m732.53 1736.4c-11.822 12.543-32.613 8.936-39.725-6.765-39.242-86.634-128.04-341.61 18.615-635.36 123.85-248.06 167.43-394.33 182.61-462.11 3.211-14.332 22.851-16.234 28.779-2.797 65.406 148.25 238.11 652.52-190.28 1107z",
    fill: "url(#SVGID_00000123417293118030957290000008448576168209327256_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8-9",
    d: "m711.05 1727.3c-0.421 0.075-0.853 0.111-1.297 0.104-3.716-0.057-6.682-3.116-6.626-6.831 0.065-4.213 8.264-425.31 164.88-778 1.508-3.393 5.484-4.925 8.883-3.42 3.397 1.51 4.927 5.485 3.42 8.883-155.48 350.12-163.66 768.56-163.73 772.74-0.05 3.274-2.428 5.966-5.535 6.522z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g18-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon10",
    points: "2194.9 2508.3 1650.3 2508.3 1590.3 3045.6 2285.4 3045.6",
    fill: "url(#SVGID_00000098909845763051153590000014870951605869837757_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12-8",
    d: "m482.63 1184.4v1230.6c0 101.23 80.671 184.02 181.87 186.63 449.48 11.59 2021.5 39.694 2449.4 33.386 73.54-1.084 133.12-59.934 135.24-133.45 8.251-285.89 21.65-973.35-27.938-1292.5-10.443-67.212-67.176-117.47-135.16-119.65-376.61-12.048-2043.1-50.304-2470.8-40.699-73.759 1.656-132.66 61.907-132.66 135.68z",
    fill: "url(#SVGID_00000119828917555509783370000015597325786279213757_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14-37",
    d: "m559.85 1178.4v1169.2c0 59.106 47.446 107.27 106.54 108.15l2386 29.478c58.593 0.876 106.62-46.264 106.84-104.86l3.992-1158.7c0.156-41.9-33.225-76.231-75.112-77.25l-2442.8-49.35c-46.849-1.142-85.444 36.525-85.444 83.387z",
    fill: "url(#SVGID_00000093173410323720510400000007903223900152542382_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15-8",
    d: "m3177.2 2533.5h-0.063l-2617.3-44.594c-2.023-0.035-3.635-1.703-3.601-3.724 0.034-2.029 1.641-3.574 3.726-3.603l2617.3 44.594c2.023 0.036 3.635 1.703 3.601 3.724-0.033 2.004-1.668 3.603-3.663 3.603z",
    fill: "#fff",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16-4",
    d: "m2435.2 3155.5h-1017.3c-27.637 0-48.392-19.675-43.048-40.809l13.054-51.626c3.925-15.526 21.006-26.924 41.293-27.557l980.73-30.603c21.194-0.661 39.961 10.589 44.579 26.725l23.532 82.228c6.113 21.364-14.74 41.642-42.824 41.642z",
    fill: "url(#SVGID_00000150797358783885708480000012842919997571784586_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17-0",
    d: "m1965.5 3049.9c-1.998 0-3.631-1.606-3.662-3.61-0.029-2.025 1.587-3.689 3.61-3.718l42.027-0.612h0.055c1.998 0 3.631 1.607 3.662 3.61 0.029 2.025-1.587 3.688-3.61 3.717l-42.027 0.612h-0.055z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18-0",
    d: "m1412.5 3127.4c-0.193 0-0.386-0.014-0.583-0.046-1.998-0.319-3.359-2.197-3.039-4.193l5.995-37.549c3.247-20.347 20.556-35.331 41.157-35.635l445.74-6.515c1.934-0.075 3.687 1.588 3.718 3.61 0.029 2.025-1.587 3.688-3.61 3.717l-445.74 6.515c-17.032 0.25-31.343 12.64-34.03 29.46l-5.995 37.549c-0.287 1.803-1.845 3.087-3.613 3.087z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26-9",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path19-5",
    d: "m2643.5 1538.8h-265.21c-16.646 0-30.141-13.494-30.141-30.141s13.495-30.142 30.141-30.142h265.21c16.646 0 30.141 13.495 30.141 30.142 1e-3 16.647-13.495 30.141-30.141 30.141z",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20-4",
    d: "m2741.1 1491.4h286.25c17.968 0 32.533 53.539 32.533 119.58v704.19c0 66.045-14.565 119.58-32.533 119.58h-286.25c-17.967 0-32.533-53.536-32.533-119.58v-704.19c0-66.042 14.566-119.58 32.533-119.58z",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21-3",
    d: "m2378.3 1572.3h265.21c16.646 0 30.141 13.495 30.141 30.141v177.5c0 16.647-13.496 30.141-30.141 30.141h-265.21c-16.646 0-30.141-13.494-30.141-30.141v-177.5c0-16.646 13.495-30.141 30.141-30.141z",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22-3",
    d: "m2378.3 1863.3h265.21c16.646 0 30.142 32.525 30.142 72.645v427.79c0 40.122-13.496 72.645-30.142 72.645h-265.21c-16.646 0-30.141-32.523-30.141-72.645v-427.79c0-40.121 13.496-72.645 30.141-72.645z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23-7",
    d: "m3056.6 1441.2h-2375.8c-27.5 0-49.794-22.293-49.794-49.794v-198.15c0-27.993 23.068-50.485 51.052-49.778l2375.8 60.077c27.001 0.683 48.535 22.768 48.535 49.778v138.08c0 27.499-22.293 49.793-49.794 49.793z",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24-68",
    d: "m2261.8 2256h-800.5c-20.168 0-36.517-16.349-36.517-36.517v-682.79c0-20.168 16.349-36.517 36.517-36.517h800.5c20.168 0 36.517 16.349 36.517 36.517v682.79c0 20.167-16.349 36.517-36.517 36.517z",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25-6",
    d: "m2296 2448.9-1646-13.846c-19.957-0.168-36.046-16.393-36.046-36.351v-58.074c0-27.761 22.505-50.265 50.265-50.265h1629.5c10.718 0 19.406 8.688 19.406 19.406v122.1c0 9.464-7.715 17.114-17.179 17.035z",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26-53",
    d: "m1339.6 2238.5h-691.17c-19.002 0-34.406-15.404-34.406-34.406v-691.17c0-19.002 15.404-34.406 34.406-34.406h691.17c19.002 0 34.406 15.404 34.406 34.406v691.17c0 19.002-15.404 34.406-34.406 34.406z",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("g", {
    id: "g61-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g29-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g28-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path27-0",
    d: "m1847.3 1557.2 778.48-6.981c15.266-0.137 27.69 12.247 27.604 27.513l-3.406 597.37c-0.088 15.366-12.785 27.648-28.145 27.19-140.75-4.196-765.66-22.712-793.24-21.557-27.261 1.139-12.45-478.74-8.381-597.14 0.501-14.639 12.447-26.266 27.094-26.398z",
    fill: "url(#SVGID_00000012433440356731570030000006688954660694553016_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28-5",
    d: "m2622.6 2179.8-0.159-0.01c-111.92-3.339-675.44-20.068-778.65-21.52l-1.392-0.02-0.242-1.369c-9.758-55.052-9.562-279.77 0.5-572.49 0.087-2.586 2.19-4.627 4.784-4.646l778.48-6.981c1.704 0 2.826 0.777 3.47 1.428 0.923 0.925 1.41 2.113 1.402 3.429l-3.408 597.37c-0.013 2.65-2.158 4.805-4.782 4.805zm-777.36-24.87c106.85 1.582 665.88 18.177 777.31 21.5l0.135 0.01c0.702 0 1.337-0.656 1.341-1.459l3.407-597.37c0-0.422-0.128-0.743-0.424-1.038-0.291-0.294-0.637-0.434-1.068-0.434l-778.46 6.981c-0.787 0.01-1.423 0.619-1.451 1.396-9.971 290.13-10.263 513.3-0.783 570.42z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path29-8",
    d: "m1941.2 2103h510.31c15.885 0 25.758-17.261 17.703-30.953l-202.03-343.45c-8.426-14.324-29.49-13.233-36.389 1.887l-97.55 213.75c-5.793 12.691-22.281 16.04-32.564 6.613l-39.461-36.173c-9.168-8.404-23.642-6.796-30.742 3.415l-106.14 152.64c-9.47 13.618 0.275 32.265 16.863 32.265z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse29",
    transform: "matrix(.9239 -.3827 .3827 .9239 -471.44 1066.3)",
    cx: 2444.6,
    cy: 1718.2,
    r: 73.36,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g60-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g32-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30-6",
    d: "m3112.6 2273c-17.914-66.254-73.261-120.68-134.94-134.44-11.332-2.527-17.894-14.071-15.234-25.373 0.019-0.078 0.037-0.157 0.055-0.235 8.937-38.531-15.763-69.228-53.012-77.868-37.248-8.638-72.939 8.052-81.875 46.583-6.031 26.003 1.694 55.254 18.795 74.197 7.048 7.806 7.614 19.458 0.785 27.457-37.584 44.03-52.874 111.24-36.621 171.34 23.939 88.539 107.19 128.09 190.6 105.54 83.408-22.55 135.38-98.666 111.44-187.21z",
    fill: "url(#SVGID_00000121255058289730104800000012049694533815015326_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31-8",
    d: "m3086.6 2357.5-1.621-1.138c14.931-21.192 16.849-51.782 5.001-79.83-9.408-22.279-26.245-42.651-52.986-64.11-9.963-7.998-20.528-15.589-30.745-22.925-12.301-8.837-25.019-17.973-36.808-27.905-10.604-8.938-21.761-20.027-24.1-34.533-1.168-7.232-0.077-14.935 0.979-22.384 1.652-11.658 3.211-22.67-3.622-31.101l1.54-1.246c7.377 9.1 5.682 21.06 4.043 32.625-1.035 7.301-2.105 14.854-0.987 21.788 2.239 13.867 13.096 24.632 23.423 33.333 11.73 9.882 24.417 18.998 36.686 27.812 10.238 7.355 20.826 14.958 30.83 22.987 27.007 21.676 44.03 42.295 53.572 64.884 12.112 28.676 10.115 59.998-5.205 81.743z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32-1",
    d: "m3047 2370.3-1.861-0.673c10.159-28.098 7.185-62.628-8.162-94.739-15.214-31.824-40.083-57.772-60.049-76.824l1.366-1.432c20.089 19.165 45.117 45.286 60.47 77.404 15.574 32.583 18.577 67.67 8.236 96.264z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path33-4",
    d: "m2647 2006.8-0.688-22.882 23.918-47.492c4.375-8.688 4.409-18.927 0.092-27.644l-27.094-54.704s-15.647 118.74-19.764 128.61 11.165 27.6 11.165 27.6z",
    fill: "url(#SVGID_00000145767868375547687400000015347788309441258117_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35-5",
    d: "m2646.3 1983.9s72.748 198.32 196.7 260.3c0 0-41.257 67.316-62.788 71.398 0 0-132.42-169.48-145.92-308.33z",
    fill: "url(#SVGID_00000126294802325949112060000010710211191002116028_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37-5",
    d: "m3144.8 3176.8 3.659 30.076c3.809 14.294 22.21 50.31 45.826 47.965 14.531-1.443 16.28-43.896 14.256-50.264-3.69-11.61-10.442-29.039-20.175-39.296h-33.363c-6.169 0-10.948 5.396-10.203 11.519z",
    fill: "url(#SVGID_00000155861672047287428150000014717788061683036842_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39-6",
    d: "m2883.5 2824.5-5.631 33.125s18.858 191.01 22.212 267.42c0.526 11.979-2.573 23.817-8.86 34.027l-32.791 53.249 83.336-49.176 1.659-10.17-13.642-18.757 17.869-213.98c1.05-12.57-1.544-25.177-7.471-36.312l-17.238-32.383z",
    fill: "url(#SVGID_00000127006289731129278320000012267005091792574389_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41-1",
    d: "m2853 3220.1h26.594c4.978 0 9.673-2.285 12.709-6.23 8.291-10.773 25.468-31.79 33.681-32.339 11.057-0.739 9.642 38.569 9.642 38.569h6.198l7.851-48.845c1.975-12.29-4.136-24.464-15.172-30.222 0 0-2.528 18.692-16.233 26.959-13.705 8.268-55.77 37.877-55.77 37.877s-5.152-0.734-10.809 0.288c-8.39 1.517-7.218 13.943 1.309 13.943z",
    fill: "url(#SVGID_00000057148531611838001090000012512168209830623914_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43-7",
    d: "m2997.7 2840.3s110.48 209.56 128.04 257.41c17.562 47.846 23.713 87.76 23.949 91.54 0.368 5.906 7.714 11.571 27.963 11.571 10.45 0 15.568-4.189 18.073-8.243 2.138-3.459 2.249-7.788 0.447-11.434-6.39-12.933-26.67-54.263-34.181-73.009-8.968-22.381-28.257-123.81-38.836-159.08-10.579-35.266-22.537-73.519-68.605-108.76 0 0-31.625-30.974-56.846 0z",
    fill: "url(#SVGID_00000056387823534247972520000008672781865422673299_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45-4",
    d: "m2927.9 2496.9c-16.18-68.562 0.099-120.21 17.194-152.05 13.635-25.397 4.049-56.814-21.526-70.114-39.969-20.786-80.521-30.507-80.521-30.507s-79.196 57.899-69.801 103.22c5.507 26.562 55.667 159.1 55.667 159.1s46.384 21.952 98.987-9.642z",
    fill: "url(#SVGID_00000160167077789473137970000017271167619637359282_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47-4",
    d: "m2991.1 2556.7c-11.597-34.938-63.183-59.782-63.183-59.782-52.603 31.594-98.986 9.642-98.986 9.642s-10.402 39.76-3.222 76.709c7.179 36.95 52.223 274.42 52.223 274.42 70.973 14.381 180.13-14.468 180.13-14.468-45.207-80.262-55.362-251.58-66.96-286.52z",
    fill: "url(#SVGID_00000036248008372141159810000014012371011415691174_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    d: "m2894.8 2164.4 23.169 104.07c2.218 9.167-6.138 7.667-15.406 5.919-15.177-2.862-34.739-8.755-41.279-20.565-0.665-1.202-0.998-2.561-1.186-3.922l-9.954-72.165c-0.79-5.726 2.305-11.282 7.589-13.625l19.208-8.517c7.396-3.279 15.956 0.941 17.859 8.804z",
    fill: "url(#SVGID_00000183208277611434962600000001046633294711992992_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51-0",
    d: "m2605.2 2095.7s60.979 211.84 306.88 191.93c15.732-1.273 29.551 10.384 30.774 26.12l0.661 8.503c1.772 22.795-16.83 42.011-39.665 40.856-81.786-4.137-257.43-36.257-317.63-230.58z",
    fill: "url(#SVGID_00000180338681985789405450000012380444343976624570_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53-2",
    d: "m2586.2 2132.5s-11.717-34.483-14.661-56.037 7.892-69.931 17.203-83.534c9.312-13.603 10.87 19.743 15.062 35.413s-2.908 38.032-2.908 38.032l4.282 29.305z",
    fill: "url(#SVGID_00000073694119909794220420000006590638614203047602_)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g59-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path55-0",
    d: "m2847.3 2078.6s-58.584 85.345-22.152 109.12c36.431 23.781 78.136-36.872 78.136-36.872s13.092-46.354-1.803-61.714c-14.894-15.36-54.181-10.539-54.181-10.539z",
    fill: "url(#SVGID_00000003824175442088235630000016428937389097010607_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57-5",
    d: "m2871.9 2057.9s-25.488 6.55-28.857 18.202 36.729 21.641 47.917 21.955l9.89 46.575s25.796-44.477 14.769-69.675c-11.027-25.197-43.719-17.057-43.719-17.057z",
    fill: "url(#SVGID_00000142874473602750082140000010672921293727273881_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59-06",
    d: "m2891.5 2144.8s22.909-27.567 32.559-10.059c9.65 17.507-20.497 31.357-31.184 22.874z",
    fill: "url(#SVGID_00000096054419447218278060000010041112042875498137_)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g69-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g64-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path62-7",
    d: "m700.05 2963h932.69v-151.48h-932.69c19.963 0 19.963 151.48 0 151.48z",
    fill: "url(#SVGID_00000059267434382287216220000004489918044642373018_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64-0",
    d: "m1632.7 2925.1v-69.325c0-24.438-18.432-44.249-41.168-44.249h-887.59c-17.88 0-32.375-11.762-32.375-26.271 0-4.408 4.404-7.982 9.837-7.982h970.07c22.247 0 57.567 28.382 57.567 63.394v96.821c0 33.01-34.29 59.771-55.265 59.771h-967.27c-8.251 0-14.94-5.428-14.94-12.123 0-12.222 12.21-22.129 27.271-22.129h898.6c19.478 0 35.268-16.971 35.268-37.907z",
    fill: "url(#SVGID_00000070812078389389961600000016134425165338174892_)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path65-0",
    d: "m1606.9 2845.9h-874.53c-1.858 0-3.365-1.507-3.365-3.365s1.507-3.365 3.365-3.365h874.53c1.858 0 3.365 1.507 3.365 3.365-1e-3 1.858-1.508 3.365-3.366 3.365z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66-1",
    d: "m1606.9 2868.4h-874.53c-1.858 0-3.365-1.507-3.365-3.365s1.507-3.365 3.365-3.365h874.53c1.858 0 3.365 1.507 3.365 3.365s-1.508 3.365-3.366 3.365z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path67-9",
    d: "m1606.9 2890.9h-874.53c-1.858 0-3.365-1.507-3.365-3.365s1.507-3.365 3.365-3.365h874.53c1.858 0 3.365 1.507 3.365 3.365-1e-3 1.858-1.508 3.365-3.366 3.365z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68-1",
    d: "m1606.9 2913.4h-874.53c-1.858 0-3.365-1.507-3.365-3.365s1.507-3.365 3.365-3.365h874.53c1.858 0 3.365 1.507 3.365 3.365s-1.508 3.365-3.366 3.365z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path69-3",
    d: "m1606.9 2935.9h-874.53c-1.858 0-3.365-1.507-3.365-3.365s1.507-3.365 3.365-3.365h874.53c1.858 0 3.365 1.507 3.365 3.365s-1.508 3.365-3.366 3.365z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path70-0",
    d: "m1723 3252.5h-1202c-11.814 0-21.391-9.577-21.391-21.391v-210.33c0-11.814 9.577-21.391 21.391-21.391h1202c11.814 0 21.391 9.577 21.391 21.391v210.33c0 11.814-9.577 21.391-21.391 21.391z",
    fill: "url(#SVGID_00000136402634363684585320000006862258134375914666_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72-6",
    d: "m779.25 3223.4h-131.75c-4 0-7.242-3.242-7.242-7.242v-180.45c0-4 3.242-7.242 7.242-7.242h131.75c4 0 7.242 3.242 7.242 7.242v180.45c0 3.999-3.242 7.242-7.242 7.242z",
    fill: "url(#SVGID_00000180349596226331042480000010840716938464896388_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74-0",
    d: "m856.98 3223.4h-43.088c-3.253 0-5.89-2.637-5.89-5.89v-183.15c0-3.253 2.637-5.89 5.89-5.89h43.088c3.253 0 5.89 2.637 5.89 5.89v183.15c0 3.253-2.637 5.89-5.89 5.89z",
    fill: "url(#SVGID_00000032623186513359405750000012785328301312811672_)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g106-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path76-8",
    d: "m1129.3 2096.1c-0.604 1.145-38.656 29.146-38.656 29.146s8.403 60.117 42.526 83.856c37.517 26.099 90.5-21.498 90.5-21.498s42.166 10.023 64.589-77.75c5.144-20.137-24.552-21.839-60.392-18.131-46.216 4.784-98.567 4.377-98.567 4.377z",
    fill: "url(#SVGID_00000024715384995037754330000010483725735170682250_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78-9",
    d: "m1058.2 2301.2c14.886-10.235 31.345-17.952 48.794-22.7 6.554-1.783 41.942 8.502 63.817 7.999 30.028-0.69 60.594-14.356 85.346-8.187 24.587 6.127 44.71 14.13 56.329 22.394 34.779 24.736 55.198 70.859 67.642 116.55-23.563 24.188-53.215 34.938-53.215 34.938l-5.479 222.08-131.32 67.187-149.88-75.25 5.369-217.02s-47.595-22.165-51.087-30.228 21.692-88.883 63.684-117.76z",
    fill: "url(#SVGID_00000103244378409925569540000016965414628150126739_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80-9",
    d: "m996.69 2418s-63.78 176.82 81.662 249.5c30.199-4.012 18.584-54.164 18.584-54.164s-63.195-13.986-44.216-161.49c-17.474-14.376-56.03-33.843-56.03-33.843z",
    fill: "url(#SVGID_00000049910347570220484680000000597896893701108899_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82-7",
    d: "m1377 2418s43.887 184.58-81.662 249.5c-30.2-4.012-18.584-54.164-18.584-54.164s50.932-25.084 44.216-161.49c17.473-14.376 56.03-33.843 56.03-33.843z",
    fill: "url(#SVGID_00000027592542826384946180000009731866730917058228_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84-4",
    d: "m1318.1 2679.9h-271.29c-4.584 0-8.334-3.75-8.334-8.334v-177.8c0-4.584 3.75-8.334 8.334-8.334h271.29c4.584 0 8.334 3.75 8.334 8.334v177.8c1e-3 4.584-3.75 8.334-8.334 8.334z",
    fill: "url(#SVGID_00000119829255027656507080000006627442016540507068_)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86-7",
    d: "m1452.7 2737.6c-32.955-7.564-109.12-3.498-109.12-3.498l-3.098 8.39-5.13 41.701s72.536 13.074 108.29 13.042c3.648 0 6.984-0.551 10.032-1.499 1.09-0.978 2.155-1.992 3.163-3.093 15.17-16.567 10.789-40.903-4.135-55.043z",
    fill: "url(#SVGID_00000065057624785415088930000005202497983871013025_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88-5",
    d: "m1321.7 2731.7 12.897 0.55c6.93 0.295 13.46 3.672 18.119 9.368s7.055 13.232 6.648 20.91c-0.326 6.121-2.837 11.847-6.979 15.908s-9.574 6.124-15.092 5.731l-19.734-1.404z",
    fill: "url(#SVGID_00000008119365616928549590000003286971871700152708_)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path90-7",
    d: "m888.04 2733.5c33.131-6.551 109.17-0.148 109.17-0.148l2.887 8.481 4.088 41.843s-72.834 10.843-108.57 9.715c-3.647-0.115-6.969-0.765-9.991-1.807-1.066-1.011-2.105-2.058-3.085-3.189-14.75-17.026-9.763-41.219 5.508-54.895z",
    fill: "url(#SVGID_00000134942934122744615380000000543446911036119436_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92-9",
    d: "m1019.1 2731.7-12.906 0.154c-6.934 0.083-13.546 3.258-18.346 8.809-4.799 5.551-7.382 13.011-7.167 20.698 0.172 6.129 2.54 11.929 6.58 16.117 4.039 4.187 9.417 6.416 14.943 6.192l19.762-0.798z",
    fill: "url(#SVGID_00000075156606444083772850000003998114166742077119_)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path94-0",
    d: "m1461.9 2606.8c-14.945-34.396-51.498-39.979-82.608-23.897-0.542 0.711-197.57 101.69-371.33 145.95 4.974 15.947 7.532 32.916 8.089 49.594 0.101 3.716 0.039 7.381-0.179 10.997 133.25-6.844 277.86-51.281 402.12-90.333 38.534-12.428 60.468-54.186 43.903-92.309z",
    fill: "url(#SVGID_00000032647687386308890090000004867695665167111095_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96-5",
    d: "m1322.7 2781.1c-0.521-19.224 3.217-37.121 11.213-53.689 0.229-0.759 0.502-1.488 0.744-2.237-9.922-3.073-22.74-7.237-39.579-12.949-123.38-42.225-217.51-84.861-307.35-133.94-34.899-19.067-74.58-6.288-85.752 35.007-9.973 36.865 11.928 68.337 45.167 79.398 99.443 33.091 47.666 23.9 80.144 34.352 87.222 26.972 195.76 51.539 295.62 58.247-0.076-1.397-0.162-2.794-0.209-4.187z",
    fill: "url(#SVGID_00000149347290681369176030000011862234838761214634_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98-3",
    d: "m1107 2278.5s13.27 57.504 77.694 56.31c65.619-1.194 71.469-56.499 71.469-56.499l-42.864-9.172-3.582-47.761-64.477 4.777-1.194 45.373z",
    fill: "url(#SVGID_00000016764513929429233440000008101920196457355399_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100-1",
    d: "m1154.2 2086.1s-73.89 143.13 13.76 177.85c61.825 24.493 100.59-95.049 89.026-127.43-17.876-50.062-29.65-44.122-29.65-44.122z",
    fill: "url(#SVGID_00000013896166155030400350000003548011044717471888_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102-4",
    d: "m1274.8 2073c36.503 10.033 5.306 89.2-49.651 70.479-54.958-18.721-76.554-18.448-85.118-3.357s-10.404 68.683-28.986 42.194c-20.372-29.041-31.732-87.331-6.753-106.12 22.323-16.793 27.532-42.831 54.307-41.928 35.539 1.198 63.023-14.556 79.065-3.195 18.423 13.048 10.277 34.546 37.136 41.928z",
    fill: "url(#SVGID_00000163045720834340893020000011436860482050806174_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104-5",
    d: "m1136.7 2152.5s-15.759-16.956-18.281 3.48c-2.523 20.436 5.576 46.756 15.064 32.329 9.487-14.427 3.217-35.809 3.217-35.809z",
    fill: "url(#SVGID_00000155851387241616723420000003624910578456651924_)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path106-2",
    d: "m1199.4 2567.4c1.527 10.317-4.001 19.682-14.318 21.209-10.318 1.527-19.919-5.6-21.446-15.917-1.526-10.317 3.195-20.565 13.513-22.091 10.318-1.527 20.724 6.481 22.251 16.799z",
    fill: "url(#SVGID_00000130617072708312783100000018275990001070300548_)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g119"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle106",
    cx: 1001.4,
    cy: 1686.7,
    r: 337.03,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "m723.58 1670.3 70.721-36.877v15.714c0 1.192-0.299 2.279-0.894 3.261-0.596 0.982-1.578 1.828-2.946 2.543l-32.414 16.609c-1.371 0.715-2.812 1.325-4.331 1.831-1.517 0.506-3.141 0.968-4.866 1.384 1.725 0.416 3.349 0.878 4.866 1.384 1.519 0.506 2.96 1.116 4.331 1.831l32.414 16.699c1.368 0.712 2.35 1.561 2.946 2.543 0.594 0.982 0.894 2.069 0.894 3.258v15.716l-70.721-36.967z",
    fill: "url(#SVGID_00000126309739124055247540000008039247533513984927_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "m826.54 1734.9v-132.69h22.056v50.986c3.571-3.392 7.501-6.13 11.787-8.214 4.286-2.081 9.316-3.125 15.09-3.125 5.001 0 9.435 0.849 13.305 2.546 3.869 1.695 7.098 4.078 9.688 7.142 2.59 3.067 4.553 6.729 5.893 10.984s2.009 8.944 2.009 14.063v58.308h-22.055v-58.308c0-5.595-1.295-9.926-3.885-12.993-2.59-3.064-6.473-4.598-11.653-4.598-3.811 0-7.381 0.863-10.715 2.59s-6.489 4.078-9.464 7.055v66.255h-22.056z",
    fill: "url(#SVGID_00000146491883155936271640000008500859777069182394_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "m958.16 1736.3c-7.918 0-14.019-2.247-18.305-6.744-4.286-4.494-6.43-10.7-6.43-18.617v-51.164h-9.286c-1.192 0-2.219-0.387-3.081-1.163-0.863-0.773-1.295-1.933-1.295-3.482v-8.749l14.734-2.413 4.643-25c0.237-1.192 0.788-2.113 1.651-2.77 0.863-0.654 1.949-0.983 3.26-0.983h11.429v28.843h24.109v15.716h-24.109v49.646c0 2.857 0.715 5.09 2.144 6.697s3.333 2.41 5.715 2.41c1.369 0 2.514-0.163 3.437-0.488 0.923-0.328 1.727-0.672 2.411-1.029 0.685-0.358 1.295-0.698 1.831-1.026 0.535-0.325 1.071-0.491 1.607-0.491 0.654 0 1.19 0.166 1.607 0.491 0.416 0.328 0.862 0.82 1.339 1.474l6.608 10.714c-3.215 2.68-6.906 4.703-11.073 6.072-4.165 1.37-8.482 2.056-12.946 2.056z",
    fill: "url(#SVGID_00000018946021706565558580000001575258451275350459_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "m997.18 1734.9v-91.613h13.484c2.857 0 4.732 1.337 5.625 4.017l1.429 6.787c1.607-1.788 3.289-3.424 5.046-4.912 1.754-1.488 3.63-2.767 5.625-3.84 1.994-1.073 4.138-1.918 6.43-2.543 2.291-0.625 4.806-0.939 7.546-0.939 5.773 0 10.521 1.564 14.241 4.688 3.721 3.125 6.504 7.275 8.349 12.455 1.429-3.035 3.215-5.639 5.357-7.813 2.144-2.171 4.495-3.942 7.054-5.313 2.559-1.366 5.283-2.378 8.171-3.035 2.886-0.654 5.789-0.982 8.706-0.982 5.059 0 9.554 0.773 13.484 2.323 3.928 1.549 7.232 3.811 9.912 6.784 2.678 2.979 4.716 6.61 6.116 10.894 1.398 4.287 2.099 9.197 2.099 14.734v58.308h-22.056v-58.308c0-5.834-1.28-10.223-3.838-13.17-2.561-2.947-6.312-4.421-11.252-4.421-2.263 0-4.362 0.39-6.294 1.163-1.936 0.773-3.632 1.889-5.091 3.349-1.459 1.459-2.604 3.287-3.437 5.491-0.834 2.203-1.25 4.732-1.25 7.589v58.308h-22.145v-58.308c0-6.13-1.237-10.595-3.706-13.394-2.471-2.796-6.117-4.197-10.938-4.197-3.157 0-6.117 0.791-8.886 2.366-2.767 1.578-5.342 3.738-7.723 6.476v67.057h-22.058z",
    fill: "url(#SVGID_00000120545269160990797450000017593968488008271807_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "m1171 1602.2v132.69h-22.056v-132.69z",
    fill: "url(#SVGID_00000070082901237665985070000009831773738052753799_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "m1204.6 1716.2v-15.716c0-1.189 0.297-2.276 0.892-3.258 0.594-0.983 1.577-1.831 2.947-2.543l32.412-16.699c2.619-1.308 5.684-2.381 9.198-3.215-1.728-0.416-3.349-0.878-4.867-1.384-1.517-0.506-2.962-1.116-4.331-1.831l-32.412-16.609c-1.37-0.715-2.353-1.561-2.947-2.543-0.596-0.983-0.892-2.07-0.892-3.261v-15.714l70.72 36.877v8.929z",
    fill: "url(#SVGID_00000006680315642275126000000013376675634451725246_)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g125"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle119",
    cx: 1774.4,
    cy: 1469,
    r: 296.87,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "m1617.5 1469.5 85.801-44.74v19.064c0 1.446-0.367 2.765-1.086 3.957-0.723 1.192-1.915 2.222-3.576 3.089l-39.323 20.15c-1.661 0.864-3.41 1.608-5.254 2.218-1.841 0.617-3.812 1.174-5.903 1.678 2.091 0.504 4.063 1.068 5.903 1.682 1.844 0.614 3.594 1.354 5.254 2.218l39.323 20.259c1.661 0.867 2.853 1.897 3.576 3.089 0.719 1.188 1.086 2.507 1.086 3.95v19.071l-85.801-44.853z",
    fill: "url(#SVGID_00000155147862518604541580000016873595598943496870_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "m1751.7 1548.2c-0.649 1.664-1.481 3.107-2.49 4.338-1.012 1.227-2.165 2.257-3.467 3.086-1.301 0.829-2.673 1.464-4.115 1.894-1.446 0.437-2.856 0.652-4.225 0.652h-11.27l63.267-161.85c1.227-3.033 2.994-5.364 5.307-6.986 2.313-1.626 5.092-2.44 8.344-2.44h11.376z",
    fill: "url(#SVGID_00000003820701522329797970000012454256313383754401_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "m1836.8 1525.2v-19.071c0-1.442 0.36-2.761 1.079-3.95 0.723-1.192 1.915-2.222 3.576-3.089l39.327-20.259c3.174-1.587 6.894-2.888 11.157-3.9-2.095-0.504-4.062-1.061-5.903-1.678-1.841-0.61-3.597-1.354-5.254-2.218l-39.327-20.15c-1.661-0.867-2.853-1.897-3.576-3.089-0.719-1.192-1.079-2.511-1.079-3.957v-19.064l85.798 44.74v10.833z",
    fill: "url(#SVGID_00000041975470230838145490000010677777126521910158_)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g127",
    fill: "#fff",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "path125",
    d: "m3108.9 1641c-0.874 0-1.746-0.339-2.405-1.012-1.3-1.329-1.277-3.459 0.052-4.758 1.985-1.942 3.94-3.907 5.869-5.895 1.293-1.334 3.426-1.365 4.758-0.072 1.334 1.293 1.367 3.424 0.072 4.758-1.969 2.031-3.966 4.038-5.994 6.02-0.653 0.64-1.502 0.959-2.352 0.959z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    d: "m2899 1729.6c-1.821 0-3.319-1.454-3.362-3.284-0.046-1.858 1.424-3.399 3.283-3.444 5.445-0.131 10.979-0.414 16.45-0.843 1.873-0.154 3.472 1.241 3.618 3.092 0.145 1.853-1.24 3.473-3.092 3.618-5.593 0.437-11.25 0.726-16.815 0.859h-0.082zm-16.661-0.043h-0.102c-5.588-0.164-11.245-0.485-16.813-0.95-1.852-0.154-3.227-1.781-3.072-3.634 0.154-1.85 1.786-3.248 3.634-3.072 5.448 0.455 10.982 0.769 16.45 0.93 1.858 0.054 3.32 1.605 3.265 3.462-0.055 1.823-1.55 3.266-3.362 3.266zm49.853-2.558c-1.661 0-3.107-1.231-3.33-2.923-0.245-1.842 1.05-3.532 2.893-3.777 5.405-0.718 10.876-1.595 16.262-2.609 1.835-0.343 3.587 0.861 3.93 2.685 0.343 1.827-0.859 3.585-2.685 3.93-5.504 1.035-11.097 1.932-16.624 2.665-0.148 0.019-0.298 0.029-0.446 0.029zm-83.04-0.209c-0.153 0-0.307-0.01-0.463-0.031-5.552-0.764-11.139-1.686-16.612-2.74-1.824-0.352-3.018-2.116-2.667-3.942 0.353-1.822 2.106-3.015 3.941-2.667 5.353 1.032 10.823 1.934 16.254 2.681 1.842 0.253 3.128 1.952 2.875 3.792-0.231 1.686-1.674 2.907-3.328 2.907zm115.76-5.948c-1.515 0-2.89-1.029-3.265-2.566-0.442-1.804 0.664-3.626 2.469-4.066 5.292-1.295 10.638-2.755 15.889-4.344 1.779-0.541 3.657 0.467 4.195 2.246 0.539 1.779-0.467 3.657-2.246 4.195-5.366 1.623-10.831 3.119-16.241 4.439-0.267 0.065-0.537 0.096-0.801 0.096zm-148.46-0.345c-0.27 0-0.542-0.031-0.815-0.099-5.419-1.347-10.877-2.857-16.223-4.49-1.776-0.544-2.777-2.425-2.234-4.201 0.545-1.779 2.433-2.773 4.203-2.236 5.231 1.6 10.574 3.079 15.878 4.395 1.802 0.448 2.902 2.274 2.455 4.078-0.382 1.532-1.755 2.553-3.264 2.553zm180.34-9.291c-1.377 0-2.668-0.853-3.164-2.221-0.633-1.748 0.273-3.677 2.019-4.31 5.126-1.855 10.288-3.879 15.341-6.017 1.707-0.721 3.687 0.076 4.41 1.788 0.725 1.712-0.076 3.685-1.788 4.41-5.162 2.185-10.435 4.252-15.673 6.148-0.378 0.137-0.766 0.202-1.145 0.202zm-212.18-0.438c-0.383 0-0.772-0.067-1.153-0.205-5.261-1.919-10.528-4.002-15.653-6.188-1.709-0.729-2.504-2.706-1.774-4.416 0.729-1.709 2.699-2.506 4.416-1.774 5.014 2.139 10.168 4.178 15.318 6.056 1.745 0.637 2.645 2.568 2.008 4.315-0.499 1.364-1.789 2.212-3.162 2.212zm242.86-12.541c-1.249 0-2.447-0.695-3.03-1.893-0.812-1.671-0.117-3.685 1.554-4.499 4.922-2.394 9.84-4.949 14.619-7.597 1.628-0.899 3.675-0.309 4.573 1.314 0.902 1.625 0.314 3.672-1.313 4.573-4.881 2.706-9.907 5.317-14.935 7.763-0.474 0.23-0.975 0.339-1.468 0.339zm-273.49-0.518c-0.496 0-1.002-0.11-1.479-0.343-5.024-2.466-10.039-5.095-14.904-7.816-1.623-0.907-2.203-2.957-1.296-4.579 0.907-1.623 2.954-2.202 4.579-1.296 4.763 2.663 9.669 5.236 14.585 7.648 1.669 0.82 2.358 2.836 1.54 4.503-0.585 1.191-1.781 1.883-3.025 1.883zm302.61-15.612c-1.122 0-2.218-0.56-2.857-1.582-0.984-1.576-0.504-3.651 1.071-4.636 4.627-2.892 9.245-5.954 13.726-9.104 1.525-1.065 3.619-0.702 4.689 0.818 1.068 1.521 0.702 3.62-0.818 4.689-4.581 3.219-9.301 6.349-14.031 9.304-0.555 0.347-1.171 0.511-1.78 0.511zm-331.67-0.626c-0.615 0-1.235-0.168-1.792-0.519-4.725-2.982-9.429-6.132-13.982-9.359-1.516-1.075-1.875-3.176-0.8-4.691 1.073-1.516 3.174-1.876 4.691-0.8 4.456 3.159 9.06 6.24 13.683 9.158 1.572 0.992 2.042 3.071 1.05 4.641-0.642 1.015-1.733 1.57-2.85 1.57zm358.91-18.515c-0.996 0-1.983-0.44-2.647-1.285-1.148-1.461-0.896-3.577 0.565-4.725 4.3-3.38 8.563-6.922 12.669-10.525 1.398-1.229 3.523-1.086 4.748 0.309 1.226 1.396 1.088 3.523-0.309 4.748-4.198 3.684-8.555 7.303-12.948 10.758-0.616 0.485-1.35 0.72-2.078 0.72zm-386.05-0.728c-0.733 0-1.47-0.238-2.088-0.728-4.38-3.472-8.719-7.104-12.898-10.799-1.392-1.231-1.521-3.357-0.291-4.75 1.23-1.39 3.355-1.525 4.75-0.291 4.086 3.615 8.332 7.17 12.618 10.566 1.456 1.153 1.702 3.271 0.547 4.727-0.663 0.838-1.646 1.275-2.638 1.275zm-24.921-22.035c-0.853 0-1.705-0.322-2.361-0.968-3.971-3.91-7.893-7.988-11.659-12.119-1.252-1.374-1.155-3.501 0.219-4.753 1.377-1.252 3.503-1.153 4.753 0.219 3.685 4.042 7.525 8.033 11.409 11.859 1.324 1.304 1.341 3.434 0.036 4.758-0.659 0.668-1.528 1.004-2.397 1.004zm-22.398-24.58c-0.974 0-1.942-0.422-2.607-1.235-3.539-4.331-7.004-8.812-10.297-13.317-1.096-1.5-0.769-3.605 0.733-4.701 1.5-1.101 3.605-0.769 4.701 0.731 3.222 4.406 6.611 8.79 10.075 13.027 1.176 1.439 0.963 3.559-0.477 4.735-0.624 0.512-1.378 0.76-2.128 0.76zm-19.648-26.871c-1.099 0-2.177-0.537-2.823-1.526-3.054-4.686-6.018-9.51-8.811-14.34-0.93-1.609-0.38-3.667 1.229-4.597 1.612-0.932 3.664-0.383 4.597 1.229 2.732 4.727 5.634 9.447 8.624 14.031 1.014 1.557 0.575 3.643-0.981 4.658-0.568 0.369-1.206 0.545-1.835 0.545zm-16.667-28.813c-1.226 0-2.407-0.67-3.002-1.837-1.195-2.345-2.366-4.71-3.51-7.101-1.288-2.688-2.535-5.384-3.74-8.093-0.756-1.699 0.01-3.687 1.707-4.441 1.694-0.761 3.687 0.01 4.441 1.707 1.179 2.65 2.399 5.29 3.661 7.921 1.12 2.34 2.266 4.656 3.435 6.951 0.845 1.655 0.188 3.682-1.469 4.526-0.488 0.249-1.009 0.367-1.523 0.367zm-13.548-30.419c-1.352 0-2.629-0.823-3.142-2.162-2.001-5.22-3.887-10.56-5.604-15.875-0.572-1.769 0.399-3.665 2.167-4.237 1.776-0.568 3.667 0.399 4.237 2.167 1.681 5.202 3.526 10.428 5.483 15.536 0.665 1.735-0.202 3.68-1.937 4.346-0.396 0.153-0.803 0.225-1.204 0.225zm-10.239-31.688c-1.49 0-2.852-0.997-3.251-2.505-1.428-5.391-2.731-10.903-3.871-16.386-0.378-1.819 0.789-3.601 2.609-3.979 1.809-0.376 3.602 0.789 3.979 2.609 1.115 5.364 2.39 10.758 3.789 16.034 0.475 1.796-0.595 3.638-2.391 4.114-0.289 0.075-0.58 0.113-0.864 0.113zm-6.782-32.601c-1.635 0-3.068-1.193-3.322-2.859-0.841-5.527-1.541-11.148-2.083-16.706-0.181-1.85 1.173-3.496 3.021-3.675 1.88-0.191 3.496 1.175 3.675 3.022 0.531 5.44 1.218 10.941 2.041 16.348 0.279 1.837-0.984 3.554-2.821 3.833-0.171 0.026-0.342 0.037-0.511 0.037zm-3.227-33.137c-1.792 0-3.281-1.411-3.36-3.219-0.194-4.467-0.292-9.017-0.292-13.524 0-1.104 0.01-2.207 0.018-3.311 0.02-1.845 1.523-3.329 3.365-3.329h0.036c1.858 0.02 3.348 1.543 3.329 3.401-0.011 1.078-0.018 2.157-0.018 3.238 0 4.41 0.097 8.862 0.286 13.231 0.081 1.857-1.359 3.427-3.215 3.508-0.051 0-0.101 0.01-0.149 0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path127",
    d: "m2580.7 1398.6c-0.074 0-0.148 0-0.222-0.01-1.855-0.122-3.26-1.722-3.14-3.577 0.186-2.831 0.406-5.654 0.667-8.473 0.171-1.85 1.779-3.232 3.661-3.04 1.85 0.171 3.21 1.809 3.04 3.661-0.255 2.757-0.471 5.521-0.651 8.289-0.117 1.78-1.597 3.147-3.355 3.147z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g130",
    fill: "#fff",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "m2686.9 1183.8c-0.94 0-1.875-0.391-2.54-1.157-1.219-1.401-1.073-3.527 0.33-4.747 2.133-1.857 4.295-3.687 6.487-5.491 1.433-1.185 3.552-0.979 4.735 0.457 1.183 1.433 0.978 3.554-0.457 4.735-2.143 1.768-4.259 3.559-6.349 5.376-0.637 0.556-1.423 0.827-2.206 0.827z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path129",
    d: "m3202 1435.4c-0.064 0-0.126 0-0.191-0.01-1.855-0.104-3.276-1.691-3.173-3.547 0.312-5.621 0.472-11.325 0.472-16.957 0-1.858 1.507-3.365 3.365-3.365s3.365 1.507 3.365 3.365c0 5.755-0.163 11.586-0.481 17.332-0.1 1.79-1.584 3.177-3.357 3.177zm0-34.291c-1.773 0-3.256-1.387-3.356-3.178-0.314-5.64-0.789-11.327-1.408-16.905-0.207-1.848 1.124-3.511 2.97-3.716 1.832-0.205 3.511 1.124 3.717 2.971 0.636 5.701 1.119 11.514 1.441 17.276 0.104 1.855-1.318 3.444-3.173 3.547h-0.191zm-3.797-34.077c-1.615 0-3.04-1.163-3.315-2.808-0.93-5.547-2.032-11.148-3.273-16.644-0.409-1.812 0.729-3.615 2.542-4.024 1.819-0.407 3.615 0.731 4.024 2.542 1.268 5.617 2.394 11.342 3.345 17.012 0.307 1.832-0.93 3.569-2.762 3.876-0.19 0.031-0.377 0.046-0.561 0.046zm-7.546-33.445c-1.465 0-2.814-0.966-3.235-2.446-1.536-5.397-3.25-10.842-5.095-16.18-0.606-1.756 0.325-3.672 2.082-4.28 1.761-0.601 3.672 0.325 4.28 2.082 1.885 5.456 3.636 11.02 5.207 16.539 0.508 1.786-0.529 3.647-2.317 4.157-0.308 0.085-0.619 0.128-0.922 0.128zm-11.191-32.413c-1.327 0-2.584-0.79-3.117-2.095-2.126-5.213-4.426-10.438-6.835-15.531-0.795-1.681-0.077-3.687 1.602-4.48 1.682-0.792 3.688-0.077 4.48 1.602 2.461 5.205 4.811 10.543 6.983 15.866 0.703 1.722-0.123 3.685-1.844 4.387-0.416 0.17-0.847 0.251-1.269 0.251zm-14.659-31.004c-1.196 0-2.354-0.637-2.962-1.765-2.688-4.969-5.54-9.912-8.476-14.693-0.973-1.584-0.478-3.656 1.106-4.628 1.586-0.973 3.656-0.477 4.628 1.106 3 4.886 5.915 9.937 8.66 15.016 0.884 1.633 0.276 3.675-1.359 4.559-0.507 0.275-1.056 0.405-1.597 0.405zm-17.938-29.212c-1.066 0-2.116-0.506-2.77-1.449-3.202-4.625-6.58-9.225-10.039-13.673-1.14-1.467-0.875-3.58 0.592-4.722 1.461-1.139 3.579-0.877 4.722 0.592 3.534 4.544 6.986 9.245 10.259 13.972 1.058 1.528 0.677 3.625-0.851 4.683-0.585 0.403-1.252 0.597-1.913 0.597zm-21.039-27.044c-0.94 0-1.875-0.391-2.54-1.155-3.685-4.236-7.548-8.429-11.478-12.465-1.296-1.333-1.268-3.462 0.063-4.758 1.331-1.298 3.463-1.268 4.758 0.063 4.019 4.127 7.967 8.414 11.734 12.741 1.219 1.403 1.073 3.527-0.329 4.748-0.637 0.553-1.424 0.826-2.208 0.826zm-23.9-24.543c-0.813 0-1.63-0.294-2.276-0.887-4.127-3.795-8.432-7.536-12.794-11.121-1.436-1.18-1.643-3.299-0.463-4.735 1.181-1.438 3.302-1.645 4.735-0.463 4.458 3.662 8.857 7.487 13.077 11.365 1.369 1.259 1.457 3.386 0.2 4.755-0.664 0.719-1.571 1.086-2.479 1.086zm-395.12-21.545c-1.035 0-2.055-0.475-2.716-1.374-1.099-1.498-0.777-3.603 0.721-4.704 4.633-3.403 9.427-6.722 14.251-9.868 1.554-1.017 3.643-0.578 4.656 0.979 1.015 1.556 0.577 3.641-0.979 4.656-4.72 3.079-9.411 6.329-13.946 9.657-0.599 0.442-1.297 0.654-1.987 0.654zm368.64-0.208c-0.69 0-1.386-0.212-1.986-0.651-4.528-3.32-9.22-6.565-13.948-9.644-1.557-1.015-1.996-3.099-0.982-4.656 1.017-1.557 3.102-1.996 4.656-0.983 4.83 3.146 9.625 6.464 14.253 9.855 1.499 1.099 1.822 3.205 0.725 4.704-0.659 0.898-1.681 1.375-2.718 1.375zm-339.93-18.529c-1.163 0-2.295-0.603-2.918-1.684-0.928-1.609-0.376-3.667 1.234-4.595 4.985-2.875 10.114-5.65 15.245-8.246 1.661-0.841 3.685-0.174 4.521 1.482 0.84 1.66 0.176 3.684-1.482 4.522-5.024 2.542-10.044 5.258-14.923 8.072-0.528 0.305-1.106 0.449-1.677 0.449zm311.21-0.179c-0.57 0-1.147-0.145-1.676-0.449-4.862-2.801-9.883-5.51-14.925-8.056-1.66-0.836-2.327-2.86-1.489-4.518 0.836-1.658 2.864-2.328 4.518-1.489 5.154 2.599 10.285 5.368 15.254 8.23 1.61 0.928 2.164 2.985 1.237 4.595-0.622 1.083-1.754 1.687-2.919 1.687zm-280.62-15.312c-1.293 0-2.527-0.751-3.082-2.011-0.748-1.7 0.025-3.687 1.725-4.436 5.281-2.323 10.681-4.526 16.054-6.547 1.73-0.651 3.68 0.225 4.334 1.965 0.654 1.738-0.225 3.68-1.965 4.334-5.258 1.978-10.543 4.134-15.712 6.409-0.441 0.194-0.901 0.286-1.354 0.286zm250.02-0.132c-0.45 0-0.909-0.092-1.347-0.284-5.143-2.251-10.431-4.395-15.722-6.373-1.74-0.651-2.624-2.588-1.973-4.329 0.651-1.742 2.599-2.627 4.329-1.973 5.406 2.019 10.811 4.211 16.065 6.511 1.702 0.746 2.478 2.729 1.732 4.433-0.554 1.261-1.788 2.015-3.084 2.015zm-217.93-11.944c-1.429 0-2.755-0.92-3.207-2.356-0.559-1.773 0.426-3.662 2.198-4.219 5.486-1.728 11.095-3.325 16.675-4.748 1.807-0.453 3.633 0.631 4.091 2.43 0.46 1.801-0.627 3.633-2.428 4.093-5.46 1.392-10.949 2.954-16.317 4.643-0.337 0.106-0.677 0.157-1.012 0.157zm185.81-0.058c-0.333 0-0.672-0.051-1.007-0.154-5.358-1.677-10.85-3.232-16.325-4.619-1.801-0.455-2.892-2.287-2.435-4.088 0.455-1.802 2.274-2.9 4.088-2.435 5.593 1.416 11.205 3.003 16.683 4.717 1.773 0.555 2.76 2.443 2.207 4.218-0.453 1.438-1.78 2.361-3.211 2.361zm-152.59-8.415c-1.576 0-2.982-1.111-3.297-2.716-0.36-1.822 0.828-3.592 2.652-3.95 5.647-1.112 11.399-2.078 17.097-2.872 1.822-0.266 3.541 1.025 3.797 2.867 0.258 1.84-1.027 3.541-2.867 3.797-5.575 0.777-11.204 1.724-16.729 2.809-0.219 0.045-0.437 0.065-0.653 0.065zm119.35-0.01c-0.214 0-0.432-0.02-0.649-0.063-5.532-1.083-11.163-2.026-16.736-2.801-1.84-0.255-3.125-1.955-2.869-3.795 0.256-1.842 1.955-3.132 3.795-2.869 5.695 0.792 11.448 1.755 17.1 2.86 1.825 0.356 3.013 2.124 2.657 3.948-0.313 1.608-1.721 2.72-3.298 2.72zm-33.966-4.725c-0.094 0-0.187 0-0.282-0.012-5.601-0.468-11.301-0.784-16.944-0.941-1.858-0.051-3.322-1.599-3.27-3.457 0.051-1.857 1.526-3.399 3.457-3.27 5.767 0.159 11.593 0.483 17.316 0.961 1.852 0.154 3.229 1.781 3.074 3.633-0.147 1.757-1.619 3.086-3.351 3.086zm-51.426-0.01c-1.733 0-3.204-1.329-3.35-3.086-0.155-1.853 1.222-3.478 3.074-3.633 5.747-0.478 11.572-0.8 17.313-0.956 1.897-0.041 3.406 1.413 3.455 3.271 0.051 1.858-1.413 3.404-3.271 3.455-5.616 0.154-11.315 0.47-16.938 0.936-0.095 0.01-0.189 0.013-0.283 0.013z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    d: "m3199.5 1461.1c-0.154 0-0.312-0.01-0.468-0.033-1.842-0.256-3.125-1.955-2.869-3.795 0.381-2.744 0.728-5.493 1.035-8.25 0.204-1.847 1.868-3.179 3.717-2.971 1.847 0.205 3.177 1.87 2.97 3.717-0.314 2.816-0.667 5.627-1.058 8.43-0.233 1.685-1.676 2.902-3.327 2.902z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path131",
    d: "m3158.8 1487.4c0.668-1.721 0.172-3.677-1.237-4.871l-40.208-34.046c3.445-24.362 3.031-49.45-1.621-74.339l38.635-35.771c1.356-1.255 1.765-3.231 1.021-4.921l-25.471-57.836c-0.745-1.69-2.48-2.721-4.319-2.569l-52.472 4.354c-15.222-20.235-33.448-37.477-53.748-51.382l2.028-52.648c0.071-1.845-1.037-3.532-2.758-4.201l-58.907-22.885c-1.722-0.669-3.678-0.172-4.871 1.238l-34.046 40.208c-24.362-3.445-49.449-3.03-74.339 1.622l-35.771-38.636c-1.255-1.355-3.23-1.765-4.921-1.021l-57.837 25.472c-1.69 0.744-2.722 2.479-2.569 4.32l4.354 52.472c-20.235 15.222-37.478 33.448-51.382 53.747l-52.649-2.028c-1.844-0.071-3.532 1.037-4.2 2.758l-22.885 58.907c-0.67 1.722-0.172 3.678 1.238 4.871l40.208 34.046c-3.446 24.362-3.031 49.45 1.621 74.339l-38.637 35.771c-1.355 1.255-1.765 3.23-1.021 4.921l25.472 57.837c0.744 1.69 2.479 2.722 4.319 2.568l52.472-4.354c15.221 20.235 33.449 37.478 53.748 51.383l-2.028 52.647c-0.072 1.846 1.037 3.533 2.758 4.202l58.907 22.885c1.721 0.669 3.677 0.172 4.871-1.237l34.046-40.208c24.362 3.446 49.449 3.03 74.339-1.622l35.771 38.636c1.253 1.355 3.23 1.765 4.921 1.02l57.835-25.471c1.69-0.744 2.722-2.479 2.57-4.319l-4.354-52.472c20.234-15.222 37.476-33.448 51.382-53.747l52.647 2.027c1.845 0.071 3.532-1.036 4.202-2.758z",
    fill: "url(#SVGID_00000042738986960506732860000006370903724307866797_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "m2888.7 1475.8c-17.721 0-35.264-7.862-46.977-22.889-9.768-12.53-14.071-28.113-12.117-43.881 1.953-15.768 9.93-29.83 22.461-39.596 12.53-9.768 28.122-14.066 43.88-12.119 15.768 1.953 29.83 9.93 39.598 22.461 20.164 25.867 15.525 63.316-10.343 83.479-10.84 8.45-23.718 12.545-36.502 12.545zm-0.173-112.21c-11.682 0-22.963 3.858-32.323 11.154-11.113 8.662-18.186 21.134-19.92 35.118-1.733 13.984 2.083 27.804 10.745 38.916 17.879 22.938 51.092 27.055 74.035 9.174 22.939-17.882 27.055-51.094 9.173-74.035-8.664-11.113-21.134-18.186-35.117-19.92-2.204-0.272-4.406-0.407-6.593-0.407z",
    fill: "#fff",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "path133",
    d: "m2887.6 1571.8c-59.938 0-117.19-34.753-142.86-93.035-8.866-20.128-13.308-41.445-13.305-62.797 0-19.064 3.552-38.157 10.661-56.462 15.076-38.804 44.361-69.417 82.462-86.195 38.096-16.78 80.449-17.717 119.26-2.642 38.806 15.076 69.418 44.361 86.197 82.46 4.484 10.177 7.88 20.812 10.096 31.608 0.048 0.228 0.069 0.455 0.069 0.679 1e-3 1.564-1.096 2.967-2.688 3.294-1.83 0.38-3.6-0.8-3.973-2.619-2.121-10.33-5.373-20.508-9.662-30.249-16.055-36.455-45.345-64.476-82.475-78.9-37.127-14.424-77.655-13.525-114.11 2.527-36.455 16.055-64.475 45.345-78.9 82.475-6.804 17.513-10.198 35.781-10.201 54.022 0 20.431 4.249 40.827 12.73 60.088 33.144 75.253 121.33 109.51 196.58 76.371 24.742-10.896 46.029-28.258 61.558-50.205 1.073-1.516 3.174-1.875 4.691-0.803 0.927 0.657 1.423 1.696 1.421 2.752 0 0.672-0.2 1.349-0.618 1.939-16.235 22.943-38.482 41.088-64.342 52.476-20.365 8.97-41.645 13.216-62.592 13.216z",
    fill: "#fff",
    opacity: 0.56
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g136",
    fill: "#fff",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "path134",
    d: "m2658.1 1251.6c-0.882 0-1.763-0.345-2.423-1.03-1.29-1.339-1.249-3.468 0.089-4.758 1.995-1.922 3.95-3.874 5.871-5.856 1.295-1.337 3.424-1.365 4.758-0.076 1.334 1.293 1.369 3.424 0.076 4.758-1.973 2.037-3.984 4.045-6.035 6.02-0.653 0.63-1.494 0.942-2.336 0.942z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path135",
    d: "m2485.6 1321.3c-4.546 0-9.165-0.126-13.729-0.376-1.855-0.102-3.278-1.689-3.176-3.544s1.712-3.291 3.544-3.176c5.586 0.307 11.212 0.424 16.788 0.342 1.921-0.033 3.386 1.459 3.412 3.317s-1.459 3.386-3.317 3.413c-1.176 0.016-2.349 0.024-3.522 0.024zm20.471-0.848c-1.733 0-3.204-1.329-3.35-3.085-0.155-1.853 1.222-3.478 3.074-3.633 5.555-0.462 11.164-1.124 16.673-1.967 1.817-0.273 3.554 0.978 3.835 2.816 0.282 1.837-0.979 3.554-2.816 3.835-5.662 0.867-11.427 1.548-17.133 2.022-0.095 0.01-0.191 0.012-0.283 0.012zm-50.96-1.033c-0.138 0-0.278-0.01-0.419-0.026-5.688-0.703-11.419-1.613-17.033-2.699-1.824-0.355-3.017-2.119-2.663-3.945 0.353-1.822 2.115-3.007 3.945-2.663 5.463 1.06 11.041 1.944 16.58 2.63 1.843 0.228 3.155 1.908 2.924 3.753-0.211 1.703-1.662 2.95-3.334 2.95zm84.589-4.116c-1.54 0-2.928-1.063-3.28-2.627-0.407-1.814 0.733-3.613 2.545-4.02 5.442-1.222 10.908-2.649 16.248-4.241 1.773-0.531 3.654 0.483 4.186 2.264 0.531 1.781-0.483 3.656-2.264 4.186-5.488 1.635-11.104 3.1-16.695 4.356-0.247 0.056-0.495 0.082-0.74 0.082zm-117.98-2.354c-0.286 0-0.575-0.038-0.865-0.113-5.53-1.469-11.083-3.146-16.509-4.991-1.76-0.598-2.701-2.509-2.103-4.268 0.598-1.76 2.51-2.703 4.269-2.103 5.281 1.796 10.686 3.429 16.069 4.858 1.797 0.476 2.867 2.318 2.389 4.114-0.399 1.505-1.761 2.503-3.25 2.503zm150.6-7.359c-1.364 0-2.647-0.836-3.151-2.188-0.651-1.74 0.232-3.679 1.973-4.329 5.195-1.942 10.417-4.101 15.52-6.414 1.696-0.771 3.687-0.02 4.454 1.674 0.767 1.692 0.018 3.687-1.674 4.454-5.241 2.377-10.605 4.594-15.944 6.588-0.387 0.146-0.786 0.215-1.178 0.215zm-182.81-3.582c-0.432 0-0.871-0.084-1.295-0.261-5.279-2.205-10.555-4.622-15.681-7.183-1.661-0.831-2.336-2.852-1.505-4.515 0.832-1.658 2.851-2.336 4.515-1.505 4.99 2.494 10.126 4.847 15.263 6.993 1.715 0.716 2.525 2.686 1.809 4.402-0.538 1.29-1.789 2.069-3.106 2.069zm213.8-10.466c-1.199 0-2.361-0.642-2.967-1.773-0.879-1.636-0.264-3.677 1.372-4.556 4.914-2.639 9.796-5.479 14.513-8.442 1.574-0.989 3.651-0.516 4.638 1.06 0.989 1.572 0.514 3.651-1.06 4.638-4.844 3.044-9.86 5.961-14.907 8.672-0.506 0.273-1.052 0.401-1.589 0.401zm-244.22-4.75c-0.58 0-1.168-0.15-1.704-0.465-4.944-2.91-9.842-6.022-14.557-9.25-1.533-1.05-1.926-3.145-0.876-4.677 1.052-1.531 3.146-1.922 4.678-0.876 4.591 3.143 9.357 6.171 14.169 9.004 1.602 0.943 2.136 3.005 1.193 4.607-0.628 1.064-1.75 1.657-2.903 1.657zm273.03-13.349c-1.04 0-2.065-0.48-2.724-1.385-1.093-1.502-0.762-3.606 0.741-4.701 4.505-3.279 8.953-6.759 13.219-10.341 1.425-1.193 3.547-1.007 4.742 0.414 1.195 1.425 1.009 3.547-0.414 4.742-4.387 3.68-8.958 7.255-13.588 10.627-0.596 0.435-1.289 0.644-1.976 0.644zm-301.09-5.862c-0.731 0-1.467-0.237-2.085-0.725-4.495-3.552-8.92-7.305-13.156-11.154-1.375-1.249-1.475-3.378-0.225-4.753 1.25-1.37 3.376-1.475 4.753-0.225 4.119 3.744 8.427 7.397 12.801 10.852 1.457 1.152 1.706 3.268 0.554 4.727-0.664 0.839-1.649 1.278-2.642 1.278zm-25.17-22.874c-0.885 0-1.768-0.347-2.43-1.037-3.965-4.137-7.832-8.461-11.496-12.853-1.19-1.428-0.997-3.549 0.429-4.74 1.425-1.186 3.549-0.997 4.74 0.429 3.564 4.273 7.328 8.483 11.187 12.508 1.285 1.341 1.24 3.472-0.102 4.756-0.652 0.626-1.49 0.937-2.328 0.937zm-21.781-26.116c-1.043 0-2.07-0.483-2.729-1.392-3.348-4.625-6.587-9.439-9.625-14.311-0.984-1.576-0.504-3.652 1.073-4.635 1.574-0.986 3.652-0.506 4.635 1.073 2.959 4.74 6.11 9.426 9.368 13.926 1.089 1.505 0.752 3.61-0.752 4.699-0.596 0.433-1.287 0.64-1.97 0.64zm-18.007-28.849c-1.203 0-2.366-0.646-2.972-1.781-1.737-3.256-3.421-6.587-5.006-9.896-0.89-1.86-1.755-3.723-2.594-5.591-0.762-1.696 0-3.687 1.691-4.448 1.689-0.766 3.685-0.01 4.448 1.691 0.816 1.819 1.661 3.633 2.525 5.442 1.543 3.222 3.184 6.464 4.875 9.635 0.874 1.64 0.255 3.679-1.385 4.553-0.506 0.268-1.048 0.395-1.582 0.395zm-13.959-31.028c-1.367 0-2.652-0.84-3.155-2.197-1.996-5.384-3.826-10.891-5.442-16.373-0.526-1.783 0.493-3.654 2.276-4.178 1.774-0.527 3.654 0.491 4.178 2.276 1.572 5.333 3.355 10.696 5.297 15.936 0.646 1.743-0.243 3.679-1.985 4.324-0.386 0.143-0.78 0.212-1.169 0.212zm-9.622-32.638c-1.543 0-2.934-1.068-3.283-2.637-1.237-5.593-2.295-11.299-3.145-16.962-0.276-1.839 0.991-3.552 2.828-3.827 1.829-0.286 3.551 0.991 3.827 2.828 0.826 5.511 1.856 11.064 3.063 16.505 0.401 1.815-0.744 3.611-2.558 4.014-0.245 0.054-0.49 0.079-0.732 0.079zm-5.045-33.646c-1.737 0-3.21-1.336-3.352-3.097-0.455-5.706-0.718-11.504-0.782-17.232-0.02-1.858 1.469-3.381 3.327-3.403h0.038c1.842 0 3.344 1.482 3.365 3.327 0.061 5.575 0.317 11.217 0.762 16.772 0.148 1.852-1.234 3.473-3.087 3.621-0.091 0.01-0.183 0.012-0.271 0.012z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "m2237 1058.4c-0.066 0-0.132 0-0.199-0.01-1.855-0.109-3.271-1.701-3.165-3.556 0.166-2.838 0.378-5.67 0.639-8.494 0.169-1.85 1.82-3.201 3.657-3.043 1.852 0.169 3.214 1.807 3.043 3.657-0.251 2.752-0.46 5.509-0.619 8.271-0.105 1.79-1.587 3.17-3.356 3.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g139",
    fill: "#fff",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "path137",
    d: "m2322 884.98c-0.94 0-1.875-0.391-2.54-1.155-1.219-1.401-1.073-3.528 0.329-4.748 2.139-1.862 4.314-3.69 6.524-5.486 1.438-1.168 3.561-0.954 4.734 0.491 1.171 1.443 0.951 3.56-0.491 4.733-2.151 1.747-4.267 3.526-6.347 5.338-0.639 0.554-1.426 0.827-2.209 0.827z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    d: "m2734 1081.5h-0.125c-1.857-0.069-3.307-1.628-3.24-3.487 0.108-2.98 0.164-5.966 0.164-8.954 0-2.52-0.04-5.042-0.117-7.566-0.058-1.857 1.401-3.409 3.26-3.467 1.807-0.132 3.409 1.401 3.467 3.26 0.081 2.593 0.12 5.184 0.12 7.773 0 3.071-0.056 6.138-0.168 9.201-0.067 1.816-1.559 3.242-3.361 3.242zm-1.044-33.46c-1.71 0-3.173-1.296-3.345-3.033-0.541-5.458-1.277-10.967-2.187-16.376-0.307-1.834 0.928-3.569 2.76-3.878 1.842-0.31 3.567 0.93 3.877 2.76 0.935 5.558 1.691 11.22 2.246 16.829 0.184 1.85-1.167 3.496-3.016 3.68-0.113 0.014-0.225 0.018-0.335 0.018zm-5.555-33.014c-1.521 0-2.9-1.038-3.27-2.583-1.275-5.336-2.749-10.698-4.38-15.932-0.554-1.773 0.437-3.661 2.211-4.213 1.766-0.552 3.661 0.435 4.213 2.211 1.677 5.378 3.191 10.885 4.502 16.369 0.432 1.807-0.684 3.623-2.491 4.055-0.262 0.063-0.525 0.093-0.785 0.093zm-9.955-31.965c-1.349 0-2.621-0.818-3.138-2.151-1.976-5.107-4.155-10.223-6.477-15.208-0.784-1.684-0.054-3.685 1.631-4.471 1.678-0.782 3.684-0.056 4.471 1.631 2.382 5.118 4.62 10.372 6.651 15.615 0.67 1.733-0.191 3.682-1.922 4.354-0.399 0.157-0.811 0.23-1.216 0.23zm-14.13-30.356c-1.188 0-2.341-0.631-2.952-1.745-2.644-4.816-5.479-9.595-8.428-14.207-1.002-1.564-0.544-3.646 1.022-4.646 1.559-1.004 3.642-0.547 4.646 1.022 3.03 4.737 5.943 9.646 8.659 14.591 0.896 1.63 0.299 3.675-1.329 4.569-0.515 0.283-1.07 0.416-1.618 0.416zm-18.036-28.194c-1.032 0-2.049-0.471-2.709-1.365-3.266-4.42-6.718-8.774-10.26-12.94-1.203-1.416-1.03-3.539 0.386-4.743 1.415-1.201 3.538-1.032 4.743 0.386 3.638 4.282 7.187 8.756 10.543 13.298 1.104 1.493 0.789 3.602-0.707 4.706-0.601 0.445-1.301 0.658-1.996 0.658zm-21.673-25.504c-0.876 0-1.751-0.34-2.412-1.019-3.812-3.915-7.821-7.762-11.913-11.432-1.383-1.24-1.5-3.368-0.26-4.752 1.24-1.383 3.366-1.498 4.751-0.26 4.206 3.771 8.327 7.725 12.245 11.749 1.295 1.332 1.267 3.463-0.066 4.76-0.653 0.637-1.499 0.954-2.345 0.954zm-24.918-22.338c-0.725 0-1.454-0.233-2.07-0.713-4.311-3.368-8.803-6.639-13.351-9.723-1.538-1.043-1.94-3.135-0.897-4.673 1.043-1.536 3.135-1.942 4.673-0.897 4.673 3.168 9.288 6.528 13.719 9.99 1.464 1.143 1.723 3.258 0.58 4.724-0.664 0.848-1.655 1.292-2.654 1.292zm-296.92-7.183c-1.056 0-2.096-0.496-2.752-1.424-1.071-1.52-0.71-3.618 0.808-4.689 4.597-3.243 9.372-6.376 14.192-9.311 1.585-0.969 3.657-0.467 4.623 1.124 0.966 1.587 0.463 3.657-1.124 4.623-4.692 2.857-9.339 5.907-13.811 9.061-0.589 0.417-1.266 0.616-1.936 0.616zm269.21-11.596c-0.577 0-1.16-0.148-1.694-0.458-4.729-2.762-9.62-5.401-14.537-7.845-1.663-0.826-2.341-2.847-1.515-4.512 0.826-1.664 2.843-2.346 4.512-1.515 5.051 2.51 10.076 5.223 14.935 8.059 1.604 0.938 2.146 2.999 1.209 4.604-0.627 1.07-1.754 1.667-2.91 1.667zm-240.63-5.817c-1.216 0-2.387-0.659-2.987-1.811-0.859-1.648-0.219-3.68 1.429-4.538 2.529-1.318 5.09-2.598 7.681-3.84 2.532-1.212 5.072-2.379 7.622-3.5 1.705-0.748 3.69 0.028 4.434 1.727 0.748 1.702-0.026 3.687-1.727 4.434-2.484 1.091-4.958 2.228-7.421 3.408-2.525 1.209-5.018 2.456-7.48 3.738-0.496 0.261-1.028 0.382-1.551 0.382zm210.66-9.08c-0.43 0-0.869-0.084-1.292-0.26-5.052-2.103-10.254-4.066-15.457-5.834-1.76-0.598-2.701-2.509-2.103-4.268 0.598-1.758 2.5-2.701 4.269-2.103 5.345 1.816 10.688 3.831 15.878 5.992 1.715 0.715 2.527 2.685 1.814 4.4-0.54 1.292-1.79 2.073-3.109 2.073zm-180-4.386c-1.377 0-2.668-0.851-3.164-2.221-0.633-1.747 0.271-3.677 2.019-4.31 5.304-1.919 10.735-3.682 16.147-5.238 1.786-0.521 3.651 0.518 4.163 2.303 0.514 1.786-0.518 3.651-2.303 4.163-5.268 1.515-10.555 3.23-15.717 5.1-0.378 0.138-0.764 0.203-1.145 0.203zm148.31-6.379c-0.286 0-0.577-0.038-0.867-0.115-5.303-1.411-10.719-2.663-16.098-3.716-1.824-0.358-3.011-2.126-2.655-3.95 0.358-1.824 2.118-3.013 3.95-2.655 5.525 1.083 11.089 2.368 16.535 3.818 1.796 0.478 2.864 2.322 2.386 4.117-0.402 1.505-1.762 2.501-3.251 2.501zm-116.14-2.872c-1.551 0-2.946-1.078-3.286-2.657-0.391-1.816 0.764-3.606 2.581-3.997 5.509-1.188 11.131-2.2 16.708-3.012 1.847-0.258 3.546 1.007 3.815 2.846 0.266 1.84-1.007 3.547-2.845 3.815-5.428 0.789-10.898 1.775-16.261 2.93-0.239 0.05-0.477 0.075-0.712 0.075zm83.29-3.561c-0.141 0-0.284-8e-3 -0.429-0.026-5.45-0.692-10.985-1.206-16.448-1.528-1.855-0.108-3.271-1.701-3.161-3.555 0.108-1.855 1.715-3.327 3.555-3.161 5.614 0.33 11.301 0.858 16.902 1.568 1.843 0.235 3.148 1.919 2.915 3.762-0.217 1.698-1.665 2.94-3.334 2.94zm-50.162-1.255c-1.741 0-3.217-1.342-3.352-3.109-0.141-1.853 1.245-3.47 3.099-3.611 5.614-0.43 11.32-0.674 16.957-0.723h0.03c1.845 0 3.349 1.487 3.365 3.335 0.016 1.858-1.477 3.378-3.335 3.394-5.486 0.048-11.039 0.286-16.504 0.703-0.088 8e-3 -0.175 0.011-0.26 0.011z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path139",
    d: "m2731.8 1106.6c-0.154 0-0.312-0.01-0.468-0.033-1.842-0.256-3.125-1.955-2.869-3.795 0.38-2.737 0.716-5.481 1.004-8.232 0.194-1.848 1.817-3.184 3.698-2.995 1.848 0.194 3.189 1.85 2.995 3.698-0.297 2.826-0.641 5.645-1.033 8.455-0.233 1.685-1.676 2.902-3.327 2.902z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "m2699.2 1126.9c0.534-1.376 0.137-2.94-0.989-3.894l-32.142-27.216c2.754-19.475 2.423-39.53-1.296-59.427l30.885-28.595c1.084-1.003 1.411-2.583 0.816-3.934l-20.362-46.234c-0.596-1.351-1.982-2.176-3.453-2.054l-41.946 3.481c-12.169-16.176-26.739-29.959-42.966-41.075l1.621-42.086c0.056-1.475-0.829-2.824-2.205-3.358l-47.09-18.294c-1.377-0.535-2.941-0.137-3.894 0.989l-27.216 32.142c-19.475-2.754-39.53-2.422-59.426 1.296l-28.595-30.886c-1.003-1.083-2.583-1.411-3.934-0.816l-46.234 20.362c-1.351 0.595-2.176 1.982-2.054 3.453l3.481 41.946c-16.176 12.168-29.959 26.738-41.074 42.965l-42.087-1.621c-1.474-0.057-2.823 0.829-3.358 2.204l-18.294 47.09c-0.536 1.376-0.137 2.94 0.989 3.894l32.142 27.216c-2.755 19.475-2.423 39.53 1.296 59.427l-30.886 28.595c-1.083 1.003-1.411 2.582-0.816 3.933l20.362 46.235c0.595 1.351 1.982 2.176 3.453 2.053l41.946-3.481c12.168 16.176 26.739 29.959 42.966 41.075l-1.621 42.086c-0.058 1.475 0.829 2.824 2.205 3.359l47.09 18.294c1.376 0.534 2.939 0.137 3.894-0.989l27.216-32.142c19.475 2.754 39.53 2.422 59.427-1.296l28.595 30.886c1.002 1.083 2.582 1.411 3.934 0.815l46.233-20.361c1.351-0.595 2.176-1.981 2.054-3.453l-3.48-41.946c16.175-12.168 29.958-26.739 41.074-42.965l42.086 1.62c1.475 0.057 2.823-0.828 3.359-2.205z",
    fill: "url(#SVGID_00000114788984611675698270000002127776657650069909_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path141",
    d: "m2483.4 1118.4c-14.366 0-28.588-6.373-38.085-18.556-7.919-10.159-11.409-22.795-9.825-35.578s8.052-24.185 18.211-32.103c10.159-7.921 22.797-11.411 35.576-9.825 12.782 1.584 24.185 8.052 32.103 18.211 16.348 20.97 12.587 51.331-8.384 67.68-8.789 6.852-19.232 10.171-29.596 10.171zm-0.137-89.703c-9.189 0-18.062 3.035-25.425 8.774-18.045 14.066-21.282 40.189-7.216 58.236 14.064 18.042 40.191 21.282 58.236 7.216 18.045-14.067 21.28-40.193 7.215-58.236-6.813-8.741-16.624-14.306-27.624-15.669-1.734-0.214-3.466-0.321-5.186-0.321z",
    fill: "#fff",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    d: "m2482.5 1195.1c-48.174 0-94.192-27.933-114.82-74.775-7.211-16.374-10.624-33.476-10.622-50.317 0-48.169 27.936-94.183 74.775-114.81 63.213-27.837 137.29 0.938 165.13 64.153 0.979 2.221 1.893 4.469 2.74 6.74 1.842 4.931 3.372 9.965 4.577 15.053 0.011 0.049 0.023 0.1 0.035 0.149 0.038 0.158 0.074 0.316 0.11 0.473 0.23 0.994 0.447 1.99 0.652 2.987 0.048 0.228 0.069 0.455 0.069 0.679 0 1.564-1.096 2.967-2.688 3.294-1.822 0.381-3.598-0.798-3.973-2.619-1.686-8.207-4.27-16.297-7.681-24.045-21.727-49.331-73.222-76.5-124.15-69.732-10.826 1.438-21.622 4.41-32.107 9.027-44.322 19.52-70.752 63.062-70.756 108.64 0 15.934 3.227 32.119 10.05 47.614 26.345 59.815 96.444 87.044 156.26 60.705 19.668-8.663 36.588-22.463 48.93-39.905 1.073-1.516 3.174-1.875 4.691-0.803 0.927 0.657 1.423 1.697 1.421 2.752 0 0.672-0.2 1.349-0.618 1.939-13.047 18.438-30.93 33.021-51.712 42.176-16.37 7.208-33.472 10.621-50.307 10.621z",
    fill: "#fff",
    opacity: 0.56
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "link-back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path107",
    d: "m71.48 162.62 21.087-19.3 111.15 0.3574 20.729 18.585z",
    fill: "#8080ff",
    stroke: "#8080ff",
    strokeWidth: 0.849
  }), /*#__PURE__*/React.createElement("g", {
    id: "g146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path109",
    d: "m95.783 146.18 104.36-0.3574 15.726 14.296-134.38-0.3574z",
    fill: "#d7e3f4",
    stroke: "#d7e3f4",
    strokeWidth: 0.849
  })), /*#__PURE__*/React.createElement("path", {
    id: "path111",
    d: "m71.48 163.33 153.32-0.3574v4.6462l-153.32 0.3574z",
    fill: "#8080ff",
    stroke: "#8080ff",
    strokeWidth: 0.849
  }), /*#__PURE__*/React.createElement("g", {
    id: "g120",
    strokeWidth: 0.849
  }, /*#__PURE__*/React.createElement("path", {
    id: "path113",
    d: "m77.913 169.05h40.386l-2.5018 36.097h-33.238z",
    fill: "#aaf",
    stroke: "#aaf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g117",
    stroke: "#3737c8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path115",
    d: "m81.845 171.19 32.523-0.3574-0.3574 14.296h-30.022z",
    fill: "#aaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path117",
    d: "m92.567 173.7 12.152-0.3574-1.4296 2.1444h-9.2924z",
    fill: "#3737c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g117-4",
    transform: "matrix(.89172 0 0 1.0034 11.425 17.027)",
    stroke: "#3737c8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path115-7",
    d: "m81.845 171.19 32.523-0.3574-0.3574 14.296h-30.022z",
    fill: "#aaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path117-9",
    d: "m92.567 173.7 12.152-0.3574-1.4296 2.1444h-9.2924z",
    fill: "#3737c8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g120-1",
    transform: "matrix(-1 0 0 1 296.89 -.25181)",
    strokeWidth: 0.849
  }, /*#__PURE__*/React.createElement("path", {
    id: "path113-2",
    d: "m77.913 169.05h40.386l-2.5018 36.097h-33.238z",
    fill: "#aaf",
    stroke: "#aaf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g117-0",
    stroke: "#3737c8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path115-2",
    d: "m81.845 171.19 32.523-0.3574-0.3574 14.296h-30.022z",
    fill: "#aaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path117-3",
    d: "m92.567 173.7 12.152-0.3574-1.4296 2.1444h-9.2924z",
    fill: "#3737c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g117-4-2",
    transform: "matrix(.89172 0 0 1.0034 11.425 17.027)",
    stroke: "#3737c8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path115-7-9",
    d: "m81.845 171.19 32.523-0.3574-0.3574 14.296h-30.022z",
    fill: "#aaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path117-9-2",
    d: "m92.567 173.7 12.152-0.3574-1.4296 2.1444h-9.2924z",
    fill: "#3737c8"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path121",
    d: "m129.74 169.41-2.8592 10.722h-7.8628l0.7148-10.722z",
    fill: "#3737c8",
    stroke: "#3737c8",
    strokeWidth: 0.849
  }), /*#__PURE__*/React.createElement("path", {
    id: "path121-9",
    d: "m167.05 169.35 2.8592 10.722h7.8628l-0.7148-10.722z",
    fill: "#3737c8",
    stroke: "#3737c8",
    strokeWidth: 0.849
  }), /*#__PURE__*/React.createElement("g", {
    id: "text20",
    transform: "matrix(1.6691 0 0 .59913 2.3231 -.80415)",
    fill: "#00222b",
    stroke: "#00222b",
    strokeWidth: 0,
    "aria-label": "vitajte na hodine INFORMATIKY"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path123",
    transform: "translate(.21413 -1.7896)",
    d: "m67.905 248.31-1.6664 5.3633h-1.557l-0.04715-5.3633h1.2318l-0.04678 3.0998 0.87944-3.0998zm1.4028-0.27957h-1.2198l0.11982-0.90198h1.2085zm-0.67944 5.6429h-1.2899l0.71248-5.3633h1.2232zm2.8243 0h-0.8147c-0.58236 0-0.92052-0.0941-1.0142-0.28178-0.09337-0.187-0.11011-0.5446-0.05094-1.0693l0.36683-3.253h-0.5493l0.08983-0.75929h0.54509l0.1144-1.0145h1.2106l-0.10179 1.0145h0.66098l-0.07108 0.75929h-0.66608l-0.32542 3.2435c-0.01621 0.16156 0.01758 0.27114 0.10148 0.32842 0.0873 0.0541 0.28495 0.0812 0.5929 0.0812zm3.286 0h-1.1406l0.01586-0.21875c-0.11086 0.19765-0.39444 0.29676-0.85041 0.29676-0.70359 0-1.0286-0.29514-0.97558-0.88042l0.10021-1.1055c0.02207-0.2435 0.12379-0.45484 0.30475-0.6344 0.18326-0.17892 0.53676-0.40169 1.0589-0.66771 0.30095-0.15226 0.45445-0.27373 0.46117-0.36464l0.0573-0.77509c0.01254-0.16962-0.05185-0.25421-0.19314-0.25421-0.16147 0-0.25843 0.20654-0.29106 0.62223-0.0059 0.0751-0.01029 0.18653-0.01316 0.33446 3.5e-5 0.14835-0.0029 0.26067-0.0089 0.3367h-1.205l0.09454-1.0481c0.06274-0.6955 0.58004-1.0396 1.5526-1.0396 0.90959 0 1.3423 0.3588 1.2977 1.0843zm-1.2126-1.0464 0.10407-1.4078c-0.29442 0.0744-0.44956 0.21096-0.46515 0.4103l-0.078 0.99745c-0.01321 0.16896 0.05652 0.25364 0.20923 0.25364 0.14073 0 0.21736-0.0847 0.22985-0.25364zm3.096-4.5964h-1.2198l0.05255-0.90198h1.2085zm-2.3518 6.8553 0.05422-0.83102c0.33919 0 0.54621-0.018 0.62102-0.054 0.07475-0.0359 0.11762-0.1485 0.12861-0.33716l0.31189-5.3536h1.2232l-0.25178 5.495c-0.0329 0.71797-0.40363 1.0807-1.1119 1.0807zm4.9764-1.2124h-0.8147c-0.58236 0-0.92759-0.0941-1.0354-0.28178-0.10742-0.187-0.15104-0.5446-0.1313-1.0693l0.12236-3.253h-0.5493l0.03277-0.75929h0.54509l0.03816-1.0145h1.2106l-0.02554 1.0145h0.66098l-0.01401 0.75929h-0.66608l-0.08166 3.2435c-0.0041 0.16156 0.03796 0.27114 0.12616 0.32842 0.09137 0.0541 0.29106 0.0812 0.599 0.0812zm3.2318-2.3426h-1.6943l-0.0042 1.2771c-6.14e-4 0.18804 0.07394 0.28231 0.22368 0.28231 0.14674 0 0.22-0.0943 0.21981-0.28231l-0.0012-1.1046h1.2585l0.01498 1.1142c0.01013 0.75323-0.49055 1.134-1.5021 1.134-1.0025 0-1.4976-0.39691-1.4853-1.1817l0.05028-3.2103c0.01136-0.72552 0.4918-1.0843 1.4414-1.0843 0.95822 0 1.442 0.3441 1.4513 1.0396zm-1.2572-0.80336-0.0013-1.2038c-1.78e-4 -0.16962-0.07091-0.25421-0.2122-0.25421-0.14417 0-0.21654 0.0846-0.21709 0.25421l-0.0039 1.2038zm6.2494 3.146h-1.2899l-0.21245-4.3498c-0.0077-0.15773-0.08221-0.23642-0.22352-0.23642-0.14132 0-0.2086 0.0757-0.20184 0.22749l0.19424 4.3587h-1.2899l-0.1723-5.3633h1.2232l0.0076 0.17114c0.15702-0.13754 0.40556-0.20617 0.74594-0.20617 0.22025 0 0.4268 0.0613 0.62002 0.1842 0.1937 0.12318 0.29804 0.30411 0.31271 0.54343zm3.3222 0h-1.1406l-0.01801-0.21875c-0.08027 0.19765-0.3485 0.29676-0.80448 0.29676-0.70359 0-1.0743-0.29514-1.1119-0.88042l-0.07093-1.1055c-0.01562-0.2435 0.05338-0.45484 0.20655-0.6344 0.15556-0.17892 0.47458-0.40169 0.95554-0.66771 0.27738-0.15226 0.41208-0.27373 0.40473-0.36464l-0.06269-0.77509c-0.01372-0.16962-0.09121-0.25421-0.2325-0.25421-0.16147 0-0.22645 0.20654-0.19474 0.62223 0.0057 0.0751 0.01859 0.18653 0.03861 0.33446 0.023 0.14835 0.03744 0.26067 0.04326 0.3367h-1.205l-0.0677-1.0481c-0.04493-0.6955 0.4191-1.0396 1.3916-1.0396 0.90959 0 1.3979 0.3588 1.4656 1.0843zm-1.3746-1.0464-0.11385-1.4078c-0.28291 0.0744-0.41691 0.21096-0.40164 0.4103l0.0764 0.99745c0.01294 0.16896 0.09578 0.25364 0.2485 0.25364 0.14074 0 0.20425-0.0847 0.19059-0.25364zm6.3533 1.0464h-1.2854l-0.56311-4.3677c-0.02033-0.15768-0.10112-0.23633-0.2424-0.23633-0.14417 0-0.20683 0.0757-0.18792 0.2274l0.54535 4.3766h-1.2854l-0.73441-6.5448h1.2043l0.16636 1.3351c0.1303-0.12581 0.37552-0.18859 0.73592-0.18859 0.24027 0 0.45644 0.0642 0.64889 0.19298 0.19295 0.12908 0.30481 0.30123 0.33528 0.51689zm0.10822-1.1037-0.46195-3.2103c-0.1044-0.72552 0.3288-1.0843 1.2985-1.0843 0.37471 0 0.71745 0.0832 1.029 0.25015 0.31551 0.16748 0.5046 0.43012 0.56679 0.78945l0.57168 3.3027c0.13038 0.75323-0.30196 1.134-1.2985 1.134-1.0237 0-1.5926-0.39691-1.7056-1.1817zm1.7257 0.0381-0.52763-3.2843c-0.02725-0.16962-0.11149-0.25421-0.25278-0.25421-0.14417 0-0.20303 0.0846-0.17652 0.25421l0.51344 3.2843c0.0294 0.18804 0.119 0.28231 0.26873 0.28231 0.14674 0 0.20496-0.0943 0.17475-0.28231zm4.738 1.0655h-0.97311l-0.14547-0.18964c-0.18562 0.17828-0.41908 0.26765-0.69991 0.26765-0.32915 0-0.62499-0.0829-0.8869-0.24823-0.25807-0.16483-0.41165-0.3886-0.46116-0.67055l-0.67558-3.8477c-0.03838-0.21861 0.01748-0.39074 0.16718-0.51689 0.15166-0.12874 0.35033-0.19298 0.59632-0.19298 0.33753 0 0.60121 0.0628 0.7914 0.1886l-0.25673-1.3351h1.2043zm-1.4866-1.0464-0.64038-3.3302c-0.0292-0.15172-0.11438-0.2274-0.25567-0.2274-0.14417 0-0.20147 0.0787-0.17183 0.23633l0.62431 3.3212c0.0318 0.16896 0.12253 0.25364 0.27225 0.25364 0.14673 0 0.20381-0.0847 0.17132-0.25364zm1.7996-4.5964h-1.2198l-0.18691-0.90197h1.2085zm1.2395 5.6429h-1.29l-1.1114-5.3633h1.2232zm3.2905 0h-1.29l-1.0394-4.3498c-0.0377-0.15773-0.12714-0.23641-0.26846-0.23641s-0.19421 0.0757-0.15859 0.22748l1.0229 4.3587h-1.29l-1.1919-5.3633h1.2232l0.0402 0.17115c0.13088-0.13755 0.36638-0.20618 0.70676-0.20618 0.22025 0 0.43846 0.0613 0.65504 0.1842 0.21712 0.12318 0.35585 0.30412 0.41602 0.54344zm2.6361-2.3426h-1.6943l0.34033 1.2771c0.0501 0.18804 0.1501 0.28231 0.29983 0.28231 0.14674 0 0.19457-0.0943 0.14365-0.28231l-0.29914-1.1046h1.2585l0.31554 1.1142c0.21331 0.75322-0.18465 1.134-1.1962 1.134-1.0025 0-1.6046-0.39692-1.8041-1.1817l-0.81573-3.2103c-0.18435-0.72552 0.1993-1.0843 1.1489-1.0843 0.95821 0 1.5348 0.34411 1.7317 1.0396zm-1.4739-0.80336-0.326-1.2038c-0.0459-0.16962-0.13949-0.25421-0.28078-0.25421-0.14417 0-0.19371 0.0846-0.14851 0.25421l0.3208 1.2038z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path143",
    transform: "translate(.10706 -1.7896)",
    d: "m63.233 259.6c0.02552-0.11453 0.13503-0.21344 0.32833-0.2968 0.19298-0.0832 0.4181-0.12479 0.6756-0.12479 0.2706 0 0.48671 0.0416 0.64854 0.12479 0.1621 0.0834 0.2316 0.18227 0.20825 0.2968-0.0225 0.11039-0.13149 0.2033-0.32715 0.27865-0.19156 0.0755-0.42607 0.11323-0.70332 0.11323-0.27285 0-0.48732-0.0356-0.64324-0.10658-0.15032-0.0754-0.21259-0.17049-0.18701-0.2853zm-2.8674 10.646 1.3862-0.58192 1.68-8.8043-0.95274-0.49295h3.0547l-1.2163 0.49295-2.2758 8.8043 1.1293 0.58192zm2.9439 0 1.0349-0.64619 1.9147-9.9732-0.60011-0.48739h1.5379l0.14332 9.822 2.1471-9.822h0.99471l-0.84666 0.51388-1.5753 9.9949 0.71458 0.598h-1.778l-0.15323-9.758-2.3826 9.758zm5.64 0 1.0015-0.64619 1.3985-9.9732-0.62533-0.48739h4.0836l-1.2079 2.4796 0.25574-2.2234h-1.6272l-0.9457 4.8319h1.0877l0.86046-1.4657-0.3957 3.3716-0.533-1.5785h-1.0912l-1.1101 5.6912zm6.2418-5.8588c-0.20006 2.0731-0.24885 3.5393-0.13902 4.3444 0.11632 0.81738 0.41014 1.2308 0.88013 1.2308s0.83103-0.40802 1.0803-1.2149c0.2456-0.79498 0.44584-2.2669 0.59873-4.3602 0.14692-2.0117 0.15665-3.3324 0.03469-4.0136-0.1203-0.67191-0.39193-1.0045-0.81612-1.0045s-0.75478 0.33697-0.99424 1.0179c-0.23835 0.69042-0.45217 2.0071-0.6445 4.0001zm-0.87567 0c0.17831-1.6983 0.50112-3.0089 0.96607-3.9598 0.46058-0.93298 0.98399-1.3929 1.5767-1.3929 0.5927 0 1.036 0.45994 1.334 1.3929 0.30374 0.95088 0.40435 2.2615 0.29473 3.9598-0.11335 1.7561-0.40292 3.1954-0.87294 4.2892-0.47979 1.1165-1.0541 1.6836-1.7155 1.6836-0.66136 0-1.1423-0.56434-1.4381-1.6757-0.28459-1.094-0.32988-2.5359-0.14496-4.297zm5.9522 0.84351c0.01854 0 0.04623 2e-3 0.08309 7e-3s0.06456 7e-3 0.0831 7e-3c0.60718 0 1.1071-0.31465 1.4962-0.93827 0.3846-0.62095 0.58824-1.435 0.61402-2.4328 0.02094-0.81059-0.10689-1.4246-0.38145-1.849-0.26784-0.42082-0.66555-0.62988-1.1948-0.62988h-0.07873zm-1.6998 5.0153 0.94443-0.64619 0.51836-9.9732-0.66835-0.48739h1.4986c0.71986 0 1.2942 0.26725 1.7264 0.80615 0.43703 0.54485 0.64875 1.2709 0.6313 2.1859-0.01472 0.77152-0.21247 1.4546-0.59638 2.0453-0.38362 0.59272-0.90008 1.0048-1.5482 1.2319l1.5704 4.063 0.89296 0.77451h-2.2516l1.0492-0.83856-2.0956-3.8727-0.52032 4.7112zm5.0716 0 0.92885-0.64619 0.05293-9.9732-0.6911-0.48739h1.6622l1.0495 5.1172 1.8823-5.1172h0.92273l-0.70201 0.48739 0.36692 10.021 0.82344 0.598h-1.7415l0.2466-9.6906-1.7069 6.1148-1.3424-6.9375-0.58564 10.513zm9.6975-5.1851-1.1829-3.71-0.12878 3.71zm2.6318 5.1851h-2.1642l0.91092-0.82256-1.285-4.0595h-1.413l-0.16584 4.882h-1.7634l0.83181-0.66225 1.3107-10.589 2.7681 10.444zm3.4893-7.2087-1.2322-3.6286h-1.1024l1.4645 10.159 1.0388 0.6783h-2.7763l0.89585-0.63013-0.86567-10.207h-1.1287l-0.3359 3.6286-0.39344-3.8981h3.8872zm-0.04948-3.4372c-0.01662-0.11453 0.05651-0.21344 0.21915-0.2968 0.16236-0.0832 0.3722-0.12479 0.62971-0.12479 0.2706 0 0.50199 0.0416 0.69444 0.12479 0.19276 0.0834 0.29864 0.18227 0.31743 0.2968 0.0181 0.11039-0.0567 0.2033-0.22465 0.27865-0.1638 0.0755-0.38442 0.11323-0.66166 0.11323-0.27286 0-0.50041-0.0356-0.68246-0.10658-0.17804-0.0754-0.2753-0.17049-0.29195-0.2853zm1.0488 10.646 1.1721-0.58192-1.5587-8.8043-1.1341-0.49295h3.0547l-1.0349 0.49295 0.96295 8.8043 1.3434 0.58192zm2.9439 0 0.79719-0.64619-1.7541-9.9732-0.77941-0.48739h1.5379l0.52434 4.3608 1.3233-3.7674-0.9249-0.59342h1.9567l-0.66311 0.59342-1.1882 3.3188 3.2625 6.404 1.1033 0.79053h-2.1933l0.7981-0.83856-3.4078-5.39 0.75886 6.2286zm7.6371-10.851-0.57556 0.56986-0.54358 5.2801 1.5272 4.4025 0.99767 0.598h-2.7325l0.75656-0.598-0.81314-4.4025-2.6652-5.4664-0.973-0.63987h1.996l-0.7278 0.69302 2.5304 4.0842 0.3264-3.8376-1.0455-0.6833z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBkgInfo);
export default __webpack_public_path__ + "static/media/bkg-info.4489210c34d19911449e79c80163b1b7.svg";
export { ForwardRef as ReactComponent };